import { jsx as p, jsxs as R, Fragment as Jr } from "react/jsx-runtime";
import * as S from "react";
import O, { createContext as Na, useContext as Oa, useCallback as hn, useState as xe, useRef as bt, useEffect as Ie, useMemo as mn, createElement as Yr, forwardRef as kt, useImperativeHandle as Qr } from "react";
import "react-dom";
import { D as ro, c as Xr, o as pn, s as ei } from "./stay-request-C1YB0ytB.js";
import { h as iE, j as lE, i as sE, a as cE, b as uE, g as dE, d as _E, k as gE, f as fE, e as bE, l as hE, n as mE, m as pE, p as yE, u as vE } from "./stay-request-C1YB0ytB.js";
var $t = (e) => e.type === "checkbox", Ue = (e) => e instanceof Date, de = (e) => e == null;
const yn = (e) => typeof e == "object";
var te = (e) => !de(e) && !Array.isArray(e) && yn(e) && !Ue(e), vn = (e) => te(e) && e.target ? $t(e.target) ? e.target.checked : e.target.value : e, ti = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, kn = (e, t) => e.has(ti(t)), ai = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return te(t) && t.hasOwnProperty("isPrototypeOf");
}, Ia = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ie(e) {
  let t;
  const a = Array.isArray(e), o = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (!(Ia && (e instanceof Blob || o)) && (a || te(e)))
    if (t = a ? [] : Object.create(Object.getPrototypeOf(e)), !a && !ai(e))
      t = e;
    else
      for (const n in e)
        e.hasOwnProperty(n) && (t[n] = ie(e[n]));
  else
    return e;
  return t;
}
var Jt = (e) => /^\w*$/.test(e), ee = (e) => e === void 0, ja = (e) => Array.isArray(e) ? e.filter(Boolean) : [], La = (e) => ja(e.replace(/["|']|\]/g, "").split(/\.|\[/)), C = (e, t, a) => {
  if (!t || !te(e))
    return a;
  const o = (Jt(t) ? [t] : La(t)).reduce((n, r) => de(n) ? n : n[r], e);
  return ee(o) || o === e ? ee(e[t]) ? a : e[t] : o;
}, me = (e) => typeof e == "boolean", G = (e, t, a) => {
  let o = -1;
  const n = Jt(t) ? [t] : La(t), r = n.length, i = r - 1;
  for (; ++o < r; ) {
    const l = n[o];
    let c = a;
    if (o !== i) {
      const s = e[l];
      c = te(s) || Array.isArray(s) ? s : isNaN(+n[o + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const Et = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, $e = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Pe = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, $n = O.createContext(null);
$n.displayName = "HookFormContext";
const Ea = () => O.useContext($n);
var wn = (e, t, a, o = !0) => {
  const n = {
    defaultValues: t._defaultValues
  };
  for (const r in e)
    Object.defineProperty(n, r, {
      get: () => {
        const i = r;
        return t._proxyFormState[i] !== $e.all && (t._proxyFormState[i] = !o || $e.all), a && (a[i] = !0), e[i];
      }
    });
  return n;
};
const Ba = typeof window < "u" ? O.useLayoutEffect : O.useEffect;
function oi(e) {
  const t = Ea(), { control: a = t.control, disabled: o, name: n, exact: r } = e || {}, [i, l] = O.useState(a._formState), c = O.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return Ba(() => a._subscribe({
    name: n,
    formState: c.current,
    exact: r,
    callback: (s) => {
      !o && l({
        ...a._formState,
        ...s
      });
    }
  }), [n, o, r]), O.useEffect(() => {
    c.current.isValid && a._setValid(!0);
  }, [a]), O.useMemo(() => wn(i, a, c.current, !1), [i, a]);
}
var Ce = (e) => typeof e == "string", xn = (e, t, a, o, n) => Ce(e) ? (o && t.watch.add(e), C(a, e, n)) : Array.isArray(e) ? e.map((r) => (o && t.watch.add(r), C(a, r))) : (o && (t.watchAll = !0), a), pa = (e) => de(e) || !yn(e);
function Oe(e, t, a = /* @__PURE__ */ new WeakSet()) {
  if (pa(e) || pa(t))
    return e === t;
  if (Ue(e) && Ue(t))
    return e.getTime() === t.getTime();
  const o = Object.keys(e), n = Object.keys(t);
  if (o.length !== n.length)
    return !1;
  if (a.has(e) || a.has(t))
    return !0;
  a.add(e), a.add(t);
  for (const r of o) {
    const i = e[r];
    if (!n.includes(r))
      return !1;
    if (r !== "ref") {
      const l = t[r];
      if (Ue(i) && Ue(l) || te(i) && te(l) || Array.isArray(i) && Array.isArray(l) ? !Oe(i, l, a) : i !== l)
        return !1;
    }
  }
  return !0;
}
function ni(e) {
  const t = Ea(), { control: a = t.control, name: o, defaultValue: n, disabled: r, exact: i, compute: l } = e || {}, c = O.useRef(n), s = O.useRef(l), u = O.useRef(void 0);
  s.current = l;
  const d = O.useMemo(() => a._getWatch(o, c.current), [a, o]), [g, b] = O.useState(s.current ? s.current(d) : d);
  return Ba(() => a._subscribe({
    name: o,
    formState: {
      values: !0
    },
    exact: i,
    callback: (h) => {
      if (!r) {
        const k = xn(o, a._names, h.values || a._formValues, !1, c.current);
        if (s.current) {
          const v = s.current(k);
          Oe(v, u.current) || (b(v), u.current = v);
        } else
          b(k);
      }
    }
  }), [a, r, o, i]), O.useEffect(() => a._removeUnmounted()), g;
}
function ri(e) {
  const t = Ea(), { name: a, disabled: o, control: n = t.control, shouldUnregister: r, defaultValue: i } = e, l = kn(n._names.array, a), c = O.useMemo(() => C(n._formValues, a, C(n._defaultValues, a, i)), [n, a, i]), s = ni({
    control: n,
    name: a,
    defaultValue: c,
    exact: !0
  }), u = oi({
    control: n,
    name: a,
    exact: !0
  }), d = O.useRef(e), g = O.useRef(n.register(a, {
    ...e.rules,
    value: s,
    ...me(e.disabled) ? { disabled: e.disabled } : {}
  }));
  d.current = e;
  const b = O.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!C(u.errors, a)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!C(u.dirtyFields, a)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!C(u.touchedFields, a)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!C(u.validatingFields, a)
    },
    error: {
      enumerable: !0,
      get: () => C(u.errors, a)
    }
  }), [u, a]), h = O.useCallback((y) => g.current.onChange({
    target: {
      value: vn(y),
      name: a
    },
    type: Et.CHANGE
  }), [a]), k = O.useCallback(() => g.current.onBlur({
    target: {
      value: C(n._formValues, a),
      name: a
    },
    type: Et.BLUR
  }), [a, n._formValues]), v = O.useCallback((y) => {
    const M = C(n._fields, a);
    M && y && (M._f.ref = {
      focus: () => y.focus && y.focus(),
      select: () => y.select && y.select(),
      setCustomValidity: (A) => y.setCustomValidity(A),
      reportValidity: () => y.reportValidity()
    });
  }, [n._fields, a]), P = O.useMemo(() => ({
    name: a,
    value: s,
    ...me(o) || u.disabled ? { disabled: u.disabled || o } : {},
    onChange: h,
    onBlur: k,
    ref: v
  }), [a, o, u.disabled, h, k, v, s]);
  return O.useEffect(() => {
    const y = n._options.shouldUnregister || r;
    n.register(a, {
      ...d.current.rules,
      ...me(d.current.disabled) ? { disabled: d.current.disabled } : {}
    });
    const M = (A, N) => {
      const F = C(n._fields, A);
      F && F._f && (F._f.mount = N);
    };
    if (M(a, !0), y) {
      const A = ie(C(n._options.defaultValues, a));
      G(n._defaultValues, a, A), ee(C(n._formValues, a)) && G(n._formValues, a, A);
    }
    return !l && n.register(a), () => {
      (l ? y && !n._state.action : y) ? n.unregister(a) : M(a, !1);
    };
  }, [a, n, l, r]), O.useEffect(() => {
    n._setDisabledField({
      disabled: o,
      name: a
    });
  }, [o, a, n]), O.useMemo(() => ({
    field: P,
    formState: u,
    fieldState: b
  }), [P, u, b]);
}
const io = (e) => e.render(ri(e));
var Ta = (e, t, a, o, n) => t ? {
  ...a[e],
  types: {
    ...a[e] && a[e].types ? a[e].types : {},
    [o]: n || !0
  }
} : {}, dt = (e) => Array.isArray(e) ? e : [e], lo = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ge = (e) => te(e) && !Object.keys(e).length, Ra = (e) => e.type === "file", we = (e) => typeof e == "function", Bt = (e) => {
  if (!Ia)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Cn = (e) => e.type === "select-multiple", Fa = (e) => e.type === "radio", ii = (e) => Fa(e) || $t(e), _a = (e) => Bt(e) && e.isConnected;
function li(e, t) {
  const a = t.slice(0, -1).length;
  let o = 0;
  for (; o < a; )
    e = ee(e) ? o++ : e[t[o++]];
  return e;
}
function si(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !ee(e[t]))
      return !1;
  return !0;
}
function re(e, t) {
  const a = Array.isArray(t) ? t : Jt(t) ? [t] : La(t), o = a.length === 1 ? e : li(e, a), n = a.length - 1, r = a[n];
  return o && delete o[r], n !== 0 && (te(o) && ge(o) || Array.isArray(o) && si(o)) && re(e, a.slice(0, -1)), e;
}
var Sn = (e) => {
  for (const t in e)
    if (we(e[t]))
      return !0;
  return !1;
};
function Tt(e, t = {}) {
  const a = Array.isArray(e);
  if (te(e) || a)
    for (const o in e)
      Array.isArray(e[o]) || te(e[o]) && !Sn(e[o]) ? (t[o] = Array.isArray(e[o]) ? [] : {}, Tt(e[o], t[o])) : de(e[o]) || (t[o] = !0);
  return t;
}
function zn(e, t, a) {
  const o = Array.isArray(e);
  if (te(e) || o)
    for (const n in e)
      Array.isArray(e[n]) || te(e[n]) && !Sn(e[n]) ? ee(t) || pa(a[n]) ? a[n] = Array.isArray(e[n]) ? Tt(e[n], []) : { ...Tt(e[n]) } : zn(e[n], de(t) ? {} : t[n], a[n]) : a[n] = !Oe(e[n], t[n]);
  return a;
}
var lt = (e, t) => zn(e, t, Tt(t));
const so = {
  value: !1,
  isValid: !1
}, co = { value: !0, isValid: !0 };
var An = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((a) => a && a.checked && !a.disabled).map((a) => a.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ee(e[0].attributes.value) ? ee(e[0].value) || e[0].value === "" ? co : { value: e[0].value, isValid: !0 } : co
    ) : so;
  }
  return so;
}, Pn = (e, { valueAsNumber: t, valueAsDate: a, setValueAs: o }) => ee(e) ? e : t ? e === "" ? NaN : e && +e : a && Ce(e) ? new Date(e) : o ? o(e) : e;
const uo = {
  isValid: !1,
  value: null
};
var Mn = (e) => Array.isArray(e) ? e.reduce((t, a) => a && a.checked && !a.disabled ? {
  isValid: !0,
  value: a.value
} : t, uo) : uo;
function _o(e) {
  const t = e.ref;
  return Ra(t) ? t.files : Fa(t) ? Mn(e.refs).value : Cn(t) ? [...t.selectedOptions].map(({ value: a }) => a) : $t(t) ? An(e.refs).value : Pn(ee(t.value) ? e.ref.value : t.value, e);
}
var ci = (e, t, a, o) => {
  const n = {};
  for (const r of e) {
    const i = C(t, r);
    i && G(n, r, i._f);
  }
  return {
    criteriaMode: a,
    names: [...e],
    fields: n,
    shouldUseNativeValidation: o
  };
}, Rt = (e) => e instanceof RegExp, st = (e) => ee(e) ? e : Rt(e) ? e.source : te(e) ? Rt(e.value) ? e.value.source : e.value : e, go = (e) => ({
  isOnSubmit: !e || e === $e.onSubmit,
  isOnBlur: e === $e.onBlur,
  isOnChange: e === $e.onChange,
  isOnAll: e === $e.all,
  isOnTouch: e === $e.onTouched
});
const fo = "AsyncFunction";
var ui = (e) => !!e && !!e.validate && !!(we(e.validate) && e.validate.constructor.name === fo || te(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === fo)), di = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), bo = (e, t, a) => !a && (t.watchAll || t.watch.has(e) || [...t.watch].some((o) => e.startsWith(o) && /^\.\w+/.test(e.slice(o.length))));
const _t = (e, t, a, o) => {
  for (const n of a || Object.keys(e)) {
    const r = C(e, n);
    if (r) {
      const { _f: i, ...l } = r;
      if (i) {
        if (i.refs && i.refs[0] && t(i.refs[0], n) && !o)
          return !0;
        if (i.ref && t(i.ref, i.name) && !o)
          return !0;
        if (_t(l, t))
          break;
      } else if (te(l) && _t(l, t))
        break;
    }
  }
};
function ho(e, t, a) {
  const o = C(e, a);
  if (o || Jt(a))
    return {
      error: o,
      name: a
    };
  const n = a.split(".");
  for (; n.length; ) {
    const r = n.join("."), i = C(t, r), l = C(e, r);
    if (i && !Array.isArray(i) && a !== r)
      return { name: a };
    if (l && l.type)
      return {
        name: r,
        error: l
      };
    if (l && l.root && l.root.type)
      return {
        name: `${r}.root`,
        error: l.root
      };
    n.pop();
  }
  return {
    name: a
  };
}
var _i = (e, t, a, o) => {
  a(e);
  const { name: n, ...r } = e;
  return ge(r) || Object.keys(r).length >= Object.keys(t).length || Object.keys(r).find((i) => t[i] === (!o || $e.all));
}, gi = (e, t, a) => !e || !t || e === t || dt(e).some((o) => o && (a ? o === t : o.startsWith(t) || t.startsWith(o))), fi = (e, t, a, o, n) => n.isOnAll ? !1 : !a && n.isOnTouch ? !(t || e) : (a ? o.isOnBlur : n.isOnBlur) ? !e : (a ? o.isOnChange : n.isOnChange) ? e : !0, bi = (e, t) => !ja(C(e, t)).length && re(e, t), hi = (e, t, a) => {
  const o = dt(C(e, a));
  return G(o, "root", t[a]), G(e, a, o), e;
}, jt = (e) => Ce(e);
function mo(e, t, a = "validate") {
  if (jt(e) || Array.isArray(e) && e.every(jt) || me(e) && !e)
    return {
      type: a,
      message: jt(e) ? e : "",
      ref: t
    };
}
var Ye = (e) => te(e) && !Rt(e) ? e : {
  value: e,
  message: ""
}, po = async (e, t, a, o, n, r) => {
  const { ref: i, refs: l, required: c, maxLength: s, minLength: u, min: d, max: g, pattern: b, validate: h, name: k, valueAsNumber: v, mount: P } = e._f, y = C(a, k);
  if (!P || t.has(k))
    return {};
  const M = l ? l[0] : i, A = (B) => {
    n && M.reportValidity && (M.setCustomValidity(me(B) ? "" : B || ""), M.reportValidity());
  }, N = {}, F = Fa(i), U = $t(i), ae = F || U, Q = (v || Ra(i)) && ee(i.value) && ee(y) || Bt(i) && i.value === "" || y === "" || Array.isArray(y) && !y.length, X = Ta.bind(null, k, o, N), ce = (B, E, T, Z = Pe.maxLength, q = Pe.minLength) => {
    const oe = B ? E : T;
    N[k] = {
      type: B ? Z : q,
      message: oe,
      ref: i,
      ...X(B ? Z : q, oe)
    };
  };
  if (r ? !Array.isArray(y) || !y.length : c && (!ae && (Q || de(y)) || me(y) && !y || U && !An(l).isValid || F && !Mn(l).isValid)) {
    const { value: B, message: E } = jt(c) ? { value: !!c, message: c } : Ye(c);
    if (B && (N[k] = {
      type: Pe.required,
      message: E,
      ref: M,
      ...X(Pe.required, E)
    }, !o))
      return A(E), N;
  }
  if (!Q && (!de(d) || !de(g))) {
    let B, E;
    const T = Ye(g), Z = Ye(d);
    if (!de(y) && !isNaN(y)) {
      const q = i.valueAsNumber || y && +y;
      de(T.value) || (B = q > T.value), de(Z.value) || (E = q < Z.value);
    } else {
      const q = i.valueAsDate || new Date(y), oe = (Ve) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Ve), ve = i.type == "time", ke = i.type == "week";
      Ce(T.value) && y && (B = ve ? oe(y) > oe(T.value) : ke ? y > T.value : q > new Date(T.value)), Ce(Z.value) && y && (E = ve ? oe(y) < oe(Z.value) : ke ? y < Z.value : q < new Date(Z.value));
    }
    if ((B || E) && (ce(!!B, T.message, Z.message, Pe.max, Pe.min), !o))
      return A(N[k].message), N;
  }
  if ((s || u) && !Q && (Ce(y) || r && Array.isArray(y))) {
    const B = Ye(s), E = Ye(u), T = !de(B.value) && y.length > +B.value, Z = !de(E.value) && y.length < +E.value;
    if ((T || Z) && (ce(T, B.message, E.message), !o))
      return A(N[k].message), N;
  }
  if (b && !Q && Ce(y)) {
    const { value: B, message: E } = Ye(b);
    if (Rt(B) && !y.match(B) && (N[k] = {
      type: Pe.pattern,
      message: E,
      ref: i,
      ...X(Pe.pattern, E)
    }, !o))
      return A(E), N;
  }
  if (h) {
    if (we(h)) {
      const B = await h(y, a), E = mo(B, M);
      if (E && (N[k] = {
        ...E,
        ...X(Pe.validate, E.message)
      }, !o))
        return A(E.message), N;
    } else if (te(h)) {
      let B = {};
      for (const E in h) {
        if (!ge(B) && !o)
          break;
        const T = mo(await h[E](y, a), M, E);
        T && (B = {
          ...T,
          ...X(E, T.message)
        }, A(T.message), o && (N[k] = B));
      }
      if (!ge(B) && (N[k] = {
        ref: M,
        ...B
      }, !o))
        return N;
    }
  }
  return A(!0), N;
};
const mi = {
  mode: $e.onSubmit,
  reValidateMode: $e.onChange,
  shouldFocusError: !0
};
function pi(e = {}) {
  let t = {
    ...mi,
    ...e
  }, a = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: we(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, o = {}, n = te(t.defaultValues) || te(t.values) ? ie(t.defaultValues || t.values) || {} : {}, r = t.shouldUnregister ? {} : ie(n), i = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, s = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let d = {
    ...u
  };
  const g = {
    array: lo(),
    state: lo()
  }, b = t.criteriaMode === $e.all, h = (_) => (f) => {
    clearTimeout(s), s = setTimeout(_, f);
  }, k = async (_) => {
    if (!t.disabled && (u.isValid || d.isValid || _)) {
      const f = t.resolver ? ge((await U()).errors) : await Q(o, !0);
      f !== a.isValid && g.state.next({
        isValid: f
      });
    }
  }, v = (_, f) => {
    !t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((_ || Array.from(l.mount)).forEach((m) => {
      m && (f ? G(a.validatingFields, m, f) : re(a.validatingFields, m));
    }), g.state.next({
      validatingFields: a.validatingFields,
      isValidating: !ge(a.validatingFields)
    }));
  }, P = (_, f = [], m, z, x = !0, w = !0) => {
    if (z && m && !t.disabled) {
      if (i.action = !0, w && Array.isArray(C(o, _))) {
        const D = m(C(o, _), z.argA, z.argB);
        x && G(o, _, D);
      }
      if (w && Array.isArray(C(a.errors, _))) {
        const D = m(C(a.errors, _), z.argA, z.argB);
        x && G(a.errors, _, D), bi(a.errors, _);
      }
      if ((u.touchedFields || d.touchedFields) && w && Array.isArray(C(a.touchedFields, _))) {
        const D = m(C(a.touchedFields, _), z.argA, z.argB);
        x && G(a.touchedFields, _, D);
      }
      (u.dirtyFields || d.dirtyFields) && (a.dirtyFields = lt(n, r)), g.state.next({
        name: _,
        isDirty: ce(_, f),
        dirtyFields: a.dirtyFields,
        errors: a.errors,
        isValid: a.isValid
      });
    } else
      G(r, _, f);
  }, y = (_, f) => {
    G(a.errors, _, f), g.state.next({
      errors: a.errors
    });
  }, M = (_) => {
    a.errors = _, g.state.next({
      errors: a.errors,
      isValid: !1
    });
  }, A = (_, f, m, z) => {
    const x = C(o, _);
    if (x) {
      const w = C(r, _, ee(m) ? C(n, _) : m);
      ee(w) || z && z.defaultChecked || f ? G(r, _, f ? w : _o(x._f)) : T(_, w), i.mount && k();
    }
  }, N = (_, f, m, z, x) => {
    let w = !1, D = !1;
    const V = {
      name: _
    };
    if (!t.disabled) {
      if (!m || z) {
        (u.isDirty || d.isDirty) && (D = a.isDirty, a.isDirty = V.isDirty = ce(), w = D !== V.isDirty);
        const W = Oe(C(n, _), f);
        D = !!C(a.dirtyFields, _), W ? re(a.dirtyFields, _) : G(a.dirtyFields, _, !0), V.dirtyFields = a.dirtyFields, w = w || (u.dirtyFields || d.dirtyFields) && D !== !W;
      }
      if (m) {
        const W = C(a.touchedFields, _);
        W || (G(a.touchedFields, _, m), V.touchedFields = a.touchedFields, w = w || (u.touchedFields || d.touchedFields) && W !== m);
      }
      w && x && g.state.next(V);
    }
    return w ? V : {};
  }, F = (_, f, m, z) => {
    const x = C(a.errors, _), w = (u.isValid || d.isValid) && me(f) && a.isValid !== f;
    if (t.delayError && m ? (c = h(() => y(_, m)), c(t.delayError)) : (clearTimeout(s), c = null, m ? G(a.errors, _, m) : re(a.errors, _)), (m ? !Oe(x, m) : x) || !ge(z) || w) {
      const D = {
        ...z,
        ...w && me(f) ? { isValid: f } : {},
        errors: a.errors,
        name: _
      };
      a = {
        ...a,
        ...D
      }, g.state.next(D);
    }
  }, U = async (_) => {
    v(_, !0);
    const f = await t.resolver(r, t.context, ci(_ || l.mount, o, t.criteriaMode, t.shouldUseNativeValidation));
    return v(_), f;
  }, ae = async (_) => {
    const { errors: f } = await U(_);
    if (_)
      for (const m of _) {
        const z = C(f, m);
        z ? G(a.errors, m, z) : re(a.errors, m);
      }
    else
      a.errors = f;
    return f;
  }, Q = async (_, f, m = {
    valid: !0
  }) => {
    for (const z in _) {
      const x = _[z];
      if (x) {
        const { _f: w, ...D } = x;
        if (w) {
          const V = l.array.has(w.name), W = x._f && ui(x._f);
          W && u.validatingFields && v([z], !0);
          const pe = await po(x, l.disabled, r, b, t.shouldUseNativeValidation && !f, V);
          if (W && u.validatingFields && v([z]), pe[w.name] && (m.valid = !1, f))
            break;
          !f && (C(pe, w.name) ? V ? hi(a.errors, pe, w.name) : G(a.errors, w.name, pe[w.name]) : re(a.errors, w.name));
        }
        !ge(D) && await Q(D, f, m);
      }
    }
    return m.valid;
  }, X = () => {
    for (const _ of l.unMount) {
      const f = C(o, _);
      f && (f._f.refs ? f._f.refs.every((m) => !_a(m)) : !_a(f._f.ref)) && la(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, ce = (_, f) => !t.disabled && (_ && f && G(r, _, f), !Oe(Ve(), n)), B = (_, f, m) => xn(_, l, {
    ...i.mount ? r : ee(f) ? n : Ce(_) ? { [_]: f } : f
  }, m, f), E = (_) => ja(C(i.mount ? r : n, _, t.shouldUnregister ? C(n, _, []) : [])), T = (_, f, m = {}) => {
    const z = C(o, _);
    let x = f;
    if (z) {
      const w = z._f;
      w && (!w.disabled && G(r, _, Pn(f, w)), x = Bt(w.ref) && de(f) ? "" : f, Cn(w.ref) ? [...w.ref.options].forEach((D) => D.selected = x.includes(D.value)) : w.refs ? $t(w.ref) ? w.refs.forEach((D) => {
        (!D.defaultChecked || !D.disabled) && (Array.isArray(x) ? D.checked = !!x.find((V) => V === D.value) : D.checked = x === D.value || !!x);
      }) : w.refs.forEach((D) => D.checked = D.value === x) : Ra(w.ref) ? w.ref.value = "" : (w.ref.value = x, w.ref.type || g.state.next({
        name: _,
        values: ie(r)
      })));
    }
    (m.shouldDirty || m.shouldTouch) && N(_, x, m.shouldTouch, m.shouldDirty, !0), m.shouldValidate && ke(_);
  }, Z = (_, f, m) => {
    for (const z in f) {
      if (!f.hasOwnProperty(z))
        return;
      const x = f[z], w = _ + "." + z, D = C(o, w);
      (l.array.has(_) || te(x) || D && !D._f) && !Ue(x) ? Z(w, x, m) : T(w, x, m);
    }
  }, q = (_, f, m = {}) => {
    const z = C(o, _), x = l.array.has(_), w = ie(f);
    G(r, _, w), x ? (g.array.next({
      name: _,
      values: ie(r)
    }), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && m.shouldDirty && g.state.next({
      name: _,
      dirtyFields: lt(n, r),
      isDirty: ce(_, w)
    })) : z && !z._f && !de(w) ? Z(_, w, m) : T(_, w, m), bo(_, l) && g.state.next({ ...a, name: _ }), g.state.next({
      name: i.mount ? _ : void 0,
      values: ie(r)
    });
  }, oe = async (_) => {
    i.mount = !0;
    const f = _.target;
    let m = f.name, z = !0;
    const x = C(o, m), w = (W) => {
      z = Number.isNaN(W) || Ue(W) && isNaN(W.getTime()) || Oe(W, C(r, m, W));
    }, D = go(t.mode), V = go(t.reValidateMode);
    if (x) {
      let W, pe;
      const St = f.type ? _o(x._f) : vn(_), Ee = _.type === Et.BLUR || _.type === Et.FOCUS_OUT, Kr = !di(x._f) && !t.resolver && !C(a.errors, m) && !x._f.deps || fi(Ee, C(a.touchedFields, m), a.isSubmitted, V, D), ua = bo(m, l, Ee);
      G(r, m, St), Ee ? (!f || !f.readOnly) && (x._f.onBlur && x._f.onBlur(_), c && c(0)) : x._f.onChange && x._f.onChange(_);
      const da = N(m, St, Ee), qr = !ge(da) || ua;
      if (!Ee && g.state.next({
        name: m,
        type: _.type,
        values: ie(r)
      }), Kr)
        return (u.isValid || d.isValid) && (t.mode === "onBlur" ? Ee && k() : Ee || k()), qr && g.state.next({ name: m, ...ua ? {} : da });
      if (!Ee && ua && g.state.next({ ...a }), t.resolver) {
        const { errors: oo } = await U([m]);
        if (w(St), z) {
          const Hr = ho(a.errors, o, m), no = ho(oo, o, Hr.name || m);
          W = no.error, m = no.name, pe = ge(oo);
        }
      } else
        v([m], !0), W = (await po(x, l.disabled, r, b, t.shouldUseNativeValidation))[m], v([m]), w(St), z && (W ? pe = !1 : (u.isValid || d.isValid) && (pe = await Q(o, !0)));
      z && (x._f.deps && ke(x._f.deps), F(m, pe, W, da));
    }
  }, ve = (_, f) => {
    if (C(a.errors, f) && _.focus)
      return _.focus(), 1;
  }, ke = async (_, f = {}) => {
    let m, z;
    const x = dt(_);
    if (t.resolver) {
      const w = await ae(ee(_) ? _ : x);
      m = ge(w), z = _ ? !x.some((D) => C(w, D)) : m;
    } else _ ? (z = (await Promise.all(x.map(async (w) => {
      const D = C(o, w);
      return await Q(D && D._f ? { [w]: D } : D);
    }))).every(Boolean), !(!z && !a.isValid) && k()) : z = m = await Q(o);
    return g.state.next({
      ...!Ce(_) || (u.isValid || d.isValid) && m !== a.isValid ? {} : { name: _ },
      ...t.resolver || !_ ? { isValid: m } : {},
      errors: a.errors
    }), f.shouldFocus && !z && _t(o, ve, _ ? x : l.mount), z;
  }, Ve = (_) => {
    const f = {
      ...i.mount ? r : n
    };
    return ee(_) ? f : Ce(_) ? C(f, _) : _.map((m) => C(f, m));
  }, ue = (_, f) => ({
    invalid: !!C((f || a).errors, _),
    isDirty: !!C((f || a).dirtyFields, _),
    error: C((f || a).errors, _),
    isValidating: !!C(a.validatingFields, _),
    isTouched: !!C((f || a).touchedFields, _)
  }), Ae = (_) => {
    _ && dt(_).forEach((f) => re(a.errors, f)), g.state.next({
      errors: _ ? a.errors : {}
    });
  }, Le = (_, f, m) => {
    const z = (C(o, _, { _f: {} })._f || {}).ref, x = C(a.errors, _) || {}, { ref: w, message: D, type: V, ...W } = x;
    G(a.errors, _, {
      ...W,
      ...f,
      ref: z
    }), g.state.next({
      name: _,
      errors: a.errors,
      isValid: !1
    }), m && m.shouldFocus && z && z.focus && z.focus();
  }, Ct = (_, f) => we(_) ? g.state.subscribe({
    next: (m) => "values" in m && _(B(void 0, f), m)
  }) : B(_, f, !0), Ya = (_) => g.state.subscribe({
    next: (f) => {
      gi(_.name, f.name, _.exact) && _i(f, _.formState || u, Wr, _.reRenderRoot) && _.callback({
        values: { ...r },
        ...a,
        ...f,
        defaultValues: n
      });
    }
  }).unsubscribe, Vr = (_) => (i.mount = !0, d = {
    ...d,
    ..._.formState
  }, Ya({
    ..._,
    formState: d
  })), la = (_, f = {}) => {
    for (const m of _ ? dt(_) : l.mount)
      l.mount.delete(m), l.array.delete(m), f.keepValue || (re(o, m), re(r, m)), !f.keepError && re(a.errors, m), !f.keepDirty && re(a.dirtyFields, m), !f.keepTouched && re(a.touchedFields, m), !f.keepIsValidating && re(a.validatingFields, m), !t.shouldUnregister && !f.keepDefaultValue && re(n, m);
    g.state.next({
      values: ie(r)
    }), g.state.next({
      ...a,
      ...f.keepDirty ? { isDirty: ce() } : {}
    }), !f.keepIsValid && k();
  }, Qa = ({ disabled: _, name: f }) => {
    (me(_) && i.mount || _ || l.disabled.has(f)) && (_ ? l.disabled.add(f) : l.disabled.delete(f));
  }, sa = (_, f = {}) => {
    let m = C(o, _);
    const z = me(f.disabled) || me(t.disabled);
    return G(o, _, {
      ...m || {},
      _f: {
        ...m && m._f ? m._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...f
      }
    }), l.mount.add(_), m ? Qa({
      disabled: me(f.disabled) ? f.disabled : t.disabled,
      name: _
    }) : A(_, !0, f.value), {
      ...z ? { disabled: f.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!f.required,
        min: st(f.min),
        max: st(f.max),
        minLength: st(f.minLength),
        maxLength: st(f.maxLength),
        pattern: st(f.pattern)
      } : {},
      name: _,
      onChange: oe,
      onBlur: oe,
      ref: (x) => {
        if (x) {
          sa(_, f), m = C(o, _);
          const w = ee(x.value) && x.querySelectorAll && x.querySelectorAll("input,select,textarea")[0] || x, D = ii(w), V = m._f.refs || [];
          if (D ? V.find((W) => W === w) : w === m._f.ref)
            return;
          G(o, _, {
            _f: {
              ...m._f,
              ...D ? {
                refs: [
                  ...V.filter(_a),
                  w,
                  ...Array.isArray(C(n, _)) ? [{}] : []
                ],
                ref: { type: w.type, name: _ }
              } : { ref: w }
            }
          }), A(_, !1, void 0, w);
        } else
          m = C(o, _, {}), m._f && (m._f.mount = !1), (t.shouldUnregister || f.shouldUnregister) && !(kn(l.array, _) && i.action) && l.unMount.add(_);
      }
    };
  }, ca = () => t.shouldFocusError && _t(o, ve, l.mount), Gr = (_) => {
    me(_) && (g.state.next({ disabled: _ }), _t(o, (f, m) => {
      const z = C(o, m);
      z && (f.disabled = z._f.disabled || _, Array.isArray(z._f.refs) && z._f.refs.forEach((x) => {
        x.disabled = z._f.disabled || _;
      }));
    }, 0, !1));
  }, Xa = (_, f) => async (m) => {
    let z;
    m && (m.preventDefault && m.preventDefault(), m.persist && m.persist());
    let x = ie(r);
    if (g.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: w, values: D } = await U();
      a.errors = w, x = ie(D);
    } else
      await Q(o);
    if (l.disabled.size)
      for (const w of l.disabled)
        re(x, w);
    if (re(a.errors, "root"), ge(a.errors)) {
      g.state.next({
        errors: {}
      });
      try {
        await _(x, m);
      } catch (w) {
        z = w;
      }
    } else
      f && await f({ ...a.errors }, m), ca(), setTimeout(ca);
    if (g.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ge(a.errors) && !z,
      submitCount: a.submitCount + 1,
      errors: a.errors
    }), z)
      throw z;
  }, Ur = (_, f = {}) => {
    C(o, _) && (ee(f.defaultValue) ? q(_, ie(C(n, _))) : (q(_, f.defaultValue), G(n, _, ie(f.defaultValue))), f.keepTouched || re(a.touchedFields, _), f.keepDirty || (re(a.dirtyFields, _), a.isDirty = f.defaultValue ? ce(_, ie(C(n, _))) : ce()), f.keepError || (re(a.errors, _), u.isValid && k()), g.state.next({ ...a }));
  }, eo = (_, f = {}) => {
    const m = _ ? ie(_) : n, z = ie(m), x = ge(_), w = x ? n : z;
    if (f.keepDefaultValues || (n = m), !f.keepValues) {
      if (f.keepDirtyValues) {
        const D = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(lt(n, r))
        ]);
        for (const V of Array.from(D))
          C(a.dirtyFields, V) ? G(w, V, C(r, V)) : q(V, C(w, V));
      } else {
        if (Ia && ee(_))
          for (const D of l.mount) {
            const V = C(o, D);
            if (V && V._f) {
              const W = Array.isArray(V._f.refs) ? V._f.refs[0] : V._f.ref;
              if (Bt(W)) {
                const pe = W.closest("form");
                if (pe) {
                  pe.reset();
                  break;
                }
              }
            }
          }
        if (f.keepFieldsRef)
          for (const D of l.mount)
            q(D, C(w, D));
        else
          o = {};
      }
      r = t.shouldUnregister ? f.keepDefaultValues ? ie(n) : {} : ie(w), g.array.next({
        values: { ...w }
      }), g.state.next({
        values: { ...w }
      });
    }
    l = {
      mount: f.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, i.mount = !u.isValid || !!f.keepIsValid || !!f.keepDirtyValues, i.watch = !!t.shouldUnregister, g.state.next({
      submitCount: f.keepSubmitCount ? a.submitCount : 0,
      isDirty: x ? !1 : f.keepDirty ? a.isDirty : !!(f.keepDefaultValues && !Oe(_, n)),
      isSubmitted: f.keepIsSubmitted ? a.isSubmitted : !1,
      dirtyFields: x ? {} : f.keepDirtyValues ? f.keepDefaultValues && r ? lt(n, r) : a.dirtyFields : f.keepDefaultValues && _ ? lt(n, _) : f.keepDirty ? a.dirtyFields : {},
      touchedFields: f.keepTouched ? a.touchedFields : {},
      errors: f.keepErrors ? a.errors : {},
      isSubmitSuccessful: f.keepIsSubmitSuccessful ? a.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: n
    });
  }, to = (_, f) => eo(we(_) ? _(r) : _, f), Zr = (_, f = {}) => {
    const m = C(o, _), z = m && m._f;
    if (z) {
      const x = z.refs ? z.refs[0] : z.ref;
      x.focus && (x.focus(), f.shouldSelect && we(x.select) && x.select());
    }
  }, Wr = (_) => {
    a = {
      ...a,
      ..._
    };
  }, ao = {
    control: {
      register: sa,
      unregister: la,
      getFieldState: ue,
      handleSubmit: Xa,
      setError: Le,
      _subscribe: Ya,
      _runSchema: U,
      _focusError: ca,
      _getWatch: B,
      _getDirty: ce,
      _setValid: k,
      _setFieldArray: P,
      _setDisabledField: Qa,
      _setErrors: M,
      _getFieldArray: E,
      _reset: eo,
      _resetDefaultValues: () => we(t.defaultValues) && t.defaultValues().then((_) => {
        to(_, t.resetOptions), g.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: X,
      _disableForm: Gr,
      _subjects: g,
      _proxyFormState: u,
      get _fields() {
        return o;
      },
      get _formValues() {
        return r;
      },
      get _state() {
        return i;
      },
      set _state(_) {
        i = _;
      },
      get _defaultValues() {
        return n;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return a;
      },
      get _options() {
        return t;
      },
      set _options(_) {
        t = {
          ...t,
          ..._
        };
      }
    },
    subscribe: Vr,
    trigger: ke,
    register: sa,
    handleSubmit: Xa,
    watch: Ct,
    setValue: q,
    getValues: Ve,
    reset: to,
    resetField: Ur,
    clearErrors: Ae,
    unregister: la,
    setError: Le,
    setFocus: Zr,
    getFieldState: ue
  };
  return {
    ...ao,
    formControl: ao
  };
}
function yi(e = {}) {
  const t = O.useRef(void 0), a = O.useRef(void 0), [o, n] = O.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: we(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: we(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: o
      }, e.defaultValues && !we(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: i, ...l } = pi(e);
      t.current = {
        ...l,
        formState: o
      };
    }
  const r = t.current.control;
  return r._options = e, Ba(() => {
    const i = r._subscribe({
      formState: r._proxyFormState,
      callback: () => n({ ...r._formState }),
      reRenderRoot: !0
    });
    return n((l) => ({
      ...l,
      isReady: !0
    })), r._formState.isReady = !0, i;
  }, [r]), O.useEffect(() => r._disableForm(e.disabled), [r, e.disabled]), O.useEffect(() => {
    e.mode && (r._options.mode = e.mode), e.reValidateMode && (r._options.reValidateMode = e.reValidateMode);
  }, [r, e.mode, e.reValidateMode]), O.useEffect(() => {
    e.errors && (r._setErrors(e.errors), r._focusError());
  }, [r, e.errors]), O.useEffect(() => {
    e.shouldUnregister && r._subjects.state.next({
      values: r._getWatch()
    });
  }, [r, e.shouldUnregister]), O.useEffect(() => {
    if (r._proxyFormState.isDirty) {
      const i = r._getDirty();
      i !== o.isDirty && r._subjects.state.next({
        isDirty: i
      });
    }
  }, [r, o.isDirty]), O.useEffect(() => {
    e.values && !Oe(e.values, a.current) ? (r._reset(e.values, {
      keepFieldsRef: !0,
      ...r._options.resetOptions
    }), a.current = e.values, n((i) => ({ ...i }))) : r._resetDefaultValues();
  }, [r, e.values]), O.useEffect(() => {
    r._state.mount || (r._setValid(), r._state.mount = !0), r._state.watch && (r._state.watch = !1, r._subjects.state.next({ ...r._formState })), r._removeUnmounted();
  }), t.current.formState = wn(o, r), t.current;
}
const vi = (e, t, a, o) => {
  const n = [a, {
    code: t,
    ...o || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(n, "warn", "react-i18next::", !0);
  Ze(n[0]) && (n[0] = `react-i18next:: ${n[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...n) : console?.warn && console.warn(...n);
}, yo = {}, ya = (e, t, a, o) => {
  Ze(a) && yo[a] || (Ze(a) && (yo[a] = /* @__PURE__ */ new Date()), vi(e, t, a, o));
}, Dn = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const a = () => {
      setTimeout(() => {
        e.off("initialized", a);
      }, 0), t();
    };
    e.on("initialized", a);
  }
}, va = (e, t, a) => {
  e.loadNamespaces(t, Dn(e, a));
}, vo = (e, t, a, o) => {
  if (Ze(a) && (a = [a]), e.options.preload && e.options.preload.indexOf(t) > -1) return va(e, a, o);
  a.forEach((n) => {
    e.options.ns.indexOf(n) < 0 && e.options.ns.push(n);
  }), e.loadLanguages(t, Dn(e, o));
}, ki = (e, t, a = {}) => !t.languages || !t.languages.length ? (ya(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: a.lng,
  precheck: (o, n) => {
    if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !n(o.isLanguageChangingTo, e)) return !1;
  }
}), Ze = (e) => typeof e == "string", $i = (e) => typeof e == "object" && e !== null, wi = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, xi = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Ci = (e) => xi[e], Si = (e) => e.replace(wi, Ci);
let zi = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Si
};
const Ai = () => zi;
let Pi;
const Mi = () => Pi, Nn = Na();
class Di {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((a) => {
      this.usedNamespaces[a] || (this.usedNamespaces[a] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Ni = (e, t) => {
  const a = bt();
  return Ie(() => {
    a.current = e;
  }, [e, t]), a.current;
}, On = (e, t, a, o) => e.getFixedT(t, a, o), Oi = (e, t, a, o) => hn(On(e, t, a, o), [e, t, a, o]), Va = (e, t = {}) => {
  const {
    i18n: a
  } = t, {
    i18n: o,
    defaultNS: n
  } = Oa(Nn) || {}, r = a || o || Mi();
  if (r && !r.reportNamespaces && (r.reportNamespaces = new Di()), !r) {
    ya(r, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const A = (F, U) => Ze(U) ? U : $i(U) && Ze(U.defaultValue) ? U.defaultValue : Array.isArray(F) ? F[F.length - 1] : F, N = [A, {}, !1];
    return N.t = A, N.i18n = {}, N.ready = !1, N;
  }
  r.options.react?.wait && ya(r, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...Ai(),
    ...r.options.react,
    ...t
  }, {
    useSuspense: l,
    keyPrefix: c
  } = i;
  let s = e || n || r.options?.defaultNS;
  s = Ze(s) ? [s] : s || ["translation"], r.reportNamespaces.addUsedNamespaces?.(s);
  const u = (r.isInitialized || r.initializedStoreOnce) && s.every((A) => ki(A, r, i)), d = Oi(r, t.lng || null, i.nsMode === "fallback" ? s : s[0], c), g = () => d, b = () => On(r, t.lng || null, i.nsMode === "fallback" ? s : s[0], c), [h, k] = xe(g);
  let v = s.join();
  t.lng && (v = `${t.lng}${v}`);
  const P = Ni(v), y = bt(!0);
  Ie(() => {
    const {
      bindI18n: A,
      bindI18nStore: N
    } = i;
    y.current = !0, !u && !l && (t.lng ? vo(r, t.lng, s, () => {
      y.current && k(b);
    }) : va(r, s, () => {
      y.current && k(b);
    })), u && P && P !== v && y.current && k(b);
    const F = () => {
      y.current && k(b);
    };
    return A && r?.on(A, F), N && r?.store.on(N, F), () => {
      y.current = !1, r && A && A?.split(" ").forEach((U) => r.off(U, F)), N && r && N.split(" ").forEach((U) => r.store.off(U, F));
    };
  }, [r, v]), Ie(() => {
    y.current && u && k(g);
  }, [r, c, u]);
  const M = [h, r, u];
  if (M.t = h, M.i18n = r, M.ready = u, u || !u && !l) return M;
  throw new Promise((A) => {
    t.lng ? vo(r, t.lng, s, () => A()) : va(r, s, () => A());
  });
};
function Ii({
  i18n: e,
  defaultNS: t,
  children: a
}) {
  const o = mn(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return Yr(Nn.Provider, {
    value: o
  }, a);
}
function In(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = In(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function H() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = In(e)) && (o && (o += " "), o += t);
  return o;
}
const ji = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Li = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Ei = ji.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Li[e]
})), Bi = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Ti = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Ri(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ p("span", { className: a }, a));
}
const Ke = kt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Ei.find((c) => c.name === e), l = H("icon", `ds-${i?.class}`, Ti[t], Bi[a], o);
    return /* @__PURE__ */ p("i", { className: l, ...n, ref: r, children: Ri(i?.paths) });
  }
);
Ke.displayName = "Icon";
const Fi = "_loader_1ksyv_29", Vi = "_circle_1ksyv_41", Qe = {
  loader: Fi,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: Vi,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, Gi = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, Ui = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function Zi({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ R(
    "svg",
    {
      className: H(
        Qe.loader,
        Qe[Gi[t]],
        Qe[Ui[a]],
        e && Qe["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ p("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ p("circle", { className: Qe.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ R(
          "circle",
          {
            className: Qe["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ p("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ p(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const Wi = "_button_z1os6_29", Ki = "_disabled_z1os6_43", qi = "_loader_z1os6_263", Me = {
  button: Wi,
  disabled: Ki,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: qi,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, nt = kt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: l = "medium",
    isContrasted: c = !1,
    disabled: s = !1,
    className: u,
    children: d,
    ...g
  }, b) => {
    const h = H(
      Me.button,
      Me[Hi[t]],
      Me[Ji[a]],
      o && Me["is-full-width"],
      s && Me.disabled,
      r === "right" && Me["has-icon-right"],
      c && Me["is-contrasted"],
      i && Me["is-loading"],
      u
    ), k = /* @__PURE__ */ R(Jr, { children: [
      i && /* @__PURE__ */ p(Zi, { className: Me.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ p(Ke, { color: "inherit", size: l, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ p(Ke, { color: "inherit", size: l, name: n })
    ] });
    if (Yi(g))
      return /* @__PURE__ */ p(
        "a",
        {
          ...g,
          href: s ? void 0 : g.href,
          className: h,
          target: g.target,
          ref: b,
          children: k
        }
      );
    if (Qi(g))
      return /* @__PURE__ */ p(
        "button",
        {
          disabled: i || s,
          ...g,
          className: h,
          ref: b,
          children: k
        }
      );
  }
);
nt.displayName = "Button";
const Hi = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, Ji = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function Yi(e) {
  return "href" in e && typeof e.href == "string";
}
function Qi(e) {
  return !("href" in e);
}
const Xi = "_buttons_1obz3_29", ko = {
  buttons: Xi,
  "flex-grow-buttons": "_flex-grow-buttons_1obz3_44"
}, jn = ({ children: e, flexGrowButtons: t }) => /* @__PURE__ */ p("div", { className: H(ko.buttons, t && ko["flex-grow-buttons"]), children: e }), $o = {
  MOBILE: 640,
  TABLET: 768
}, el = "_text_1tduc_29", Be = {
  text: el,
  "is-small": "_is-small_1tduc_34",
  "is-uppercase": "_is-uppercase_1tduc_38",
  "is-ellipsis": "_is-ellipsis_1tduc_41",
  "is-center": "_is-center_1tduc_47",
  "color-primary": "_color-primary_1tduc_50",
  "color-secondary": "_color-secondary_1tduc_53",
  "color-tertiary": "_color-tertiary_1tduc_56",
  "color-eco-green": "_color-eco-green_1tduc_59",
  "color-success": "_color-success_1tduc_62",
  "color-error": "_color-error_1tduc_65",
  "color-inverted": "_color-inverted_1tduc_68",
  "color-warning": "_color-warning_1tduc_71",
  "color-highlight": "_color-highlight_1tduc_74",
  "color-inherit": "_color-inherit_1tduc_77",
  "is-bold": "_is-bold_1tduc_80",
  "size-xs": "_size-xs_1tduc_83",
  "size-sm": "_size-sm_1tduc_86",
  "size-base": "_size-base_1tduc_89",
  "size-lg": "_size-lg_1tduc_92",
  "size-xl": "_size-xl_1tduc_95",
  "dialog-overlay-show": "_dialog-overlay-show_1tduc_1",
  "dialog-content-show": "_dialog-content-show_1tduc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tduc_1"
};
function Ft({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: a,
  isUppercase: o,
  ellipsis: n,
  isSpan: r,
  className: i = "",
  color: l = "primary",
  isBold: c,
  size: s,
  title: u,
  center: d,
  ...g
}) {
  const b = H(
    Be.text,
    a && Be["is-small"],
    n && Be["is-ellipsis"],
    l && Be[`color-${l}`],
    c && Be["is-bold"],
    o && Be["is-uppercase"],
    s && Be[`size-${s}`],
    d && Be["is-center"],
    i
  ), h = r ? "span" : "div";
  return t ? /* @__PURE__ */ p(h, { className: b, dangerouslySetInnerHTML: t, ...g, title: u }) : /* @__PURE__ */ p(h, { className: b, ...g, children: e });
}
const tl = "_title_1s6y9_29", al = "_subtitle_1s6y9_106", Ge = {
  "title-container": "_title-container_1s6y9_29",
  "color-inverted": "_color-inverted_1s6y9_32",
  "is-primary": "_is-primary_1s6y9_35",
  "is-secondary": "_is-secondary_1s6y9_38",
  "is-tertiary": "_is-tertiary_1s6y9_41",
  "is-success": "_is-success_1s6y9_44",
  "is-error": "_is-error_1s6y9_47",
  "is-eco-green": "_is-eco-green_1s6y9_50",
  title: tl,
  "is-1": "_is-1_1s6y9_61",
  "is-impact": "_is-impact_1s6y9_70",
  "is-2": "_is-2_1s6y9_74",
  "is-3": "_is-3_1s6y9_84",
  "text-align-left": "_text-align-left_1s6y9_94",
  "text-align-right": "_text-align-right_1s6y9_97",
  "text-align-center": "_text-align-center_1s6y9_100",
  "text-align-justify": "_text-align-justify_1s6y9_103",
  subtitle: al,
  "dialog-overlay-show": "_dialog-overlay-show_1s6y9_1",
  "dialog-content-show": "_dialog-content-show_1s6y9_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1s6y9_1"
}, ol = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function Ln({
  color: e = "default",
  children: t,
  level: a = 3,
  hasHeaderTag: o = !1,
  isImpact: n,
  subtitle: r,
  className: i = "",
  title: l,
  textAlign: c,
  ...s
}) {
  const u = `h${a}`, d = `${o ? u : "p"}`, g = H(
    Ge.title,
    Ge[`is-${a}`],
    n && Ge["is-impact"],
    c && Ge[`text-align-${c}`],
    i
  );
  return /* @__PURE__ */ R("div", { className: H(Ge["title-container"], Ge[ol[e]]), children: [
    /* @__PURE__ */ p(d, { className: g, ...s, title: l, children: t }),
    r && /* @__PURE__ */ p("p", { className: H(Ge.subtitle), children: r })
  ] });
}
const zt = {
  "flex-children": "_flex-children_7pjb4_29",
  "justify-self-start": "_justify-self-start_7pjb4_29",
  "justify-self-end": "_justify-self-end_7pjb4_32",
  "justify-self-center": "_justify-self-center_7pjb4_35",
  "align-self-start": "_align-self-start_7pjb4_38",
  "align-self-end": "_align-self-end_7pjb4_41",
  "align-self-center": "_align-self-center_7pjb4_44",
  "is-full-width": "_is-full-width_7pjb4_47",
  "dialog-overlay-show": "_dialog-overlay-show_7pjb4_1",
  "dialog-content-show": "_dialog-content-show_7pjb4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7pjb4_1"
}, nl = ({ alignSelf: e, justifySelf: t, children: a, isFullWidth: o, ...n }) => {
  const r = H(
    zt["flex-children"],
    e && zt[`align-self-${e}`],
    t && zt[`justify-self-${t}`],
    o && zt["is-full-width"]
  );
  return /* @__PURE__ */ p("div", { className: r, ...n, children: a });
}, rl = "_flex_1y1zn_29", il = "_wrap_1y1zn_67", ll = "_nowrap_1y1zn_70", sl = "_shrink_1y1zn_88", fe = {
  flex: rl,
  "flex-row": "_flex-row_1y1zn_34",
  "flex-column": "_flex-column_1y1zn_37",
  "justify-start": "_justify-start_1y1zn_40",
  "justify-end": "_justify-end_1y1zn_43",
  "justify-center": "_justify-center_1y1zn_46",
  "justify-space-between": "_justify-space-between_1y1zn_49",
  "justify-space-around": "_justify-space-around_1y1zn_52",
  "align-start": "_align-start_1y1zn_55",
  "align-end": "_align-end_1y1zn_58",
  "align-center": "_align-center_1y1zn_61",
  "align-stretch": "_align-stretch_1y1zn_64",
  wrap: il,
  nowrap: ll,
  "wrap-reverse": "_wrap-reverse_1y1zn_73",
  "is-full-width": "_is-full-width_1y1zn_79",
  "is-full-height": "_is-full-height_1y1zn_82",
  "flex-grow": "_flex-grow_1y1zn_85",
  shrink: sl,
  "hide-on-mobile": "_hide-on-mobile_1y1zn_91",
  "is-scrollable": "_is-scrollable_1y1zn_99",
  "gap-0": "_gap-0_1y1zn_105",
  "gap-1": "_gap-1_1y1zn_108",
  "gap-2": "_gap-2_1y1zn_111",
  "gap-3": "_gap-3_1y1zn_114",
  "gap-4": "_gap-4_1y1zn_117",
  "gap-5": "_gap-5_1y1zn_120",
  "gap-6": "_gap-6_1y1zn_123",
  "gap-7": "_gap-7_1y1zn_126",
  "gap-8": "_gap-8_1y1zn_129",
  "gap-9": "_gap-9_1y1zn_132",
  "gap-10": "_gap-10_1y1zn_135",
  "gap-11": "_gap-11_1y1zn_138",
  "gap-12": "_gap-12_1y1zn_141",
  "gap-14": "_gap-14_1y1zn_144",
  "gap-16": "_gap-16_1y1zn_147",
  "gap-18": "_gap-18_1y1zn_150",
  "gap-20": "_gap-20_1y1zn_153",
  "gap-24": "_gap-24_1y1zn_156",
  "gap-28": "_gap-28_1y1zn_159",
  "gap-32": "_gap-32_1y1zn_162",
  "gap-36": "_gap-36_1y1zn_165",
  "gap-40": "_gap-40_1y1zn_168",
  "gap-44": "_gap-44_1y1zn_171",
  "gap-48": "_gap-48_1y1zn_174",
  "gap-52": "_gap-52_1y1zn_177",
  "gap-56": "_gap-56_1y1zn_180",
  "gap-60": "_gap-60_1y1zn_183",
  "gap-64": "_gap-64_1y1zn_186",
  "gap-72": "_gap-72_1y1zn_189",
  "gap-80": "_gap-80_1y1zn_192",
  "gap-96": "_gap-96_1y1zn_195",
  "no-margin": "_no-margin_1y1zn_198",
  "dialog-overlay-show": "_dialog-overlay-show_1y1zn_1",
  "dialog-content-show": "_dialog-content-show_1y1zn_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1y1zn_1"
};
function We({
  children: e,
  direction: t = "row",
  justifyContent: a = "start",
  alignItems: o = "start",
  flexWrap: n = "wrap",
  className: r = "",
  isFullWidth: i = !1,
  isFullHeight: l = !1,
  gap: c,
  style: s,
  noMargin: u = !1,
  flexGrow: d = !1,
  hideOnMobile: g = !1,
  shrink: b = !1,
  isScrollable: h = !1,
  ...k
}) {
  const v = H(
    fe.flex,
    fe[`flex-${t}`],
    fe[`justify-${a}`],
    fe[`align-${o}`],
    fe[n],
    i && fe["is-full-width"],
    l && fe["is-full-height"],
    c && fe[`gap-${c}`],
    u && fe["no-margin"],
    d && fe["flex-grow"],
    g && fe["hide-on-mobile"],
    b && fe.shrink,
    h && fe["is-scrollable"],
    r
  );
  return /* @__PURE__ */ p("div", { className: v, ...k, style: s, children: e });
}
We.FlexChildren = nl;
function je(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var ht = globalThis?.document ? S.useLayoutEffect : () => {
}, cl = S[" useInsertionEffect ".trim().toString()] || ht;
function En({
  prop: e,
  defaultProp: t,
  onChange: a = () => {
  },
  caller: o
}) {
  const [n, r, i] = ul({
    defaultProp: t,
    onChange: a
  }), l = e !== void 0, c = l ? e : n;
  {
    const u = S.useRef(e !== void 0);
    S.useEffect(() => {
      const d = u.current;
      d !== l && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = l;
    }, [l, o]);
  }
  const s = S.useCallback(
    (u) => {
      if (l) {
        const d = dl(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [l, e, r, i]
  );
  return [c, s];
}
function ul({
  defaultProp: e,
  onChange: t
}) {
  const [a, o] = S.useState(e), n = S.useRef(a), r = S.useRef(t);
  return cl(() => {
    r.current = t;
  }, [t]), S.useEffect(() => {
    n.current !== a && (r.current?.(a), n.current = a);
  }, [a, n]), [a, o, r];
}
function dl(e) {
  return typeof e == "function";
}
function wo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Bn(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = wo(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : wo(e[n], null);
        }
      };
  };
}
function qe(...e) {
  return S.useCallback(Bn(...e), e);
}
function Yt(e, t = []) {
  let a = [];
  function o(r, i) {
    const l = S.createContext(i), c = a.length;
    a = [...a, i];
    const s = (d) => {
      const { scope: g, children: b, ...h } = d, k = g?.[e]?.[c] || l, v = S.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ p(k.Provider, { value: v, children: b });
    };
    s.displayName = r + "Provider";
    function u(d, g) {
      const b = g?.[e]?.[c] || l, h = S.useContext(b);
      if (h) return h;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [s, u];
  }
  const n = () => {
    const r = a.map((i) => S.createContext(i));
    return function(i) {
      const l = i?.[e] || r;
      return S.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return n.scopeName = e, [o, _l(n, ...t)];
}
function _l(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: l, scopeName: c }) => {
        const s = l(n)[`__scope${c}`];
        return { ...i, ...s };
      }, {});
      return S.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function ka(e) {
  const t = /* @__PURE__ */ gl(e), a = S.forwardRef((o, n) => {
    const { children: r, ...i } = o, l = S.Children.toArray(r), c = l.find(bl);
    if (c) {
      const s = c.props.children, u = l.map((d) => d === c ? S.Children.count(s) > 1 ? S.Children.only(null) : S.isValidElement(s) ? s.props.children : null : d);
      return /* @__PURE__ */ p(t, { ...i, ref: n, children: S.isValidElement(s) ? S.cloneElement(s, void 0, u) : null });
    }
    return /* @__PURE__ */ p(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function gl(e) {
  const t = S.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (S.isValidElement(n)) {
      const i = ml(n), l = hl(r, n.props);
      return n.type !== S.Fragment && (l.ref = o ? Bn(o, i) : i), S.cloneElement(n, l);
    }
    return S.Children.count(n) > 1 ? S.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var fl = Symbol("radix.slottable");
function bl(e) {
  return S.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === fl;
}
function hl(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const l = r(...i);
      return n(...i), l;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function ml(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var pl = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], rt = pl.reduce((e, t) => {
  const a = /* @__PURE__ */ ka(`Primitive.${t}`), o = S.forwardRef((n, r) => {
    const { asChild: i, ...l } = n, c = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(c, { ...l, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {}), yl = S.createContext(void 0);
function Tn(e) {
  const t = S.useContext(yl);
  return e || t || "ltr";
}
function vl(e) {
  const t = e + "CollectionProvider", [a, o] = Yt(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (k) => {
    const { scope: v, children: P } = k, y = O.useRef(null), M = O.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(n, { scope: v, itemMap: M, collectionRef: y, children: P });
  };
  i.displayName = t;
  const l = e + "CollectionSlot", c = /* @__PURE__ */ ka(l), s = O.forwardRef(
    (k, v) => {
      const { scope: P, children: y } = k, M = r(l, P), A = qe(v, M.collectionRef);
      return /* @__PURE__ */ p(c, { ref: A, children: y });
    }
  );
  s.displayName = l;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", g = /* @__PURE__ */ ka(u), b = O.forwardRef(
    (k, v) => {
      const { scope: P, children: y, ...M } = k, A = O.useRef(null), N = qe(v, A), F = r(u, P);
      return O.useEffect(() => (F.itemMap.set(A, { ref: A, ...M }), () => void F.itemMap.delete(A))), /* @__PURE__ */ p(g, { [d]: "", ref: N, children: y });
    }
  );
  b.displayName = u;
  function h(k) {
    const v = r(e + "CollectionConsumer", k);
    return O.useCallback(() => {
      const P = v.collectionRef.current;
      if (!P) return [];
      const y = Array.from(P.querySelectorAll(`[${d}]`));
      return Array.from(v.itemMap.values()).sort(
        (M, A) => y.indexOf(M.ref.current) - y.indexOf(A.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: i, Slot: s, ItemSlot: b },
    h,
    o
  ];
}
var kl = S[" useId ".trim().toString()] || (() => {
}), $l = 0;
function wl(e) {
  const [t, a] = S.useState(kl());
  return ht(() => {
    a((o) => o ?? String($l++));
  }, [e]), t ? `radix-${t}` : "";
}
function xl(e, t) {
  return S.useReducer((a, o) => t[a][o] ?? a, e);
}
var Rn = (e) => {
  const { present: t, children: a } = e, o = Cl(t), n = typeof a == "function" ? a({ present: o.isPresent }) : S.Children.only(a), r = qe(o.ref, Sl(n));
  return typeof a == "function" || o.isPresent ? S.cloneElement(n, { ref: r }) : null;
};
Rn.displayName = "Presence";
function Cl(e) {
  const [t, a] = S.useState(), o = S.useRef(null), n = S.useRef(e), r = S.useRef("none"), i = e ? "mounted" : "unmounted", [l, c] = xl(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    const s = At(o.current);
    r.current = l === "mounted" ? s : "none";
  }, [l]), ht(() => {
    const s = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, g = At(s);
      e ? c("MOUNT") : g === "none" || s?.display === "none" ? c("UNMOUNT") : c(u && d !== g ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, c]), ht(() => {
    if (t) {
      let s;
      const u = t.ownerDocument.defaultView ?? window, d = (b) => {
        const h = At(o.current).includes(CSS.escape(b.animationName));
        if (b.target === t && h && (c("ANIMATION_END"), !n.current)) {
          const k = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", s = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = k);
          });
        }
      }, g = (b) => {
        b.target === t && (r.current = At(o.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(s), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: S.useCallback((s) => {
      o.current = s ? getComputedStyle(s) : null, a(s);
    }, [])
  };
}
function At(e) {
  return e?.animationName || "none";
}
function Sl(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function zl(e) {
  const t = S.useRef(e);
  return S.useEffect(() => {
    t.current = e;
  }), S.useMemo(() => (...a) => t.current?.(...a), []);
}
var ga = "rovingFocusGroup.onEntryFocus", Al = { bubbles: !1, cancelable: !0 }, wt = "RovingFocusGroup", [$a, Fn, Pl] = vl(wt), [Ml, Vn] = Yt(
  wt,
  [Pl]
), [Dl, Nl] = Ml(wt), Gn = S.forwardRef(
  (e, t) => /* @__PURE__ */ p($a.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p($a.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Ol, { ...e, ref: t }) }) })
);
Gn.displayName = wt;
var Ol = S.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: a,
    orientation: o,
    loop: n = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: c,
    onEntryFocus: s,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, g = S.useRef(null), b = qe(t, g), h = Tn(r), [k, v] = En({
    prop: i,
    defaultProp: l ?? null,
    onChange: c,
    caller: wt
  }), [P, y] = S.useState(!1), M = zl(s), A = Fn(a), N = S.useRef(!1), [F, U] = S.useState(0);
  return S.useEffect(() => {
    const ae = g.current;
    if (ae)
      return ae.addEventListener(ga, M), () => ae.removeEventListener(ga, M);
  }, [M]), /* @__PURE__ */ p(
    Dl,
    {
      scope: a,
      orientation: o,
      dir: h,
      loop: n,
      currentTabStopId: k,
      onItemFocus: S.useCallback(
        (ae) => v(ae),
        [v]
      ),
      onItemShiftTab: S.useCallback(() => y(!0), []),
      onFocusableItemAdd: S.useCallback(
        () => U((ae) => ae + 1),
        []
      ),
      onFocusableItemRemove: S.useCallback(
        () => U((ae) => ae - 1),
        []
      ),
      children: /* @__PURE__ */ p(
        rt.div,
        {
          tabIndex: P || F === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: b,
          style: { outline: "none", ...e.style },
          onMouseDown: je(e.onMouseDown, () => {
            N.current = !0;
          }),
          onFocus: je(e.onFocus, (ae) => {
            const Q = !N.current;
            if (ae.target === ae.currentTarget && Q && !P) {
              const X = new CustomEvent(ga, Al);
              if (ae.currentTarget.dispatchEvent(X), !X.defaultPrevented) {
                const ce = A().filter((Z) => Z.focusable), B = ce.find((Z) => Z.active), E = ce.find((Z) => Z.id === k), T = [B, E, ...ce].filter(
                  Boolean
                ).map((Z) => Z.ref.current);
                Wn(T, u);
              }
            }
            N.current = !1;
          }),
          onBlur: je(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Un = "RovingFocusGroupItem", Zn = S.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: a,
      focusable: o = !0,
      active: n = !1,
      tabStopId: r,
      children: i,
      ...l
    } = e, c = wl(), s = r || c, u = Nl(Un, a), d = u.currentTabStopId === s, g = Fn(a), { onFocusableItemAdd: b, onFocusableItemRemove: h, currentTabStopId: k } = u;
    return S.useEffect(() => {
      if (o)
        return b(), () => h();
    }, [o, b, h]), /* @__PURE__ */ p(
      $a.ItemSlot,
      {
        scope: a,
        id: s,
        focusable: o,
        active: n,
        children: /* @__PURE__ */ p(
          rt.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...l,
            ref: t,
            onMouseDown: je(e.onMouseDown, (v) => {
              o ? u.onItemFocus(s) : v.preventDefault();
            }),
            onFocus: je(e.onFocus, () => u.onItemFocus(s)),
            onKeyDown: je(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const P = Ll(v, u.orientation, u.dir);
              if (P !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let y = g().filter((M) => M.focusable).map((M) => M.ref.current);
                if (P === "last") y.reverse();
                else if (P === "prev" || P === "next") {
                  P === "prev" && y.reverse();
                  const M = y.indexOf(v.currentTarget);
                  y = u.loop ? El(y, M + 1) : y.slice(M + 1);
                }
                setTimeout(() => Wn(y));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: k != null }) : i
          }
        )
      }
    );
  }
);
Zn.displayName = Un;
var Il = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function jl(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Ll(e, t, a) {
  const o = jl(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Il[o];
}
function Wn(e, t = !1) {
  const a = document.activeElement;
  for (const o of e)
    if (o === a || (o.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
function El(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
var Bl = Gn, Tl = Zn;
function Rl(e) {
  const [t, a] = S.useState(void 0);
  return ht(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const r = n[0];
        let i, l;
        if ("borderBoxSize" in r) {
          const c = r.borderBoxSize, s = Array.isArray(c) ? c[0] : c;
          i = s.inlineSize, l = s.blockSize;
        } else
          i = e.offsetWidth, l = e.offsetHeight;
        a({ width: i, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
function Fl(e) {
  const t = S.useRef({ value: e, previous: e });
  return S.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Ga = "Radio", [Vl, Kn] = Yt(Ga), [Gl, Ul] = Vl(Ga), qn = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: a,
      name: o,
      checked: n = !1,
      required: r,
      disabled: i,
      value: l = "on",
      onCheck: c,
      form: s,
      ...u
    } = e, [d, g] = S.useState(null), b = qe(t, (v) => g(v)), h = S.useRef(!1), k = d ? s || !!d.closest("form") : !0;
    return /* @__PURE__ */ R(Gl, { scope: a, checked: n, disabled: i, children: [
      /* @__PURE__ */ p(
        rt.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": n,
          "data-state": Qn(n),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: l,
          ...u,
          ref: b,
          onClick: je(e.onClick, (v) => {
            n || c?.(), k && (h.current = v.isPropagationStopped(), h.current || v.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ p(
        Yn,
        {
          control: d,
          bubbles: !h.current,
          name: o,
          value: l,
          checked: n,
          required: r,
          disabled: i,
          form: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
qn.displayName = Ga;
var Hn = "RadioIndicator", Jn = S.forwardRef(
  (e, t) => {
    const { __scopeRadio: a, forceMount: o, ...n } = e, r = Ul(Hn, a);
    return /* @__PURE__ */ p(Rn, { present: o || r.checked, children: /* @__PURE__ */ p(
      rt.span,
      {
        "data-state": Qn(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    ) });
  }
);
Jn.displayName = Hn;
var Zl = "RadioBubbleInput", Yn = S.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: a,
    bubbles: o = !0,
    ...n
  }, r) => {
    const i = S.useRef(null), l = qe(i, r), c = Fl(a), s = Rl(t);
    return S.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, g = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (c !== a && g) {
        const b = new Event("click", { bubbles: o });
        g.call(u, a), u.dispatchEvent(b);
      }
    }, [c, a, o]), /* @__PURE__ */ p(
      rt.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: a,
        ...n,
        tabIndex: -1,
        ref: l,
        style: {
          ...n.style,
          ...s,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Yn.displayName = Zl;
function Qn(e) {
  return e ? "checked" : "unchecked";
}
var Wl = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Qt = "RadioGroup", [Kl, UL] = Yt(Qt, [
  Vn,
  Kn
]), Xn = Vn(), er = Kn(), [ql, Hl] = Kl(Qt), tr = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: a,
      name: o,
      defaultValue: n,
      value: r,
      required: i = !1,
      disabled: l = !1,
      orientation: c,
      dir: s,
      loop: u = !0,
      onValueChange: d,
      ...g
    } = e, b = Xn(a), h = Tn(s), [k, v] = En({
      prop: r,
      defaultProp: n ?? null,
      onChange: d,
      caller: Qt
    });
    return /* @__PURE__ */ p(
      ql,
      {
        scope: a,
        name: o,
        required: i,
        disabled: l,
        value: k,
        onValueChange: v,
        children: /* @__PURE__ */ p(
          Bl,
          {
            asChild: !0,
            ...b,
            orientation: c,
            dir: h,
            loop: u,
            children: /* @__PURE__ */ p(
              rt.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": c,
                "data-disabled": l ? "" : void 0,
                dir: h,
                ...g,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
tr.displayName = Qt;
var ar = "RadioGroupItem", or = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: a, disabled: o, ...n } = e, r = Hl(ar, a), i = r.disabled || o, l = Xn(a), c = er(a), s = S.useRef(null), u = qe(t, s), d = r.value === n.value, g = S.useRef(!1);
    return S.useEffect(() => {
      const b = (k) => {
        Wl.includes(k.key) && (g.current = !0);
      }, h = () => g.current = !1;
      return document.addEventListener("keydown", b), document.addEventListener("keyup", h), () => {
        document.removeEventListener("keydown", b), document.removeEventListener("keyup", h);
      };
    }, []), /* @__PURE__ */ p(
      Tl,
      {
        asChild: !0,
        ...l,
        focusable: !i,
        active: d,
        children: /* @__PURE__ */ p(
          qn,
          {
            disabled: i,
            required: r.required,
            checked: d,
            ...c,
            ...n,
            name: r.name,
            ref: u,
            onCheck: () => r.onValueChange(n.value),
            onKeyDown: je((b) => {
              b.key === "Enter" && b.preventDefault();
            }),
            onFocus: je(n.onFocus, () => {
              g.current && s.current?.click();
            })
          }
        )
      }
    );
  }
);
or.displayName = ar;
var Jl = "RadioGroupIndicator", nr = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: a, ...o } = e, n = er(a);
    return /* @__PURE__ */ p(Jn, { ...n, ...o, ref: t });
  }
);
nr.displayName = Jl;
var Yl = tr, Ql = or, Xl = nr;
const es = "_indicator_o29me_51", ts = "_label_o29me_66", Pt = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: es,
  label: ts
};
function as({ value: e, id: t, label: a, description: o }) {
  return /* @__PURE__ */ R("div", { className: Pt["radio-item"], children: [
    /* @__PURE__ */ p(Ql, { value: e, id: t, className: Pt["radio-button"], "aria-label": a, children: /* @__PURE__ */ p(Xl, { className: Pt.indicator }) }),
    /* @__PURE__ */ R("label", { htmlFor: t, className: Pt.label, children: [
      a,
      o && /* @__PURE__ */ p("p", { children: o })
    ] })
  ] });
}
function os() {
  const [e, t] = xe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ie(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function rr() {
  const { width: e } = os();
  let t = "desktop";
  return e && e <= $o.MOBILE ? t = "mobile" : e && e <= $o.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
const ns = ({
  initialPhoneNumber: e = "",
  initialCountry: t = "",
  onChangePhoneNumber: a,
  onChangeCountry: o
}) => {
  const [n, r] = xe(e), [i, l] = xe(t);
  return {
    phoneNumber: n,
    country: i,
    handlePhoneNumberChange: (c) => {
      r(c), a?.(c);
    },
    handleCountryChange: (c) => {
      l(c), o?.(c);
    }
  };
}, rs = {
  ad: "Andorra",
  ae: "De Forenede Arabiske Emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østrig",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnien-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "De tidligere Nederlandske Antiller",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviderusland",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocosøerne",
  cd: "Congo-Kinshasa",
  cf: "Den Centralafrikanske Republik",
  cg: "Congo-Brazzaville",
  ch: "Schweiz",
  ci: "Elfenbenskysten",
  ck: "Cookøerne",
  cl: "Chile",
  cm: "Cameroun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Juleøen",
  cy: "Cypern",
  cz: "Tjekkiet",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den Dominikanske Republik",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Vestsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøerne",
  fm: "Mikronesien",
  fo: "Færøerne",
  fr: "Frankrig",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ækvatorialguinea",
  gr: "Grækenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "SAR Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Det Britiske Territorium i Det Indiske Ocean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comorerne",
  kn: "Saint Kitts og Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanøerne",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxembourg",
  lv: "Letland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Marshalløerne",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "SAR Macao",
  mp: "Nordmarianerne",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverne",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Ny Kaledonien",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Holland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesien",
  pg: "Papua Ny Guinea",
  ph: "Filippinerne",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint Pierre og Miquelon",
  pr: "Puerto Rico",
  ps: "De palæstinensiske områder",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumænien",
  rs: "Serbien",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saudi-Arabien",
  sb: "Salomonøerne",
  sc: "Seychellerne",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenien",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakiet",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- og Caicosøerne",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Tyrkiet",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "Saint Vincent og Grenadinerne",
  ve: "Venezuela",
  vg: "De Britiske Jomfruøer",
  vi: "De Amerikanske Jomfruøer",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, is = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, ls = { ...rs, ...is }, ss = {
  ad: "Andorra",
  ae: "Vereinigte Arabische Emirate",
  af: "Afghanistan",
  ag: "Antigua und Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentinien",
  as: "Amerikanisch-Samoa",
  at: "Österreich",
  au: "Australien",
  aw: "Aruba",
  ax: "Ålandinseln",
  az: "Aserbaidschan",
  ba: "Bosnien und Herzegowina",
  bb: "Barbados",
  bd: "Bangladesch",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei Darussalam",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botsuana",
  by: "Belarus",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosinseln",
  cd: "Kongo-Kinshasa",
  cf: "Zentralafrikanische Republik",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cookinseln",
  cl: "Chile",
  cm: "Kamerun",
  cn: "China",
  co: "Kolumbien",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Weihnachtsinsel",
  cy: "Zypern",
  cz: "Tschechien",
  de: "Deutschland",
  dj: "Dschibuti",
  dk: "Dänemark",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dz: "Algerien",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Ägypten",
  eh: "Westsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Äthiopien",
  fi: "Finnland",
  fj: "Fidschi",
  fk: "Falklandinseln",
  fm: "Mikronesien",
  fo: "Färöer",
  fr: "Frankreich",
  ga: "Gabun",
  gb: "Vereinigtes Königreich",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Französisch-Guayana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Äquatorialguinea",
  gr: "Griechenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Sonderverwaltungsregion Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Britisches Territorium im Indischen Ozean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaika",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgisistan",
  kh: "Kambodscha",
  ki: "Kiribati",
  km: "Komoren",
  kn: "St. Kitts und Nevis",
  kp: "Nordkorea",
  kr: "Südkorea",
  kw: "Kuwait",
  ky: "Kaimaninseln",
  kz: "Kasachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Republik Moldau",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagaskar",
  mh: "Marshallinseln",
  mk: "Nordmazedonien",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolei",
  mo: "Sonderverwaltungsregion Macau",
  mp: "Nördliche Marianen",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Malediven",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Neukaledonien",
  ne: "Niger",
  nf: "Norfolkinsel",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Niederlande",
  no: "Norwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Neuseeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Französisch-Polynesien",
  pg: "Papua-Neuguinea",
  ph: "Philippinen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "St. Pierre und Miquelon",
  pr: "Puerto Rico",
  ps: "Palästinensische Autonomiegebiete",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Russland",
  rw: "Ruanda",
  sa: "Saudi-Arabien",
  sb: "Salomonen",
  sc: "Seychellen",
  sd: "Sudan",
  se: "Schweden",
  sg: "Singapur",
  sh: "St. Helena",
  si: "Slowenien",
  sj: "Spitzbergen und Jan Mayen",
  sk: "Slowakei",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Südsudan",
  st: "São Tomé und Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- und Caicosinseln",
  td: "Tschad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadschikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Türkei",
  tt: "Trinidad und Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tansania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "Vereinigte Staaten",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstadt",
  vc: "St. Vincent und die Grenadinen",
  ve: "Venezuela",
  vg: "Britische Jungferninseln",
  vi: "Amerikanische Jungferninseln",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis und Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Südafrika",
  zm: "Sambia",
  zw: "Simbabwe"
}, cs = {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo"
}, us = { ...ss, ...cs }, ds = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, _s = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, gs = { ...ds, ..._s }, fs = {
  ad: "Andorra",
  ae: "Emiratos Árabes Unidos",
  af: "Afganistán",
  ag: "Antigua y Barbuda",
  ai: "Anguila",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Islas Åland",
  az: "Azerbaiyán",
  ba: "Bosnia y Herzegovina",
  bb: "Barbados",
  bd: "Bangladés",
  be: "Bélgica",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Baréin",
  bi: "Burundi",
  bj: "Benín",
  bl: "San Bartolomé",
  bm: "Bermudas",
  bn: "Brunéi",
  bo: "Bolivia",
  bq: "Caribe neerlandés",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bután",
  bw: "Botsuana",
  by: "Bielorrusia",
  bz: "Belice",
  ca: "Canadá",
  cc: "Islas Cocos",
  cd: "República Democrática del Congo",
  cf: "República Centroafricana",
  cg: "Congo",
  ch: "Suiza",
  ci: "Côte d’Ivoire",
  ck: "Islas Cook",
  cl: "Chile",
  cm: "Camerún",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curazao",
  cx: "Isla de Navidad",
  cy: "Chipre",
  cz: "Chequia",
  de: "Alemania",
  dj: "Yibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argelia",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egipto",
  eh: "Sáhara Occidental",
  er: "Eritrea",
  es: "España",
  et: "Etiopía",
  fi: "Finlandia",
  fj: "Fiyi",
  fk: "Islas Malvinas",
  fm: "Micronesia",
  fo: "Islas Feroe",
  fr: "Francia",
  ga: "Gabón",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Georgia",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupe",
  gq: "Guinea Ecuatorial",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  hk: "RAE de Hong Kong (China)",
  hn: "Honduras",
  hr: "Croacia",
  ht: "Haití",
  hu: "Hungría",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israel",
  im: "Isla de Man",
  in: "India",
  io: "Territorio Británico del Océano Índico",
  iq: "Irak",
  ir: "Irán",
  is: "Islandia",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordania",
  jp: "Japón",
  ke: "Kenia",
  kg: "Kirguistán",
  kh: "Camboya",
  ki: "Kiribati",
  km: "Comoras",
  kn: "San Cristóbal y Nieves",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  kw: "Kuwait",
  ky: "Islas Caimán",
  kz: "Kazajistán",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lucía",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesoto",
  lt: "Lituania",
  lu: "Luxemburgo",
  lv: "Letonia",
  ly: "Libia",
  ma: "Marruecos",
  mc: "Mónaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "San Martín",
  mg: "Madagascar",
  mh: "Islas Marshall",
  mk: "Macedonia del Norte",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAE de Macao (China)",
  mp: "Islas Marianas del Norte",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricio",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malasia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Nueva Caledonia",
  ne: "Níger",
  nf: "Isla Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Países Bajos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nueva Zelanda",
  om: "Omán",
  pa: "Panamá",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pg: "Papúa Nueva Guinea",
  ph: "Filipinas",
  pk: "Pakistán",
  pl: "Polonia",
  pm: "San Pedro y Miquelón",
  pr: "Puerto Rico",
  ps: "Territorios Palestinos",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Catar",
  re: "Reunión",
  ro: "Rumanía",
  rs: "Serbia",
  ru: "Rusia",
  rw: "Ruanda",
  sa: "Arabia Saudí",
  sb: "Islas Salomón",
  sc: "Seychelles",
  sd: "Sudán",
  se: "Suecia",
  sg: "Singapur",
  sh: "Santa Elena",
  si: "Eslovenia",
  sj: "Svalbard y Jan Mayen",
  sk: "Eslovaquia",
  sl: "Sierra Leona",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sudán del Sur",
  st: "Santo Tomé y Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Esuatini",
  tc: "Islas Turcas y Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Tailandia",
  tj: "Tayikistán",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistán",
  tn: "Túnez",
  to: "Tonga",
  tr: "Turquía",
  tt: "Trinidad y Tobago",
  tv: "Tuvalu",
  tw: "Taiwán",
  tz: "Tanzania",
  ua: "Ucrania",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguay",
  uz: "Uzbekistán",
  va: "Ciudad del Vaticano",
  vc: "San Vicente y las Granadinas",
  ve: "Venezuela",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis y Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudáfrica",
  zm: "Zambia",
  zw: "Zimbabue"
}, bs = {
  selectedCountryAriaLabel: "País seleccionado",
  noCountrySelected: "Ningún país seleccionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Buscar",
  zeroSearchResults: "No se han encontrado resultados",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "isla Ascencion",
  xk: "Kosovo"
}, hs = { ...fs, ...bs }, ms = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
}, ps = {
  selectedCountryAriaLabel: "Pays sélectionné",
  noCountrySelected: "Aucun pays sélectionné",
  countryListAriaLabel: "Liste des pays",
  searchPlaceholder: "Recherche",
  zeroSearchResults: "Aucun résultat trouvé",
  oneSearchResult: "1 résultat trouvé",
  multipleSearchResults: "${count} résultats trouvés",
  // additional countries (not supported by country-list library)
  ac: "Île de l'Ascension",
  xk: "Kosovo"
}, ys = { ...ms, ...ps }, vs = {
  ad: "Andora",
  ae: "Ujedinjeni Arapski Emirati",
  af: "Afganistan",
  ag: "Antigva i Barbuda",
  ai: "Angvila",
  al: "Albanija",
  am: "Armenija",
  ao: "Angola",
  ar: "Argentina",
  as: "Američka Samoa",
  at: "Austrija",
  au: "Australija",
  aw: "Aruba",
  ax: "Ålandski otoci",
  az: "Azerbajdžan",
  ba: "Bosna i Hercegovina",
  bb: "Barbados",
  bd: "Bangladeš",
  be: "Belgija",
  bf: "Burkina Faso",
  bg: "Bugarska",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermudi",
  bn: "Brunej",
  bo: "Bolivija",
  bq: "Karipski otoci Nizozemske",
  br: "Brazil",
  bs: "Bahami",
  bt: "Butan",
  bw: "Bocvana",
  by: "Bjelorusija",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosovi (Keelingovi) otoci",
  cd: "Kongo - Kinshasa",
  cf: "Srednjoafrička Republika",
  cg: "Kongo - Brazzaville",
  ch: "Švicarska",
  ci: "Obala Bjelokosti",
  ck: "Cookovi Otoci",
  cl: "Čile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Kolumbija",
  cr: "Kostarika",
  cu: "Kuba",
  cv: "Zelenortska Republika",
  cw: "Curaçao",
  cx: "Božićni otok",
  cy: "Cipar",
  cz: "Češka",
  de: "Njemačka",
  dj: "Džibuti",
  dk: "Danska",
  dm: "Dominika",
  do: "Dominikanska Republika",
  dz: "Alžir",
  ec: "Ekvador",
  ee: "Estonija",
  eg: "Egipat",
  eh: "Zapadna Sahara",
  er: "Eritreja",
  es: "Španjolska",
  et: "Etiopija",
  fi: "Finska",
  fj: "Fidži",
  fk: "Falklandski otoci",
  fm: "Mikronezija",
  fo: "Farski otoci",
  fr: "Francuska",
  ga: "Gabon",
  gb: "Ujedinjeno Kraljevstvo",
  gd: "Grenada",
  ge: "Gruzija",
  gf: "Francuska Gijana",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Grenland",
  gm: "Gambija",
  gn: "Gvineja",
  gp: "Guadalupe",
  gq: "Ekvatorska Gvineja",
  gr: "Grčka",
  gt: "Gvatemala",
  gu: "Guam",
  gw: "Gvineja Bisau",
  gy: "Gvajana",
  hk: "PUP Hong Kong Kina",
  hn: "Honduras",
  hr: "Hrvatska",
  ht: "Haiti",
  hu: "Mađarska",
  id: "Indonezija",
  ie: "Irska",
  il: "Izrael",
  im: "Otok Man",
  in: "Indija",
  io: "Britanski Indijskooceanski teritorij",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italija",
  je: "Jersey",
  jm: "Jamajka",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenija",
  kg: "Kirgistan",
  kh: "Kambodža",
  ki: "Kiribati",
  km: "Komori",
  kn: "Sveti Kristofor i Nevis",
  kp: "Sjeverna Koreja",
  kr: "Južna Koreja",
  kw: "Kuvajt",
  ky: "Kajmanski otoci",
  kz: "Kazahstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Sveta Lucija",
  li: "Lihtenštajn",
  lk: "Šri Lanka",
  lr: "Liberija",
  ls: "Lesoto",
  lt: "Litva",
  lu: "Luksemburg",
  lv: "Latvija",
  ly: "Libija",
  ma: "Maroko",
  mc: "Monako",
  md: "Moldavija",
  me: "Crna Gora",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Maršalovi Otoci",
  mk: "Sjeverna Makedonija",
  ml: "Mali",
  mm: "Mjanmar (Burma)",
  mn: "Mongolija",
  mo: "PUP Makao Kina",
  mp: "Sjevernomarijanski otoci",
  mq: "Martinique",
  mr: "Mauretanija",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricijus",
  mv: "Maldivi",
  mw: "Malavi",
  mx: "Meksiko",
  my: "Malezija",
  mz: "Mozambik",
  na: "Namibija",
  nc: "Nova Kaledonija",
  ne: "Niger",
  nf: "Otok Norfolk",
  ng: "Nigerija",
  ni: "Nikaragva",
  nl: "Nizozemska",
  no: "Norveška",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Novi Zeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Francuska Polinezija",
  pg: "Papua Nova Gvineja",
  ph: "Filipini",
  pk: "Pakistan",
  pl: "Poljska",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Portoriko",
  ps: "Palestinsko područje",
  pt: "Portugal",
  pw: "Palau",
  py: "Paragvaj",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumunjska",
  rs: "Srbija",
  ru: "Rusija",
  rw: "Ruanda",
  sa: "Saudijska Arabija",
  sb: "Salomonski Otoci",
  sc: "Sejšeli",
  sd: "Sudan",
  se: "Švedska",
  sg: "Singapur",
  sh: "Sveta Helena",
  si: "Slovenija",
  sj: "Svalbard i Jan Mayen",
  sk: "Slovačka",
  sl: "Sijera Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalija",
  sr: "Surinam",
  ss: "Južni Sudan",
  st: "Sveti Toma i Princip",
  sv: "Salvador",
  sx: "Sint Maarten",
  sy: "Sirija",
  sz: "Esvatini",
  tc: "Otoci Turks i Caicos",
  td: "Čad",
  tg: "Togo",
  th: "Tajland",
  tj: "Tadžikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunis",
  to: "Tonga",
  tr: "Turska",
  tt: "Trinidad i Tobago",
  tv: "Tuvalu",
  tw: "Tajvan",
  tz: "Tanzanija",
  ua: "Ukrajina",
  ug: "Uganda",
  us: "Sjedinjene Američke Države",
  uy: "Urugvaj",
  uz: "Uzbekistan",
  va: "Vatikanski Grad",
  vc: "Sveti Vincent i Grenadini",
  ve: "Venezuela",
  vg: "Britanski Djevičanski otoci",
  vi: "Američki Djevičanski otoci",
  vn: "Vijetnam",
  vu: "Vanuatu",
  wf: "Wallis i Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Južnoafrička Republika",
  zm: "Zambija",
  zw: "Zimbabve"
}, ks = {
  selectedCountryAriaLabel: "Odabrana zemlja",
  noCountrySelected: "Zemlja nije odabrana",
  countryListAriaLabel: "Lista zemalja",
  searchPlaceholder: "Pretraži",
  zeroSearchResults: "Nema pronađenih rezultata",
  oneSearchResult: "Pronađen 1 rezultat",
  multipleSearchResults: "${count} rezultata pronađeno",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, $s = { ...vs, ...ks }, ws = {
  ad: "Andorra",
  ae: "Emirati Arabi Uniti",
  af: "Afghanistan",
  ag: "Antigua e Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa americane",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Isole Åland",
  az: "Azerbaigian",
  ba: "Bosnia ed Erzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgio",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caraibi olandesi",
  br: "Brasile",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Bielorussia",
  bz: "Belize",
  ca: "Canada",
  cc: "Isole Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Repubblica Centrafricana",
  cg: "Congo-Brazzaville",
  ch: "Svizzera",
  ci: "Costa d’Avorio",
  ck: "Isole Cook",
  cl: "Cile",
  cm: "Camerun",
  cn: "Cina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Capo Verde",
  cw: "Curaçao",
  cx: "Isola Christmas",
  cy: "Cipro",
  cz: "Cechia",
  de: "Germania",
  dj: "Gibuti",
  dk: "Danimarca",
  dm: "Dominica",
  do: "Repubblica Dominicana",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egitto",
  eh: "Sahara occidentale",
  er: "Eritrea",
  es: "Spagna",
  et: "Etiopia",
  fi: "Finlandia",
  fj: "Figi",
  fk: "Isole Falkland",
  fm: "Micronesia",
  fo: "Isole Fær Øer",
  fr: "Francia",
  ga: "Gabon",
  gb: "Regno Unito",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guyana francese",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibilterra",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupa",
  gq: "Guinea Equatoriale",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "RAS di Hong Kong",
  hn: "Honduras",
  hr: "Croazia",
  ht: "Haiti",
  hu: "Ungheria",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israele",
  im: "Isola di Man",
  in: "India",
  io: "Territorio britannico dell’Oceano Indiano",
  iq: "Iraq",
  ir: "Iran",
  is: "Islanda",
  it: "Italia",
  je: "Jersey",
  jm: "Giamaica",
  jo: "Giordania",
  jp: "Giappone",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambogia",
  ki: "Kiribati",
  km: "Comore",
  kn: "Saint Kitts e Nevis",
  kp: "Corea del Nord",
  kr: "Corea del Sud",
  kw: "Kuwait",
  ky: "Isole Cayman",
  kz: "Kazakistan",
  la: "Laos",
  lb: "Libano",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lituania",
  lu: "Lussemburgo",
  lv: "Lettonia",
  ly: "Libia",
  ma: "Marocco",
  mc: "Monaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagascar",
  mh: "Isole Marshall",
  mk: "Macedonia del Nord",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAS di Macao",
  mp: "Isole Marianne settentrionali",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldive",
  mw: "Malawi",
  mx: "Messico",
  my: "Malaysia",
  mz: "Mozambico",
  na: "Namibia",
  nc: "Nuova Caledonia",
  ne: "Niger",
  nf: "Isola Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Paesi Bassi",
  no: "Norvegia",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nuova Zelanda",
  om: "Oman",
  pa: "Panamá",
  pe: "Perù",
  pf: "Polinesia francese",
  pg: "Papua Nuova Guinea",
  ph: "Filippine",
  pk: "Pakistan",
  pl: "Polonia",
  pm: "Saint-Pierre e Miquelon",
  pr: "Portorico",
  ps: "Territori palestinesi",
  pt: "Portogallo",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Riunione",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Ruanda",
  sa: "Arabia Saudita",
  sb: "Isole Salomone",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Svezia",
  sg: "Singapore",
  sh: "Sant’Elena",
  si: "Slovenia",
  sj: "Svalbard e Jan Mayen",
  sk: "Slovacchia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Sud Sudan",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Swaziland",
  tc: "Isole Turks e Caicos",
  td: "Ciad",
  tg: "Togo",
  th: "Thailandia",
  tj: "Tagikistan",
  tk: "Tokelau",
  tl: "Timor Est",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turchia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ucraina",
  ug: "Uganda",
  us: "Stati Uniti",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Città del Vaticano",
  vc: "Saint Vincent e Grenadine",
  ve: "Venezuela",
  vg: "Isole Vergini Britanniche",
  vi: "Isole Vergini Americane",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudafrica",
  zm: "Zambia",
  zw: "Zimbabwe"
}, xs = {
  selectedCountryAriaLabel: "Paese selezionato",
  noCountrySelected: "Nessun paese selezionato",
  countryListAriaLabel: "Elenco dei paesi",
  searchPlaceholder: "Ricerca",
  zeroSearchResults: "Nessun risultato trovato",
  oneSearchResult: "1 risultato trovato",
  multipleSearchResults: "${count} risultati trovati",
  // additional countries (not supported by country-list library)
  ac: "Isola di Ascensione",
  xk: "Kosovo"
}, Cs = { ...ws, ...xs }, Ss = {
  ad: "Andorra",
  ae: "Verenigde Arabische Emiraten",
  af: "Afghanistan",
  ag: "Antigua en Barbuda",
  ai: "Anguilla",
  al: "Albanië",
  am: "Armenië",
  ao: "Angola",
  ar: "Argentinië",
  as: "Amerikaans-Samoa",
  at: "Oostenrijk",
  au: "Australië",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbeidzjan",
  ba: "Bosnië en Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "België",
  bf: "Burkina Faso",
  bg: "Bulgarije",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribisch Nederland",
  br: "Brazilië",
  bs: "Bahama’s",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocoseilanden",
  cd: "Congo-Kinshasa",
  cf: "Centraal-Afrikaanse Republiek",
  cg: "Congo-Brazzaville",
  ch: "Zwitserland",
  ci: "Ivoorkust",
  ck: "Cookeilanden",
  cl: "Chili",
  cm: "Kameroen",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kaapverdië",
  cw: "Curaçao",
  cx: "Christmaseiland",
  cy: "Cyprus",
  cz: "Tsjechië",
  de: "Duitsland",
  dj: "Djibouti",
  dk: "Denemarken",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  dz: "Algerije",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypte",
  eh: "Westelijke Sahara",
  er: "Eritrea",
  es: "Spanje",
  et: "Ethiopië",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandeilanden",
  fm: "Micronesia",
  fo: "Faeröer",
  fr: "Frankrijk",
  ga: "Gabon",
  gb: "Verenigd Koninkrijk",
  gd: "Grenada",
  ge: "Georgië",
  gf: "Frans-Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambia",
  gn: "Guinee",
  gp: "Guadeloupe",
  gq: "Equatoriaal-Guinea",
  gr: "Griekenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  hk: "Hongkong SAR van China",
  hn: "Honduras",
  hr: "Kroatië",
  ht: "Haïti",
  hu: "Hongarije",
  id: "Indonesië",
  ie: "Ierland",
  il: "Israël",
  im: "Isle of Man",
  in: "India",
  io: "Brits Indische Oceaanterritorium",
  iq: "Irak",
  ir: "Iran",
  is: "IJsland",
  it: "Italië",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanië",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgizië",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comoren",
  kn: "Saint Kitts en Nevis",
  kp: "Noord-Korea",
  kr: "Zuid-Korea",
  kw: "Koeweit",
  ky: "Kaaimaneilanden",
  kz: "Kazachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litouwen",
  lu: "Luxemburg",
  lv: "Letland",
  ly: "Libië",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldavië",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalleilanden",
  mk: "Noord-Macedonië",
  ml: "Mali",
  mm: "Myanmar (Birma)",
  mn: "Mongolië",
  mo: "Macau SAR van China",
  mp: "Noordelijke Marianen",
  mq: "Martinique",
  mr: "Mauritanië",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiven",
  mw: "Malawi",
  mx: "Mexico",
  my: "Maleisië",
  mz: "Mozambique",
  na: "Namibië",
  nc: "Nieuw-Caledonië",
  ne: "Niger",
  nf: "Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Noorwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nieuw-Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Frans-Polynesië",
  pg: "Papoea-Nieuw-Guinea",
  ph: "Filipijnen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre en Miquelon",
  pr: "Puerto Rico",
  ps: "Palestijnse gebieden",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  rs: "Servië",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saoedi-Arabië",
  sb: "Salomonseilanden",
  sc: "Seychellen",
  sd: "Soedan",
  se: "Zweden",
  sg: "Singapore",
  sh: "Sint-Helena",
  si: "Slovenië",
  sj: "Spitsbergen en Jan Mayen",
  sk: "Slowakije",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalië",
  sr: "Suriname",
  ss: "Zuid-Soedan",
  st: "Sao Tomé en Principe",
  sv: "El Salvador",
  sx: "Sint-Maarten",
  sy: "Syrië",
  sz: "eSwatini",
  tc: "Turks- en Caicoseilanden",
  td: "Tsjaad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Oost-Timor",
  tm: "Turkmenistan",
  tn: "Tunesië",
  to: "Tonga",
  tr: "Turkije",
  tt: "Trinidad en Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Oekraïne",
  ug: "Oeganda",
  us: "Verenigde Staten",
  uy: "Uruguay",
  uz: "Oezbekistan",
  va: "Vaticaanstad",
  vc: "Saint Vincent en de Grenadines",
  ve: "Venezuela",
  vg: "Britse Maagdeneilanden",
  vi: "Amerikaanse Maagdeneilanden",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis en Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Zuid-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, zs = {
  selectedCountryAriaLabel: "Geselecteerd land",
  noCountrySelected: "Geen land geselecteerd",
  countryListAriaLabel: "Lijst met landen",
  searchPlaceholder: "Zoekopdracht",
  zeroSearchResults: "Geen resultaten gevonden",
  oneSearchResult: "1 resultaat gevonden",
  multipleSearchResults: "${count} resultaten gevonden",
  // additional countries (not supported by country-list library)
  ac: "Ascension-eiland",
  xk: "Kosovo"
}, xo = { ...Ss, ...zs }, As = {
  ad: "Andorra",
  ae: "Emirados Árabes Unidos",
  af: "Afeganistão",
  ag: "Antígua e Barbuda",
  ai: "Anguila",
  al: "Albânia",
  am: "Armênia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Áustria",
  au: "Austrália",
  aw: "Aruba",
  ax: "Ilhas Aland",
  az: "Azerbaijão",
  ba: "Bósnia e Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bélgica",
  bf: "Burquina Faso",
  bg: "Bulgária",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "São Bartolomeu",
  bm: "Bermudas",
  bn: "Brunei",
  bo: "Bolívia",
  bq: "Países Baixos Caribenhos",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Butão",
  bw: "Botsuana",
  by: "Bielorrússia",
  bz: "Belize",
  ca: "Canadá",
  cc: "Ilhas Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  ch: "Suíça",
  ci: "Costa do Marfim",
  ck: "Ilhas Cook",
  cl: "Chile",
  cm: "Camarões",
  cn: "China",
  co: "Colômbia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Ilha Christmas",
  cy: "Chipre",
  cz: "Tchéquia",
  de: "Alemanha",
  dj: "Djibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argélia",
  ec: "Equador",
  ee: "Estônia",
  eg: "Egito",
  eh: "Saara Ocidental",
  er: "Eritreia",
  es: "Espanha",
  et: "Etiópia",
  fi: "Finlândia",
  fj: "Fiji",
  fk: "Ilhas Malvinas",
  fm: "Micronésia",
  fo: "Ilhas Faroe",
  fr: "França",
  ga: "Gabão",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Geórgia",
  gf: "Guiana Francesa",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Groenlândia",
  gm: "Gâmbia",
  gn: "Guiné",
  gp: "Guadalupe",
  gq: "Guiné Equatorial",
  gr: "Grécia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  hk: "Hong Kong, RAE da China",
  hn: "Honduras",
  hr: "Croácia",
  ht: "Haiti",
  hu: "Hungria",
  id: "Indonésia",
  ie: "Irlanda",
  il: "Israel",
  im: "Ilha de Man",
  in: "Índia",
  io: "Território Britânico do Oceano Índico",
  iq: "Iraque",
  ir: "Irã",
  is: "Islândia",
  it: "Itália",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordânia",
  jp: "Japão",
  ke: "Quênia",
  kg: "Quirguistão",
  kh: "Camboja",
  ki: "Quiribati",
  km: "Comores",
  kn: "São Cristóvão e Névis",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  kw: "Kuwait",
  ky: "Ilhas Cayman",
  kz: "Cazaquistão",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lúcia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesoto",
  lt: "Lituânia",
  lu: "Luxemburgo",
  lv: "Letônia",
  ly: "Líbia",
  ma: "Marrocos",
  mc: "Mônaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "São Martinho",
  mg: "Madagascar",
  mh: "Ilhas Marshall",
  mk: "Macedônia do Norte",
  ml: "Mali",
  mm: "Mianmar (Birmânia)",
  mn: "Mongólia",
  mo: "Macau, RAE da China",
  mp: "Ilhas Marianas do Norte",
  mq: "Martinica",
  mr: "Mauritânia",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Maurício",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malásia",
  mz: "Moçambique",
  na: "Namíbia",
  nc: "Nova Caledônia",
  ne: "Níger",
  nf: "Ilha Norfolk",
  ng: "Nigéria",
  ni: "Nicarágua",
  nl: "Países Baixos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nova Zelândia",
  om: "Omã",
  pa: "Panamá",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pg: "Papua-Nova Guiné",
  ph: "Filipinas",
  pk: "Paquistão",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pr: "Porto Rico",
  ps: "Territórios palestinos",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguai",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  rs: "Sérvia",
  ru: "Rússia",
  rw: "Ruanda",
  sa: "Arábia Saudita",
  sb: "Ilhas Salomão",
  sc: "Seicheles",
  sd: "Sudão",
  se: "Suécia",
  sg: "Singapura",
  sh: "Santa Helena",
  si: "Eslovênia",
  sj: "Svalbard e Jan Mayen",
  sk: "Eslováquia",
  sl: "Serra Leoa",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somália",
  sr: "Suriname",
  ss: "Sudão do Sul",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Síria",
  sz: "Essuatíni",
  tc: "Ilhas Turcas e Caicos",
  td: "Chade",
  tg: "Togo",
  th: "Tailândia",
  tj: "Tadjiquistão",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turcomenistão",
  tn: "Tunísia",
  to: "Tonga",
  tr: "Turquia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzânia",
  ua: "Ucrânia",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  va: "Cidade do Vaticano",
  vc: "São Vicente e Granadinas",
  ve: "Venezuela",
  vg: "Ilhas Virgens Britânicas",
  vi: "Ilhas Virgens Americanas",
  vn: "Vietnã",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Iêmen",
  yt: "Mayotte",
  za: "África do Sul",
  zm: "Zâmbia",
  zw: "Zimbábue"
}, Ps = {
  selectedCountryAriaLabel: "País selecionado",
  noCountrySelected: "Nenhum país selecionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Procurar",
  zeroSearchResults: "Nenhum resultado encontrado",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "Ilha de Ascensão",
  xk: "Kosovo"
}, Ms = { ...As, ...Ps }, Ds = {
  ad: "Andorra",
  ae: "Förenade Arabemiraten",
  af: "Afghanistan",
  ag: "Antigua och Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikanska Samoa",
  at: "Österrike",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbajdzjan",
  ba: "Bosnien och Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "S:t Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibiska Nederländerna",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Vitryssland",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosöarna",
  cd: "Kongo-Kinshasa",
  cf: "Centralafrikanska republiken",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cooköarna",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Julön",
  cy: "Cypern",
  cz: "Tjeckien",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Dominikanska republiken",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Västsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsöarna",
  fm: "Mikronesien",
  fo: "Färöarna",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Franska Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorialguinea",
  gr: "Grekland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungern",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Brittiska territoriet i Indiska oceanen",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgizistan",
  kh: "Kambodja",
  ki: "Kiribati",
  km: "Komorerna",
  kn: "S:t Kitts och Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanöarna",
  kz: "Kazakstan",
  la: "Laos",
  lb: "Libanon",
  lc: "S:t Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marocko",
  mc: "Monaco",
  md: "Moldavien",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshallöarna",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "Macao",
  mp: "Nordmarianerna",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverna",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Moçambique",
  na: "Namibia",
  nc: "Nya Kaledonien",
  ne: "Niger",
  nf: "Norfolkön",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederländerna",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nya Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Franska Polynesien",
  pg: "Papua Nya Guinea",
  ph: "Filippinerna",
  pk: "Pakistan",
  pl: "Polen",
  pm: "S:t Pierre och Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinska territorierna",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Ryssland",
  rw: "Rwanda",
  sa: "Saudiarabien",
  sb: "Salomonöarna",
  sc: "Seychellerna",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "S:t Helena",
  si: "Slovenien",
  sj: "Svalbard och Jan Mayen",
  sk: "Slovakien",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé och Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Swaziland",
  tc: "Turks- och Caicosöarna",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Östtimor",
  tm: "Turkmenistan",
  tn: "Tunisien",
  to: "Tonga",
  tr: "Turkiet",
  tt: "Trinidad och Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatikanstaten",
  vc: "S:t Vincent och Grenadinerna",
  ve: "Venezuela",
  vg: "Brittiska Jungfruöarna",
  vi: "Amerikanska Jungfruöarna",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis- och Futunaöarna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, Ns = {
  selectedCountryAriaLabel: "Valt land",
  noCountrySelected: "Inget land valt",
  countryListAriaLabel: "Lista över länder",
  searchPlaceholder: "Sök",
  zeroSearchResults: "Inga resultat hittades",
  oneSearchResult: "1 resultat hittades",
  multipleSearchResults: "${count} resultat hittades",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, Os = { ...Ds, ...Ns }, Is = {
  en: gs,
  fr: ys,
  it: Cs,
  es: hs,
  de: us,
  da: ls,
  hr: $s,
  nb: xo,
  nl: xo,
  pt: Ms,
  sv: Os
}, Co = {
  error: "is-error"
}, So = {
  error: {
    name: "error-warning-fill",
    color: "error"
  }
}, js = "_title_ej2xw_37", Ls = "_text_ej2xw_41", Xe = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: js,
  text: Ls,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function wa({
  children: e,
  defaultValue: t,
  label: a,
  helperContent: o,
  errorMessage: n,
  disabled: r,
  onChange: i,
  onBlur: l,
  value: c,
  name: s
}) {
  const u = !!n, d = !!(a ?? o);
  return /* @__PURE__ */ R(
    Yl,
    {
      name: s,
      onValueChange: i,
      defaultValue: t,
      className: H(Xe["radio-group"], n && Xe["has-error"]),
      disabled: r,
      onBlur: l,
      value: c,
      children: [
        d && /* @__PURE__ */ R("div", { className: Xe["group-label"], children: [
          a && /* @__PURE__ */ p("label", { className: Xe.title, children: a }),
          o && /* @__PURE__ */ p("p", { className: Xe.text, children: o })
        ] }),
        e,
        u && /* @__PURE__ */ R("p", { className: Xe["error-message"], children: [
          /* @__PURE__ */ p(Ke, { name: "error-warning-fill", color: "error" }),
          n
        ] })
      ]
    }
  );
}
wa.Item = as;
var Es = [
  [
    "af",
    // Afghanistan
    "93"
  ],
  [
    "ax",
    // Åland Islands
    "358",
    1
  ],
  [
    "al",
    // Albania
    "355"
  ],
  [
    "dz",
    // Algeria
    "213"
  ],
  [
    "as",
    // American Samoa
    "1",
    5,
    ["684"]
  ],
  [
    "ad",
    // Andorra
    "376"
  ],
  [
    "ao",
    // Angola
    "244"
  ],
  [
    "ai",
    // Anguilla
    "1",
    6,
    ["264"]
  ],
  [
    "ag",
    // Antigua and Barbuda
    "1",
    7,
    ["268"]
  ],
  [
    "ar",
    // Argentina
    "54"
  ],
  [
    "am",
    // Armenia
    "374"
  ],
  [
    "aw",
    // Aruba
    "297"
  ],
  [
    "ac",
    // Ascension Island
    "247"
  ],
  [
    "au",
    // Australia
    "61",
    0,
    null,
    "0"
  ],
  [
    "at",
    // Austria
    "43"
  ],
  [
    "az",
    // Azerbaijan
    "994"
  ],
  [
    "bs",
    // Bahamas
    "1",
    8,
    ["242"]
  ],
  [
    "bh",
    // Bahrain
    "973"
  ],
  [
    "bd",
    // Bangladesh
    "880"
  ],
  [
    "bb",
    // Barbados
    "1",
    9,
    ["246"]
  ],
  [
    "by",
    // Belarus
    "375"
  ],
  [
    "be",
    // Belgium
    "32"
  ],
  [
    "bz",
    // Belize
    "501"
  ],
  [
    "bj",
    // Benin
    "229"
  ],
  [
    "bm",
    // Bermuda
    "1",
    10,
    ["441"]
  ],
  [
    "bt",
    // Bhutan
    "975"
  ],
  [
    "bo",
    // Bolivia
    "591"
  ],
  [
    "ba",
    // Bosnia and Herzegovina
    "387"
  ],
  [
    "bw",
    // Botswana
    "267"
  ],
  [
    "br",
    // Brazil
    "55"
  ],
  [
    "io",
    // British Indian Ocean Territory
    "246"
  ],
  [
    "vg",
    // British Virgin Islands
    "1",
    11,
    ["284"]
  ],
  [
    "bn",
    // Brunei
    "673"
  ],
  [
    "bg",
    // Bulgaria
    "359"
  ],
  [
    "bf",
    // Burkina Faso
    "226"
  ],
  [
    "bi",
    // Burundi
    "257"
  ],
  [
    "kh",
    // Cambodia
    "855"
  ],
  [
    "cm",
    // Cameroon
    "237"
  ],
  [
    "ca",
    // Canada
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
  ],
  [
    "cv",
    // Cape Verde
    "238"
  ],
  [
    "bq",
    // Caribbean Netherlands
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "ky",
    // Cayman Islands
    "1",
    12,
    ["345"]
  ],
  [
    "cf",
    // Central African Republic
    "236"
  ],
  [
    "td",
    // Chad
    "235"
  ],
  [
    "cl",
    // Chile
    "56"
  ],
  [
    "cn",
    // China
    "86"
  ],
  [
    "cx",
    // Christmas Island
    "61",
    2,
    ["89164"],
    "0"
  ],
  [
    "cc",
    // Cocos (Keeling) Islands
    "61",
    1,
    ["89162"],
    "0"
  ],
  [
    "co",
    // Colombia
    "57"
  ],
  [
    "km",
    // Comoros
    "269"
  ],
  [
    "cg",
    // Congo (Brazzaville)
    "242"
  ],
  [
    "cd",
    // Congo (Kinshasa)
    "243"
  ],
  [
    "ck",
    // Cook Islands
    "682"
  ],
  [
    "cr",
    // Costa Rica
    "506"
  ],
  [
    "ci",
    // Côte d'Ivoire
    "225"
  ],
  [
    "hr",
    // Croatia
    "385"
  ],
  [
    "cu",
    // Cuba
    "53"
  ],
  [
    "cw",
    // Curaçao
    "599",
    0
  ],
  [
    "cy",
    // Cyprus
    "357"
  ],
  [
    "cz",
    // Czech Republic
    "420"
  ],
  [
    "dk",
    // Denmark
    "45"
  ],
  [
    "dj",
    // Djibouti
    "253"
  ],
  [
    "dm",
    // Dominica
    "1",
    13,
    ["767"]
  ],
  [
    "do",
    // Dominican Republic
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "ec",
    // Ecuador
    "593"
  ],
  [
    "eg",
    // Egypt
    "20"
  ],
  [
    "sv",
    // El Salvador
    "503"
  ],
  [
    "gq",
    // Equatorial Guinea
    "240"
  ],
  [
    "er",
    // Eritrea
    "291"
  ],
  [
    "ee",
    // Estonia
    "372"
  ],
  [
    "sz",
    // Eswatini
    "268"
  ],
  [
    "et",
    // Ethiopia
    "251"
  ],
  [
    "fk",
    // Falkland Islands (Malvinas)
    "500"
  ],
  [
    "fo",
    // Faroe Islands
    "298"
  ],
  [
    "fj",
    // Fiji
    "679"
  ],
  [
    "fi",
    // Finland
    "358",
    0
  ],
  [
    "fr",
    // France
    "33"
  ],
  [
    "gf",
    // French Guiana
    "594"
  ],
  [
    "pf",
    // French Polynesia
    "689"
  ],
  [
    "ga",
    // Gabon
    "241"
  ],
  [
    "gm",
    // Gambia
    "220"
  ],
  [
    "ge",
    // Georgia
    "995"
  ],
  [
    "de",
    // Germany
    "49"
  ],
  [
    "gh",
    // Ghana
    "233"
  ],
  [
    "gi",
    // Gibraltar
    "350"
  ],
  [
    "gr",
    // Greece
    "30"
  ],
  [
    "gl",
    // Greenland
    "299"
  ],
  [
    "gd",
    // Grenada
    "1",
    14,
    ["473"]
  ],
  [
    "gp",
    // Guadeloupe
    "590",
    0
  ],
  [
    "gu",
    // Guam
    "1",
    15,
    ["671"]
  ],
  [
    "gt",
    // Guatemala
    "502"
  ],
  [
    "gg",
    // Guernsey
    "44",
    1,
    ["1481", "7781", "7839", "7911"],
    "0"
  ],
  [
    "gn",
    // Guinea
    "224"
  ],
  [
    "gw",
    // Guinea-Bissau
    "245"
  ],
  [
    "gy",
    // Guyana
    "592"
  ],
  [
    "ht",
    // Haiti
    "509"
  ],
  [
    "hn",
    // Honduras
    "504"
  ],
  [
    "hk",
    // Hong Kong SAR China
    "852"
  ],
  [
    "hu",
    // Hungary
    "36"
  ],
  [
    "is",
    // Iceland
    "354"
  ],
  [
    "in",
    // India
    "91"
  ],
  [
    "id",
    // Indonesia
    "62"
  ],
  [
    "ir",
    // Iran
    "98"
  ],
  [
    "iq",
    // Iraq
    "964"
  ],
  [
    "ie",
    // Ireland
    "353"
  ],
  [
    "im",
    // Isle of Man
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"],
    "0"
  ],
  [
    "il",
    // Israel
    "972"
  ],
  [
    "it",
    // Italy
    "39",
    0
  ],
  [
    "jm",
    // Jamaica
    "1",
    4,
    ["876", "658"]
  ],
  [
    "jp",
    // Japan
    "81"
  ],
  [
    "je",
    // Jersey
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"],
    "0"
  ],
  [
    "jo",
    // Jordan
    "962"
  ],
  [
    "kz",
    // Kazakhstan
    "7",
    1,
    ["33", "7"],
    "8"
  ],
  [
    "ke",
    // Kenya
    "254"
  ],
  [
    "ki",
    // Kiribati
    "686"
  ],
  [
    "xk",
    // Kosovo
    "383"
  ],
  [
    "kw",
    // Kuwait
    "965"
  ],
  [
    "kg",
    // Kyrgyzstan
    "996"
  ],
  [
    "la",
    // Laos
    "856"
  ],
  [
    "lv",
    // Latvia
    "371"
  ],
  [
    "lb",
    // Lebanon
    "961"
  ],
  [
    "ls",
    // Lesotho
    "266"
  ],
  [
    "lr",
    // Liberia
    "231"
  ],
  [
    "ly",
    // Libya
    "218"
  ],
  [
    "li",
    // Liechtenstein
    "423"
  ],
  [
    "lt",
    // Lithuania
    "370"
  ],
  [
    "lu",
    // Luxembourg
    "352"
  ],
  [
    "mo",
    // Macao SAR China
    "853"
  ],
  [
    "mg",
    // Madagascar
    "261"
  ],
  [
    "mw",
    // Malawi
    "265"
  ],
  [
    "my",
    // Malaysia
    "60"
  ],
  [
    "mv",
    // Maldives
    "960"
  ],
  [
    "ml",
    // Mali
    "223"
  ],
  [
    "mt",
    // Malta
    "356"
  ],
  [
    "mh",
    // Marshall Islands
    "692"
  ],
  [
    "mq",
    // Martinique
    "596"
  ],
  [
    "mr",
    // Mauritania
    "222"
  ],
  [
    "mu",
    // Mauritius
    "230"
  ],
  [
    "yt",
    // Mayotte
    "262",
    1,
    ["269", "639"],
    "0"
  ],
  [
    "mx",
    // Mexico
    "52"
  ],
  [
    "fm",
    // Micronesia
    "691"
  ],
  [
    "md",
    // Moldova
    "373"
  ],
  [
    "mc",
    // Monaco
    "377"
  ],
  [
    "mn",
    // Mongolia
    "976"
  ],
  [
    "me",
    // Montenegro
    "382"
  ],
  [
    "ms",
    // Montserrat
    "1",
    16,
    ["664"]
  ],
  [
    "ma",
    // Morocco
    "212",
    0,
    null,
    "0"
  ],
  [
    "mz",
    // Mozambique
    "258"
  ],
  [
    "mm",
    // Myanmar (Burma)
    "95"
  ],
  [
    "na",
    // Namibia
    "264"
  ],
  [
    "nr",
    // Nauru
    "674"
  ],
  [
    "np",
    // Nepal
    "977"
  ],
  [
    "nl",
    // Netherlands
    "31"
  ],
  [
    "nc",
    // New Caledonia
    "687"
  ],
  [
    "nz",
    // New Zealand
    "64"
  ],
  [
    "ni",
    // Nicaragua
    "505"
  ],
  [
    "ne",
    // Niger
    "227"
  ],
  [
    "ng",
    // Nigeria
    "234"
  ],
  [
    "nu",
    // Niue
    "683"
  ],
  [
    "nf",
    // Norfolk Island
    "672"
  ],
  [
    "kp",
    // North Korea
    "850"
  ],
  [
    "mk",
    // North Macedonia
    "389"
  ],
  [
    "mp",
    // Northern Mariana Islands
    "1",
    17,
    ["670"]
  ],
  [
    "no",
    // Norway
    "47",
    0
  ],
  [
    "om",
    // Oman
    "968"
  ],
  [
    "pk",
    // Pakistan
    "92"
  ],
  [
    "pw",
    // Palau
    "680"
  ],
  [
    "ps",
    // Palestinian Territories
    "970"
  ],
  [
    "pa",
    // Panama
    "507"
  ],
  [
    "pg",
    // Papua New Guinea
    "675"
  ],
  [
    "py",
    // Paraguay
    "595"
  ],
  [
    "pe",
    // Peru
    "51"
  ],
  [
    "ph",
    // Philippines
    "63"
  ],
  [
    "pl",
    // Poland
    "48"
  ],
  [
    "pt",
    // Portugal
    "351"
  ],
  [
    "pr",
    // Puerto Rico
    "1",
    3,
    ["787", "939"]
  ],
  [
    "qa",
    // Qatar
    "974"
  ],
  [
    "re",
    // Réunion
    "262",
    0,
    null,
    "0"
  ],
  [
    "ro",
    // Romania
    "40"
  ],
  [
    "ru",
    // Russia
    "7",
    0,
    null,
    "8"
  ],
  [
    "rw",
    // Rwanda
    "250"
  ],
  [
    "ws",
    // Samoa
    "685"
  ],
  [
    "sm",
    // San Marino
    "378"
  ],
  [
    "st",
    // São Tomé & Príncipe
    "239"
  ],
  [
    "sa",
    // Saudi Arabia
    "966"
  ],
  [
    "sn",
    // Senegal
    "221"
  ],
  [
    "rs",
    // Serbia
    "381"
  ],
  [
    "sc",
    // Seychelles
    "248"
  ],
  [
    "sl",
    // Sierra Leone
    "232"
  ],
  [
    "sg",
    // Singapore
    "65"
  ],
  [
    "sx",
    // Sint Maarten
    "1",
    21,
    ["721"]
  ],
  [
    "sk",
    // Slovakia
    "421"
  ],
  [
    "si",
    // Slovenia
    "386"
  ],
  [
    "sb",
    // Solomon Islands
    "677"
  ],
  [
    "so",
    // Somalia
    "252"
  ],
  [
    "za",
    // South Africa
    "27"
  ],
  [
    "kr",
    // South Korea
    "82"
  ],
  [
    "ss",
    // South Sudan
    "211"
  ],
  [
    "es",
    // Spain
    "34"
  ],
  [
    "lk",
    // Sri Lanka
    "94"
  ],
  [
    "bl",
    // St. Barthélemy
    "590",
    1
  ],
  [
    "sh",
    // St. Helena
    "290"
  ],
  [
    "kn",
    // St. Kitts & Nevis
    "1",
    18,
    ["869"]
  ],
  [
    "lc",
    // St. Lucia
    "1",
    19,
    ["758"]
  ],
  [
    "mf",
    // St. Martin
    "590",
    2
  ],
  [
    "pm",
    // St. Pierre & Miquelon
    "508"
  ],
  [
    "vc",
    // St. Vincent & Grenadines
    "1",
    20,
    ["784"]
  ],
  [
    "sd",
    // Sudan
    "249"
  ],
  [
    "sr",
    // Suriname
    "597"
  ],
  [
    "sj",
    // Svalbard & Jan Mayen
    "47",
    1,
    ["79"]
  ],
  [
    "se",
    // Sweden
    "46"
  ],
  [
    "ch",
    // Switzerland
    "41"
  ],
  [
    "sy",
    // Syria
    "963"
  ],
  [
    "tw",
    // Taiwan
    "886"
  ],
  [
    "tj",
    // Tajikistan
    "992"
  ],
  [
    "tz",
    // Tanzania
    "255"
  ],
  [
    "th",
    // Thailand
    "66"
  ],
  [
    "tl",
    // Timor-Leste
    "670"
  ],
  [
    "tg",
    // Togo
    "228"
  ],
  [
    "tk",
    // Tokelau
    "690"
  ],
  [
    "to",
    // Tonga
    "676"
  ],
  [
    "tt",
    // Trinidad & Tobago
    "1",
    22,
    ["868"]
  ],
  [
    "tn",
    // Tunisia
    "216"
  ],
  [
    "tr",
    // Turkey
    "90"
  ],
  [
    "tm",
    // Turkmenistan
    "993"
  ],
  [
    "tc",
    // Turks & Caicos Islands
    "1",
    23,
    ["649"]
  ],
  [
    "tv",
    // Tuvalu
    "688"
  ],
  [
    "vi",
    // U.S. Virgin Islands
    "1",
    24,
    ["340"]
  ],
  [
    "ug",
    // Uganda
    "256"
  ],
  [
    "ua",
    // Ukraine
    "380"
  ],
  [
    "ae",
    // United Arab Emirates
    "971"
  ],
  [
    "gb",
    // United Kingdom
    "44",
    0,
    null,
    "0"
  ],
  [
    "us",
    // United States
    "1",
    0
  ],
  [
    "uy",
    // Uruguay
    "598"
  ],
  [
    "uz",
    // Uzbekistan
    "998"
  ],
  [
    "vu",
    // Vanuatu
    "678"
  ],
  [
    "va",
    // Vatican City
    "39",
    1,
    ["06698"]
  ],
  [
    "ve",
    // Venezuela
    "58"
  ],
  [
    "vn",
    // Vietnam
    "84"
  ],
  [
    "wf",
    // Wallis & Futuna
    "681"
  ],
  [
    "eh",
    // Western Sahara
    "212",
    1,
    ["5288", "5289"],
    "0"
  ],
  [
    "ye",
    // Yemen
    "967"
  ],
  [
    "zm",
    // Zambia
    "260"
  ],
  [
    "zw",
    // Zimbabwe
    "263"
  ]
], ir = [];
for (const e of Es)
  ir.push({
    name: "",
    // populated in the plugin
    iso2: e[0],
    dialCode: e[1],
    priority: e[2] || 0,
    areaCodes: e[3] || null,
    nodeById: {},
    // populated by the plugin
    nationalPrefix: e[4] || null
  });
var at = ir, Bs = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, Ts = Bs, Rs = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, Fs = Rs, Vs = { ...Ts, ...Fs }, lr = Vs, fa = (e) => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(e).matches, Gs = () => {
  if (typeof navigator < "u" && typeof window < "u") {
    const e = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), t = fa("(max-width: 500px)"), a = fa("(max-height: 600px)"), o = fa("(pointer: coarse)");
    return e || t || o && a;
  }
  return !1;
}, sr = {
  // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
  allowPhonewords: !1,
  //* Whether or not to allow the dropdown.
  allowDropdown: !0,
  //* Add a placeholder in the input with an example number for the selected country.
  autoPlaceholder: "polite",
  //* Modify the parentClass.
  containerClass: "",
  //* The order of the countries in the dropdown. Defaults to alphabetical.
  countryOrder: null,
  //* Add a country search input at the top of the dropdown.
  countrySearch: !0,
  //* Modify the auto placeholder.
  customPlaceholder: null,
  //* Append menu to specified element.
  dropdownContainer: null,
  //* Don't display these countries.
  excludeCountries: [],
  //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
  fixDropdownWidth: !0,
  //* Format the number as the user types
  formatAsYouType: !0,
  //* Format the input value during initialisation and on setNumber.
  formatOnDisplay: !0,
  //* geoIp lookup function.
  geoIpLookup: null,
  //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
  hiddenInput: null,
  //* Internationalise the plugin text e.g. search input placeholder, country names.
  i18n: {},
  //* Initial country.
  initialCountry: "",
  //* A function to load the utils script.
  loadUtils: null,
  //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
  nationalMode: !0,
  //* Display only these countries.
  onlyCountries: [],
  //* Number type to use for placeholders.
  placeholderNumberType: "MOBILE",
  //* Show flags - for both the selected country, and in the country dropdown
  showFlags: !0,
  //* Display the international dial code next to the selected flag.
  separateDialCode: !1,
  //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
  strictMode: !1,
  //* Use full screen popup instead of dropdown for country list.
  useFullscreenPopup: Gs(),
  //* The number type to enforce during validation.
  validationNumberTypes: ["MOBILE"]
};
function Us(e) {
  e.useFullscreenPopup && (e.fixDropdownWidth = !1), e.onlyCountries.length === 1 && (e.initialCountry = e.onlyCountries[0]), e.separateDialCode && (e.nationalMode = !1), e.allowDropdown && !e.showFlags && !e.separateDialCode && (e.nationalMode = !1), e.useFullscreenPopup && !e.dropdownContainer && (e.dropdownContainer = document.body), e.i18n = { ...lr, ...e.i18n };
}
var Lt = (e) => e.replace(/\D/g, ""), cr = (e = "") => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), ne = (e, t, a) => {
  const o = document.createElement(e);
  return t && Object.entries(t).forEach(([n, r]) => o.setAttribute(n, r)), a && a.appendChild(o), o;
};
function Zs(e) {
  const { onlyCountries: t, excludeCountries: a } = e;
  if (t.length) {
    const o = t.map((n) => n.toLowerCase());
    return at.filter((n) => o.includes(n.iso2));
  } else if (a.length) {
    const o = a.map((n) => n.toLowerCase());
    return at.filter((n) => !o.includes(n.iso2));
  }
  return at;
}
function Ws(e, t) {
  for (const a of e) {
    const o = a.iso2.toLowerCase();
    t.i18n[o] && (a.name = t.i18n[o]);
  }
}
function Ks(e, t) {
  const a = /* @__PURE__ */ new Set();
  let o = 0;
  const n = {}, r = (i, l, c) => {
    if (!i || !l)
      return;
    l.length > o && (o = l.length), n.hasOwnProperty(l) || (n[l] = []);
    const s = n[l];
    if (s.includes(i))
      return;
    const u = c !== void 0 ? c : s.length;
    s[u] = i;
  };
  for (const i of e)
    a.has(i.dialCode) || a.add(i.dialCode), r(i.iso2, i.dialCode, i.priority);
  (t.onlyCountries.length || t.excludeCountries.length) && a.forEach((i) => {
    n[i] = n[i].filter(Boolean);
  });
  for (const i of e)
    if (i.areaCodes) {
      const l = n[i.dialCode][0];
      for (const c of i.areaCodes) {
        for (let s = 1; s < c.length; s++) {
          const u = c.substring(0, s), d = i.dialCode + u;
          r(l, d), r(i.iso2, d);
        }
        r(i.iso2, i.dialCode + c);
      }
    }
  return { dialCodes: a, dialCodeMaxLen: o, dialCodeToIso2Map: n };
}
function qs(e, t) {
  t.countryOrder && (t.countryOrder = t.countryOrder.map((a) => a.toLowerCase())), e.sort((a, o) => {
    const { countryOrder: n } = t;
    if (n) {
      const r = n.indexOf(a.iso2), i = n.indexOf(o.iso2), l = r > -1, c = i > -1;
      if (l || c)
        return l && c ? r - i : l ? -1 : 1;
    }
    return a.name.localeCompare(o.name);
  });
}
function Hs(e) {
  for (const t of e)
    t.normalisedName = cr(t.name), t.initials = t.name.split(/[^a-zA-ZÀ-ÿа-яА-Я]/).map((a) => a[0]).join("").toLowerCase(), t.dialCodePlus = `+${t.dialCode}`;
}
function Js(e, t, a, o) {
  let n = e;
  if (a && t) {
    t = `+${o.dialCode}`;
    const r = n[t.length] === " " || n[t.length] === "-" ? t.length + 1 : t.length;
    n = n.substring(r);
  }
  return n;
}
function Ys(e, t, a, o, n) {
  const r = a ? a.formatNumberAsYouType(e, o.iso2) : e, { dialCode: i } = o;
  return n && t.charAt(0) !== "+" && r.includes(`+${i}`) ? (r.split(`+${i}`)[1] || "").trim() : r;
}
function Qs(e, t, a, o) {
  if (a === 0 && !o)
    return 0;
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    if (/[+0-9]/.test(t[r]) && n++, n === e && !o)
      return r + 1;
    if (o && n === e + 1)
      return r;
  }
  return t.length;
}
var Xs = [
  "800",
  "822",
  "833",
  "844",
  "855",
  "866",
  "877",
  "880",
  "881",
  "882",
  "883",
  "884",
  "885",
  "886",
  "887",
  "888",
  "889"
], zo = (e) => {
  const t = Lt(e);
  if (t.charAt(0) === "1") {
    const a = t.substring(1, 4);
    return Xs.includes(a);
  }
  return !1;
};
for (const e of at)
  e.name = lr[e.iso2];
var ec = 0, tc = new Set(at.map((e) => e.iso2)), ba = (e) => tc.has(e), gt = (e, ...t) => {
  const { instances: a } = I;
  Object.values(a).forEach((o) => o[e](...t));
}, ac = class xa {
  /**
   * Build a space-delimited class string from an object map of className -> truthy/falsey.
   * Only keys with truthy values are included.
   */
  static _buildClassNames(t) {
    return Object.keys(t).filter((a) => !!t[a]).join(" ");
  }
  constructor(t, a = {}) {
    this.id = ec++, this.telInput = t, this.highlightedItem = null, this.options = Object.assign({}, sr, a), this.hadInitialPlaceholder = !!t.getAttribute("placeholder");
  }
  _detectEnvironmentAndLayout() {
    this.isAndroid = typeof navigator < "u" ? /Android/i.test(navigator.userAgent) : !1, this.isRTL = !!this.telInput.closest("[dir=rtl]"), this.telInput.dir = "ltr";
    const t = this.options.allowDropdown || this.options.separateDialCode;
    this.showSelectedCountryOnLeft = this.isRTL ? !t : t, this.options.separateDialCode && (this.isRTL ? this.originalPaddingRight = this.telInput.style.paddingRight : this.originalPaddingLeft = this.telInput.style.paddingLeft);
  }
  _createInitPromises() {
    const t = new Promise((o, n) => {
      this.resolveAutoCountryPromise = o, this.rejectAutoCountryPromise = n;
    }), a = new Promise((o, n) => {
      this.resolveUtilsScriptPromise = o, this.rejectUtilsScriptPromise = n;
    });
    this.promise = Promise.all([t, a]);
  }
  //* Can't be private as it's called from intlTelInput convenience wrapper.
  _init() {
    Us(this.options), this._detectEnvironmentAndLayout(), this._createInitPromises(), this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
  }
  //********************
  //*  PRIVATE METHODS
  //********************
  //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
  _processCountryData() {
    this.countries = Zs(this.options);
    const t = Ks(this.countries, this.options);
    this.dialCodes = t.dialCodes, this.dialCodeMaxLen = t.dialCodeMaxLen, this.dialCodeToIso2Map = t.dialCodeToIso2Map, Ws(this.countries, this.options), qs(this.countries, this.options), this.countryByIso2 = new Map(this.countries.map((a) => [a.iso2, a])), Hs(this.countries);
  }
  //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
  _generateMarkup() {
    this._prepareTelInput();
    const t = this._createWrapperAndInsert();
    this._maybeBuildCountryContainer(t), t.appendChild(this.telInput), this._maybeUpdateInputPaddingAndReveal(), this._maybeBuildHiddenInputs(t);
  }
  _prepareTelInput() {
    this.telInput.classList.add("iti__tel-input"), !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
  }
  _createWrapperAndInsert() {
    const {
      allowDropdown: t,
      showFlags: a,
      containerClass: o,
      useFullscreenPopup: n
    } = this.options, r = xa._buildClassNames({
      iti: !0,
      "iti--allow-dropdown": t,
      "iti--show-flags": a,
      "iti--inline-dropdown": !n,
      [o]: !!o
    }), i = ne("div", { class: r });
    return this.telInput.parentNode?.insertBefore(i, this.telInput), i;
  }
  _maybeBuildCountryContainer(t) {
    const {
      allowDropdown: a,
      separateDialCode: o,
      showFlags: n
    } = this.options;
    if (a || n || o) {
      this.countryContainer = ne(
        "div",
        // visibly hidden until we measure it's width to set the input padding correctly
        { class: "iti__country-container iti__v-hide" },
        t
      ), this.showSelectedCountryOnLeft ? this.countryContainer.style.left = "0px" : this.countryContainer.style.right = "0px", a ? (this.selectedCountry = ne(
        "button",
        {
          type: "button",
          class: "iti__selected-country",
          "aria-expanded": "false",
          "aria-label": this.options.i18n.noCountrySelected,
          "aria-haspopup": "dialog",
          "aria-controls": `iti-${this.id}__dropdown-content`
        },
        this.countryContainer
      ), this.telInput.disabled && this.selectedCountry.setAttribute("disabled", "true")) : this.selectedCountry = ne(
        "div",
        { class: "iti__selected-country" },
        this.countryContainer
      );
      const r = ne(
        "div",
        { class: "iti__selected-country-primary" },
        this.selectedCountry
      );
      this.selectedCountryInner = ne(
        "div",
        { class: "iti__flag" },
        r
      ), a && (this.dropdownArrow = ne(
        "div",
        { class: "iti__arrow", "aria-hidden": "true" },
        r
      )), o && (this.selectedDialCode = ne(
        "div",
        { class: "iti__selected-dial-code", dir: "ltr" },
        this.selectedCountry
      )), a && this._buildDropdownContent();
    }
  }
  _buildDropdownContent() {
    const {
      fixDropdownWidth: t,
      useFullscreenPopup: a,
      countrySearch: o,
      i18n: n,
      dropdownContainer: r,
      containerClass: i
    } = this.options, l = t ? "" : "iti--flexible-dropdown-width";
    if (this.dropdownContent = ne("div", {
      id: `iti-${this.id}__dropdown-content`,
      class: `iti__dropdown-content iti__hide ${l}`,
      role: "dialog",
      "aria-modal": "true"
    }), o && this._buildSearchUI(), this.countryList = ne(
      "ul",
      {
        class: "iti__country-list",
        id: `iti-${this.id}__country-listbox`,
        role: "listbox",
        "aria-label": n.countryListAriaLabel
      },
      this.dropdownContent
    ), this._appendListItems(), o && this._updateSearchResultsA11yText(), r) {
      const c = xa._buildClassNames({
        iti: !0,
        "iti--container": !0,
        "iti--fullscreen-popup": a,
        "iti--inline-dropdown": !a,
        [i]: !!i
      });
      this.dropdown = ne("div", { class: c }), this.dropdown.appendChild(this.dropdownContent);
    } else
      this.countryContainer.appendChild(this.dropdownContent);
  }
  _buildSearchUI() {
    const { i18n: t } = this.options, a = ne(
      "div",
      { class: "iti__search-input-wrapper" },
      this.dropdownContent
    );
    this.searchIcon = ne(
      "span",
      {
        class: "iti__search-icon",
        "aria-hidden": "true"
      },
      a
    ), this.searchIcon.innerHTML = `
      <svg class="iti__search-icon-svg" width="14" height="14" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>`, this.searchInput = ne(
      "input",
      {
        id: `iti-${this.id}__search-input`,
        // Chrome says inputs need either a name or an id
        type: "search",
        class: "iti__search-input",
        placeholder: t.searchPlaceholder,
        // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
        role: "combobox",
        "aria-expanded": "true",
        "aria-label": t.searchPlaceholder,
        "aria-controls": `iti-${this.id}__country-listbox`,
        "aria-autocomplete": "list",
        autocomplete: "off"
      },
      a
    ), this.searchClearButton = ne(
      "button",
      {
        type: "button",
        class: "iti__search-clear iti__hide",
        "aria-label": t.clearSearchAriaLabel,
        tabindex: "-1"
      },
      a
    );
    const o = `iti-${this.id}-clear-mask`;
    this.searchClearButton.innerHTML = `
      <svg class="iti__search-clear-svg" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <mask id="${o}" maskUnits="userSpaceOnUse">
          <rect width="16" height="16" fill="white" />
          <path d="M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8" stroke="black" stroke-linecap="round" class="iti__search-clear-x" />
        </mask>
        <circle cx="8" cy="8" r="8" class="iti__search-clear-bg" mask="url(#${o})" />
      </svg>`, this.searchResultsA11yText = ne(
      "span",
      { class: "iti__a11y-text" },
      this.dropdownContent
    ), this.searchNoResults = ne(
      "div",
      {
        class: "iti__no-results iti__hide",
        "aria-hidden": "true"
        // all a11y messaging happens in this.searchResultsA11yText
      },
      this.dropdownContent
    ), this.searchNoResults.textContent = t.zeroSearchResults;
  }
  _maybeUpdateInputPaddingAndReveal() {
    this.countryContainer && (this._updateInputPadding(), this.countryContainer.classList.remove("iti__v-hide"));
  }
  _maybeBuildHiddenInputs(t) {
    const { hiddenInput: a } = this.options;
    if (a) {
      const o = this.telInput.getAttribute("name") || "", n = a(o);
      if (n.phone) {
        const r = this.telInput.form?.querySelector(`input[name="${n.phone}"]`);
        r ? this.hiddenInput = r : (this.hiddenInput = ne("input", {
          type: "hidden",
          name: n.phone
        }), t.appendChild(this.hiddenInput));
      }
      if (n.country) {
        const r = this.telInput.form?.querySelector(`input[name="${n.country}"]`);
        r ? this.hiddenInputCountry = r : (this.hiddenInputCountry = ne("input", {
          type: "hidden",
          name: n.country
        }), t.appendChild(this.hiddenInputCountry));
      }
    }
  }
  //* For each country: add a country list item <li> to the countryList <ul> container.
  _appendListItems() {
    for (let t = 0; t < this.countries.length; t++) {
      const a = this.countries[t], o = t === 0 ? "iti__highlight" : "", n = ne(
        "li",
        {
          id: `iti-${this.id}__item-${a.iso2}`,
          class: `iti__country ${o}`,
          tabindex: "-1",
          role: "option",
          "data-dial-code": a.dialCode,
          "data-country-code": a.iso2,
          "aria-selected": "false"
        },
        this.countryList
      );
      a.nodeById[this.id] = n;
      let r = "";
      this.options.showFlags && (r += `<div class='iti__flag iti__${a.iso2}'></div>`), r += `<span class='iti__country-name'>${a.name}</span>`, r += `<span class='iti__dial-code' dir='ltr'>+${a.dialCode}</span>`, n.insertAdjacentHTML("beforeend", r);
    }
  }
  //* Set the initial state of the input value and the selected country by:
  //* 1. Extracting a dial code from the given number
  //* 2. Using explicit initialCountry
  _setInitialState(t = !1) {
    const a = this.telInput.getAttribute("value"), o = this.telInput.value, n = a && a.charAt(0) === "+" && (!o || o.charAt(0) !== "+") ? a : o, r = this._getDialCode(n), i = zo(n), { initialCountry: l, geoIpLookup: c } = this.options, s = l === "auto" && c;
    if (r && !i)
      this._updateCountryFromNumber(n);
    else if (!s || t) {
      const u = l ? l.toLowerCase() : "";
      ba(u) ? this._setCountry(u) : r && i ? this._setCountry("us") : this._setCountry("");
    }
    n && this._updateValFromNumber(n);
  }
  //* Initialise the main event listeners: input keyup, and click selected country.
  _initListeners() {
    this._initTelInputListeners(), this.options.allowDropdown && this._initDropdownListeners(), (this.hiddenInput || this.hiddenInputCountry) && this.telInput.form && this._initHiddenInputListener();
  }
  //* Update hidden input on form submit.
  _initHiddenInputListener() {
    this._handleHiddenInputSubmit = () => {
      this.hiddenInput && (this.hiddenInput.value = this.getNumber()), this.hiddenInputCountry && (this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "");
    }, this.telInput.form?.addEventListener(
      "submit",
      this._handleHiddenInputSubmit
    );
  }
  //* initialise the dropdown listeners.
  _initDropdownListeners() {
    this._handleLabelClick = (a) => {
      this.dropdownContent.classList.contains("iti__hide") ? this.telInput.focus() : a.preventDefault();
    };
    const t = this.telInput.closest("label");
    t && t.addEventListener("click", this._handleLabelClick), this._handleClickSelectedCountry = () => {
      this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly && this._openDropdown();
    }, this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry), this._handleCountryContainerKeydown = (a) => {
      this.dropdownContent.classList.contains("iti__hide") && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(a.key) && (a.preventDefault(), a.stopPropagation(), this._openDropdown()), a.key === "Tab" && this._closeDropdown();
    }, this.countryContainer.addEventListener(
      "keydown",
      this._handleCountryContainerKeydown
    );
  }
  //* Init many requests: utils script / geo ip lookup.
  _initRequests() {
    let { loadUtils: t, initialCountry: a, geoIpLookup: o } = this.options;
    t && !I.utils ? (this._doAttachUtils = () => {
      I.attachUtils(t)?.catch(() => {
      });
    }, I.documentReady() ? this._doAttachUtils() : (this._handlePageLoad = () => {
      this._doAttachUtils();
    }, window.addEventListener("load", this._handlePageLoad))) : this.resolveUtilsScriptPromise(), a === "auto" && o && !this.selectedCountryData.iso2 ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
  }
  //* Perform the geo ip lookup.
  _loadAutoCountry() {
    I.autoCountry ? this.handleAutoCountry() : I.startedLoadingAutoCountry || (I.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(
      (t = "") => {
        const a = t.toLowerCase();
        ba(a) ? (I.autoCountry = a, setTimeout(() => gt("handleAutoCountry"))) : (this._setInitialState(!0), gt("rejectAutoCountryPromise"));
      },
      () => {
        this._setInitialState(!0), gt("rejectAutoCountryPromise");
      }
    ));
  }
  _openDropdownWithPlus() {
    this._openDropdown(), this.searchInput.value = "+", this._filterCountries("");
  }
  //* Initialize the tel input listeners.
  _initTelInputListeners() {
    this._bindInputListener(), this._maybeBindKeydownListener(), this._maybeBindPasteListener();
  }
  _bindInputListener() {
    const { strictMode: t, formatAsYouType: a, separateDialCode: o, allowDropdown: n, countrySearch: r } = this.options;
    let i = !1;
    new RegExp("\\p{L}", "u").test(this.telInput.value) && (i = !0), this._handleInputEvent = (l) => {
      if (this.isAndroid && l?.data === "+" && o && n && r) {
        const d = this.telInput.selectionStart || 0, g = this.telInput.value.substring(0, d - 1), b = this.telInput.value.substring(d);
        this.telInput.value = g + b, this._openDropdownWithPlus();
        return;
      }
      this._updateCountryFromNumber(this.telInput.value) && this._triggerCountryChange();
      const c = l?.data && /[^+0-9]/.test(l.data), s = l?.inputType === "insertFromPaste" && this.telInput.value;
      c || s && !t ? i = !0 : /[^+0-9]/.test(this.telInput.value) || (i = !1);
      const u = l?.detail && l.detail.isSetNumber;
      if (a && !i && !u) {
        const d = this.telInput.selectionStart || 0, g = this.telInput.value.substring(0, d).replace(/[^+0-9]/g, "").length, b = l?.inputType === "deleteContentForward", h = this._getFullNumber(), k = Ys(
          h,
          this.telInput.value,
          I.utils,
          this.selectedCountryData,
          this.options.separateDialCode
        ), v = Qs(g, k, d, b);
        this.telInput.value = k, this.telInput.setSelectionRange(v, v);
      }
    }, this.telInput.addEventListener("input", this._handleInputEvent);
  }
  _maybeBindKeydownListener() {
    const { strictMode: t, separateDialCode: a, allowDropdown: o, countrySearch: n } = this.options;
    (t || a) && (this._handleKeydownEvent = (r) => {
      if (r.key && r.key.length === 1 && !r.altKey && !r.ctrlKey && !r.metaKey) {
        if (a && o && n && r.key === "+") {
          r.preventDefault(), this._openDropdownWithPlus();
          return;
        }
        if (t) {
          const i = this.telInput.value, l = i.charAt(0) !== "+" && this.telInput.selectionStart === 0 && r.key === "+", c = /^[0-9]$/.test(r.key), s = a ? c : l || c, u = i.slice(0, this.telInput.selectionStart) + r.key + i.slice(this.telInput.selectionEnd), d = this._getFullNumber(u), g = I.utils.getCoreNumber(d, this.selectedCountryData.iso2), b = this.maxCoreNumberLength && g.length > this.maxCoreNumberLength, h = this._getNewCountryFromNumber(d) !== null;
          (!s || b && !h && !l) && r.preventDefault();
        }
      }
    }, this.telInput.addEventListener("keydown", this._handleKeydownEvent));
  }
  _maybeBindPasteListener() {
    this.options.strictMode && (this._handlePasteEvent = (t) => {
      t.preventDefault();
      const a = this.telInput, o = a.selectionStart, n = a.selectionEnd, r = a.value.slice(0, o), i = a.value.slice(n), l = this.selectedCountryData.iso2, c = t.clipboardData.getData("text"), s = o === 0 && n > 0, u = !a.value.startsWith("+") || s, d = c.replace(/[^0-9+]/g, ""), g = d.startsWith("+"), b = d.replace(/\+/g, ""), h = g && u ? `+${b}` : b;
      let k = r + h + i, v = I.utils.getCoreNumber(k, l);
      for (; v.length === 0 && k.length > 0; )
        k = k.slice(0, -1), v = I.utils.getCoreNumber(k, l);
      if (!v)
        return;
      if (this.maxCoreNumberLength && v.length > this.maxCoreNumberLength)
        if (a.selectionEnd === a.value.length) {
          const y = v.length - this.maxCoreNumberLength;
          k = k.slice(0, k.length - y);
        } else
          return;
      a.value = k;
      const P = o + h.length;
      a.setSelectionRange(P, P), a.dispatchEvent(new InputEvent("input", { bubbles: !0 }));
    }, this.telInput.addEventListener("paste", this._handlePasteEvent));
  }
  //* Adhere to the input's maxlength attr.
  _cap(t) {
    const a = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
    return a && t.length > a ? t.substring(0, a) : t;
  }
  //* Trigger a custom event on the input.
  _trigger(t, a = {}) {
    const o = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !0,
      detail: a
    });
    this.telInput.dispatchEvent(o);
  }
  //* Open the dropdown.
  _openDropdown() {
    const { fixDropdownWidth: t, countrySearch: a } = this.options;
    if (t && (this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`), this.dropdownContent.classList.remove("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), a) {
      const o = this.countryList.firstElementChild;
      o && (this._highlightListItem(o, !1), this.countryList.scrollTop = 0), this.searchInput.focus();
    }
    this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
  }
  //* Set the dropdown position
  _setDropdownPosition() {
    if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.options.useFullscreenPopup) {
      const t = this.telInput.getBoundingClientRect(), a = this.telInput.offsetHeight;
      this.options.dropdownContainer && (this.dropdown.style.top = `${t.top + a}px`, this.dropdown.style.left = `${t.left}px`, this._handleWindowScroll = () => this._closeDropdown(), window.addEventListener("scroll", this._handleWindowScroll));
    }
  }
  //* We only bind dropdown listeners when the dropdown is open.
  _bindDropdownListeners() {
    this._handleMouseoverCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._highlightListItem(n, !1);
    }, this.countryList.addEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this._handleClickCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._selectListItem(n);
    }, this.countryList.addEventListener("click", this._handleClickCountryList), this._handleClickOffToClose = (o) => {
      o.target.closest(`#iti-${this.id}__dropdown-content`) || this._closeDropdown();
    }, setTimeout(() => {
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
    }, 0);
    let t = "", a = null;
    if (this._handleKeydownOnDropdown = (o) => {
      ["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(o.key) && (o.preventDefault(), o.stopPropagation(), o.key === "ArrowUp" || o.key === "ArrowDown" ? this._handleUpDownKey(o.key) : o.key === "Enter" ? this._handleEnterKey() : o.key === "Escape" && this._closeDropdown()), !this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(o.key) && (o.stopPropagation(), a && clearTimeout(a), t += o.key.toLowerCase(), this._searchForCountry(t), a = setTimeout(() => {
        t = "";
      }, 1e3));
    }, document.addEventListener("keydown", this._handleKeydownOnDropdown), this.options.countrySearch) {
      const o = () => {
        const r = this.searchInput.value.trim();
        this._filterCountries(r), this.searchInput.value ? this.searchClearButton.classList.remove("iti__hide") : this.searchClearButton.classList.add("iti__hide");
      };
      let n = null;
      this._handleSearchChange = () => {
        n && clearTimeout(n), n = setTimeout(() => {
          o(), n = null;
        }, 100);
      }, this.searchInput.addEventListener("input", this._handleSearchChange), this._handleSearchClear = () => {
        this.searchInput.value = "", this.searchInput.focus(), o();
      }, this.searchClearButton.addEventListener("click", this._handleSearchClear);
    }
  }
  //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
  _searchForCountry(t) {
    for (const a of this.countries)
      if (a.name.substring(0, t.length).toLowerCase() === t) {
        const o = a.nodeById[this.id];
        this._highlightListItem(o, !1), this._scrollTo(o);
        break;
      }
  }
  //* Country search enabled: Filter the countries according to the search query.
  _filterCountries(t) {
    this.countryList.innerHTML = "";
    let a;
    t === "" ? a = this.countries : a = this._getMatchedCountries(t);
    let o = !0;
    for (const n of a) {
      const r = n.nodeById[this.id];
      r && (this.countryList.appendChild(r), o && (this._highlightListItem(r, !1), o = !1));
    }
    o ? (this._highlightListItem(null, !1), this.searchNoResults && this.searchNoResults.classList.remove("iti__hide")) : this.searchNoResults && this.searchNoResults.classList.add("iti__hide"), this.countryList.scrollTop = 0, this._updateSearchResultsA11yText();
  }
  _getMatchedCountries(t) {
    const a = cr(t), o = [], n = [], r = [], i = [], l = [], c = [];
    for (const s of this.countries)
      s.iso2 === a ? o.push(s) : s.normalisedName.startsWith(a) ? n.push(s) : s.normalisedName.includes(a) ? r.push(s) : a === s.dialCode || a === s.dialCodePlus ? i.push(s) : s.dialCodePlus.includes(a) ? l.push(s) : s.initials.includes(a) && c.push(s);
    return [
      ...o.sort((s, u) => s.priority - u.priority),
      ...n.sort((s, u) => s.priority - u.priority),
      ...r.sort((s, u) => s.priority - u.priority),
      ...i.sort((s, u) => s.priority - u.priority),
      ...l.sort((s, u) => s.priority - u.priority),
      ...c.sort((s, u) => s.priority - u.priority)
    ];
  }
  //* Update search results text (for a11y).
  _updateSearchResultsA11yText() {
    const { i18n: t } = this.options, a = this.countryList.childElementCount;
    let o;
    a === 0 ? o = t.zeroSearchResults : t.searchResultsText ? o = t.searchResultsText(a) : a === 1 ? o = t.oneSearchResult : o = t.multipleSearchResults.replace("${count}", a.toString()), this.searchResultsA11yText.textContent = o;
  }
  //* Highlight the next/prev item in the list (and ensure it is visible).
  _handleUpDownKey(t) {
    let a = t === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
    !a && this.countryList.childElementCount > 1 && (a = t === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild), a && (this._scrollTo(a), this._highlightListItem(a, !1));
  }
  //* Select the currently highlighted item.
  _handleEnterKey() {
    this.highlightedItem && this._selectListItem(this.highlightedItem);
  }
  //* Update the input's value to the given val (format first if possible)
  //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
  _updateValFromNumber(t) {
    let a = t;
    if (this.options.formatOnDisplay && I.utils && this.selectedCountryData) {
      const o = this.options.nationalMode || a.charAt(0) !== "+" && !this.options.separateDialCode, { NATIONAL: n, INTERNATIONAL: r } = I.utils.numberFormat, i = o ? n : r;
      a = I.utils.formatNumber(
        a,
        this.selectedCountryData.iso2,
        i
      );
    }
    a = this._beforeSetNumber(a), this.telInput.value = a;
  }
  //* Check if need to select a new country based on the given number
  //* Note: called from _setInitialState, keyup handler, setNumber.
  _updateCountryFromNumber(t) {
    const a = this._getNewCountryFromNumber(t);
    return a !== null ? this._setCountry(a) : !1;
  }
  _ensureHasDialCode(t) {
    const { dialCode: a, nationalPrefix: o } = this.selectedCountryData;
    if (t.charAt(0) === "+" || !a)
      return t;
    const n = o && t.charAt(0) === o && !this.options.separateDialCode ? t.substring(1) : t;
    return `+${a}${n}`;
  }
  // Get the country ISO2 code from the given number
  // BUT ONLY IF ITS CHANGED FROM THE CURRENTLY SELECTED COUNTRY
  // NOTE: consider refactoring this to be more clear
  _getNewCountryFromNumber(t) {
    const a = t.indexOf("+");
    let o = a ? t.substring(a) : t;
    const n = this.selectedCountryData.iso2, r = this.selectedCountryData.dialCode;
    o = this._ensureHasDialCode(o);
    const i = this._getDialCode(o, !0), l = Lt(o);
    if (i) {
      const c = Lt(i), s = this.dialCodeToIso2Map[c];
      if (s.length === 1)
        return s[0] === n ? null : s[0];
      if (!n && this.defaultCountry && s.includes(this.defaultCountry))
        return this.defaultCountry;
      if (r === "1" && zo(l))
        return null;
      const u = this.selectedCountryData.areaCodes && l.length > c.length;
      if (!(n && s.includes(n) && !u))
        return s[0];
    } else {
      if (o.charAt(0) === "+" && l.length)
        return "";
      if ((!o || o === "+") && !n)
        return this.defaultCountry;
    }
    return null;
  }
  //* Remove highlighting from other list items and highlight the given item.
  _highlightListItem(t, a) {
    const o = this.highlightedItem;
    if (o && (o.classList.remove("iti__highlight"), o.setAttribute("aria-selected", "false")), this.highlightedItem = t, this.highlightedItem && (this.highlightedItem.classList.add("iti__highlight"), this.highlightedItem.setAttribute("aria-selected", "true"), this.options.countrySearch)) {
      const n = this.highlightedItem.getAttribute("id") || "";
      this.searchInput.setAttribute("aria-activedescendant", n);
    }
    a && this.highlightedItem.focus();
  }
  //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
  //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
  _setCountry(t) {
    const { separateDialCode: a, showFlags: o, i18n: n } = this.options, r = this.selectedCountryData.iso2 || "";
    if (this.selectedCountryData = t ? this.countryByIso2.get(t) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), this.selectedCountry) {
      const i = t && o ? `iti__flag iti__${t}` : "iti__flag iti__globe";
      let l, c;
      if (t) {
        const { name: s, dialCode: u } = this.selectedCountryData;
        c = s, l = n.selectedCountryAriaLabel.replace("${countryName}", s).replace("${dialCode}", `+${u}`);
      } else
        c = n.noCountrySelected, l = n.noCountrySelected;
      this.selectedCountryInner.className = i, this.selectedCountry.setAttribute("title", c), this.selectedCountry.setAttribute("aria-label", l);
    }
    if (a) {
      const i = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
      this.selectedDialCode.innerHTML = i, this._updateInputPadding();
    }
    return this._updatePlaceholder(), this._updateMaxLength(), r !== t;
  }
  //* Update the input padding to make space for the selected country/dial code.
  _updateInputPadding() {
    if (this.selectedCountry) {
      const t = this.options.separateDialCode ? 78 : 42, a = (this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth() || t) + 6;
      this.showSelectedCountryOnLeft ? this.telInput.style.paddingLeft = `${a}px` : this.telInput.style.paddingRight = `${a}px`;
    }
  }
  //* Update the maximum valid number length for the currently selected country.
  _updateMaxLength() {
    const { strictMode: t, placeholderNumberType: a, validationNumberTypes: o } = this.options, { iso2: n } = this.selectedCountryData;
    if (t && I.utils)
      if (n) {
        const r = I.utils.numberType[a];
        let i = I.utils.getExampleNumber(
          n,
          !1,
          r,
          !0
        ), l = i;
        for (; I.utils.isPossibleNumber(i, n, o); )
          l = i, i += "0";
        const c = I.utils.getCoreNumber(l, n);
        this.maxCoreNumberLength = c.length, n === "by" && (this.maxCoreNumberLength = c.length + 1);
      } else
        this.maxCoreNumberLength = null;
  }
  //* When input is in a hidden container during init, we cannot calculate the selected country width.
  //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
  //* To get the right styling to apply, all we need is a shallow clone of the container,
  //* and then to inject a deep clone of the selectedCountry element.
  _getHiddenSelectedCountryWidth() {
    if (this.telInput.parentNode) {
      let t;
      try {
        t = window.top.document.body;
      } catch {
        t = document.body;
      }
      const a = this.telInput.parentNode.cloneNode(!1);
      a.style.visibility = "hidden", t.appendChild(a);
      const o = this.countryContainer.cloneNode();
      a.appendChild(o);
      const n = this.selectedCountry.cloneNode(!0);
      o.appendChild(n);
      const r = n.offsetWidth;
      return t.removeChild(a), r;
    }
    return 0;
  }
  //* Update the input placeholder to an example number from the currently selected country.
  _updatePlaceholder() {
    const {
      autoPlaceholder: t,
      placeholderNumberType: a,
      nationalMode: o,
      customPlaceholder: n
    } = this.options, r = t === "aggressive" || !this.hadInitialPlaceholder && t === "polite";
    if (I.utils && r) {
      const i = I.utils.numberType[a];
      let l = this.selectedCountryData.iso2 ? I.utils.getExampleNumber(
        this.selectedCountryData.iso2,
        o,
        i
      ) : "";
      l = this._beforeSetNumber(l), typeof n == "function" && (l = n(l, this.selectedCountryData)), this.telInput.setAttribute("placeholder", l);
    }
  }
  //* Called when the user selects a list item from the dropdown.
  _selectListItem(t) {
    const a = t.getAttribute("data-country-code"), o = this._setCountry(a);
    this._closeDropdown();
    const n = t.getAttribute("data-dial-code");
    this._updateDialCode(n), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this.telInput.focus(), o && this._triggerCountryChange();
  }
  //* Close the dropdown and unbind any listeners.
  _closeDropdown() {
    this.dropdownContent.classList.add("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "false"), this.highlightedItem && this.highlightedItem.setAttribute("aria-selected", "false"), this.options.countrySearch && this.searchInput.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), this.options.countrySearch && (this.searchInput.removeEventListener("input", this._handleSearchChange), this.searchClearButton.removeEventListener("click", this._handleSearchClear)), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener(
      "click",
      this._handleClickOffToClose
    ), this.countryList.removeEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.options.useFullscreenPopup || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
  }
  //* Check if an element is visible within it's container, else scroll until it is.
  _scrollTo(t) {
    const a = this.countryList, o = document.documentElement.scrollTop, n = a.offsetHeight, r = a.getBoundingClientRect().top + o, i = r + n, l = t.offsetHeight, c = t.getBoundingClientRect().top + o, s = c + l, u = c - r + a.scrollTop;
    if (c < r)
      a.scrollTop = u;
    else if (s > i) {
      const d = n - l;
      a.scrollTop = u - d;
    }
  }
  //* Replace any existing dial code with the new one
  //* Note: called from _selectListItem and setCountry
  _updateDialCode(t) {
    const a = this.telInput.value, o = `+${t}`;
    let n;
    if (a.charAt(0) === "+") {
      const r = this._getDialCode(a);
      r ? n = a.replace(r, o) : n = o, this.telInput.value = n;
    }
  }
  //* Try and extract a valid international dial code from a full telephone number.
  //* Note: returns the raw string inc plus character and any whitespace/dots etc.
  _getDialCode(t, a) {
    let o = "";
    if (t.charAt(0) === "+") {
      let n = "";
      for (let r = 0; r < t.length; r++) {
        const i = t.charAt(r);
        if (/[0-9]/.test(i)) {
          if (n += i, a)
            this.dialCodeToIso2Map[n] && (o = t.substring(0, r + 1));
          else if (this.dialCodes.has(n)) {
            o = t.substring(0, r + 1);
            break;
          }
          if (n.length === this.dialCodeMaxLen)
            break;
        }
      }
    }
    return o;
  }
  //* Get the input val, adding the dial code if separateDialCode is enabled.
  _getFullNumber(t) {
    const a = t || this.telInput.value.trim(), { dialCode: o } = this.selectedCountryData;
    let n;
    const r = Lt(a);
    return this.options.separateDialCode && a.charAt(0) !== "+" && o && r ? n = `+${o}` : n = "", n + a;
  }
  //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
  _beforeSetNumber(t) {
    const a = this._getDialCode(t), o = Js(
      t,
      a,
      this.options.separateDialCode,
      this.selectedCountryData
    );
    return this._cap(o);
  }
  //* Trigger the 'countrychange' event.
  _triggerCountryChange() {
    this._trigger("countrychange");
  }
  //**************************
  //*  SECRET PUBLIC METHODS
  //**************************
  //* This is called when the geoip call returns.
  handleAutoCountry() {
    this.options.initialCountry === "auto" && I.autoCountry && (this.defaultCountry = I.autoCountry, this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe") || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
  }
  //* This is called when the utils request completes.
  handleUtils() {
    I.utils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this.selectedCountryData.iso2 && (this._updatePlaceholder(), this._updateMaxLength())), this.resolveUtilsScriptPromise();
  }
  //********************
  //*  PUBLIC METHODS
  //********************
  //* Remove plugin.
  destroy() {
    this.telInput.iti = void 0;
    const { allowDropdown: t, separateDialCode: a } = this.options;
    if (t) {
      this._closeDropdown(), this.selectedCountry.removeEventListener(
        "click",
        this._handleClickSelectedCountry
      ), this.countryContainer.removeEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
      const r = this.telInput.closest("label");
      r && r.removeEventListener("click", this._handleLabelClick);
    }
    const { form: o } = this.telInput;
    this._handleHiddenInputSubmit && o && o.removeEventListener("submit", this._handleHiddenInputSubmit), this.telInput.removeEventListener("input", this._handleInputEvent), this._handleKeydownEvent && this.telInput.removeEventListener("keydown", this._handleKeydownEvent), this._handlePasteEvent && this.telInput.removeEventListener("paste", this._handlePasteEvent), this._handlePageLoad && window.removeEventListener("load", this._handlePageLoad), this.telInput.removeAttribute("data-intl-tel-input-id"), a && (this.isRTL ? this.telInput.style.paddingRight = this.originalPaddingRight : this.telInput.style.paddingLeft = this.originalPaddingLeft);
    const n = this.telInput.parentNode;
    n?.parentNode?.insertBefore(this.telInput, n), n?.parentNode?.removeChild(n), delete I.instances[this.id];
  }
  //* Get the extension from the current number.
  getExtension() {
    return I.utils ? I.utils.getExtension(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : "";
  }
  //* Format the number to the given format.
  getNumber(t) {
    if (I.utils) {
      const { iso2: a } = this.selectedCountryData;
      return I.utils.formatNumber(
        this._getFullNumber(),
        a,
        t
      );
    }
    return "";
  }
  //* Get the type of the entered number e.g. landline/mobile.
  getNumberType() {
    return I.utils ? I.utils.getNumberType(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : -99;
  }
  //* Get the country data for the currently selected country.
  getSelectedCountryData() {
    return this.selectedCountryData;
  }
  //* Get the validation error.
  getValidationError() {
    if (I.utils) {
      const { iso2: t } = this.selectedCountryData;
      return I.utils.getValidationError(this._getFullNumber(), t);
    }
    return -99;
  }
  //* Validate the input val (with precise=false)
  isValidNumber() {
    return this._validateNumber(!1);
  }
  //* Validate the input val (with precise=true)
  isValidNumberPrecise() {
    return this._validateNumber(!0);
  }
  _utilsIsPossibleNumber(t) {
    return I.utils ? I.utils.isPossibleNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Shared internal validation logic to handle alpha character extension rules.
  _validateNumber(t) {
    if (!this.selectedCountryData.iso2)
      return !1;
    const a = (r) => t ? this._utilsIsValidNumber(r) : this._utilsIsPossibleNumber(r), o = this._getFullNumber(), n = o.search(new RegExp("\\p{L}", "u"));
    if (n > -1 && !this.options.allowPhonewords) {
      const r = o.substring(0, n), i = a(r), l = a(o);
      return i && l;
    }
    return a(o);
  }
  _utilsIsValidNumber(t) {
    return I.utils ? I.utils.isValidNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Update the selected country, and update the input val accordingly.
  setCountry(t) {
    const a = t?.toLowerCase();
    if (!ba(a))
      throw new Error(`Invalid country code: '${a}'`);
    const o = this.selectedCountryData.iso2;
    (t && a !== o || !t && o) && (this._setCountry(a), this._updateDialCode(this.selectedCountryData.dialCode), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this._triggerCountryChange());
  }
  //* Set the input value and update the country.
  setNumber(t) {
    const a = this._updateCountryFromNumber(t);
    this._updateValFromNumber(t), a && this._triggerCountryChange(), this._trigger("input", { isSetNumber: !0 });
  }
  //* Set the placeholder number typ
  setPlaceholderNumberType(t) {
    this.options.placeholderNumberType = t, this._updatePlaceholder();
  }
  setDisabled(t) {
    this.telInput.disabled = t, t ? this.selectedCountry.setAttribute("disabled", "true") : this.selectedCountry.removeAttribute("disabled");
  }
}, oc = (e) => {
  if (!I.utils && !I.startedLoadingUtilsScript) {
    let t;
    if (typeof e == "function")
      try {
        t = Promise.resolve(e());
      } catch (a) {
        return Promise.reject(a);
      }
    else
      return Promise.reject(new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utilities module, not ${typeof e}`));
    return I.startedLoadingUtilsScript = !0, t.then((a) => {
      const o = a?.default;
      if (!o || typeof o != "object")
        throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
      return I.utils = o, gt("handleUtils"), !0;
    }).catch((a) => {
      throw gt("rejectUtilsScriptPromise", a), a;
    });
  }
  return null;
}, I = Object.assign(
  (e, t) => {
    const a = new ac(e, t);
    return a._init(), e.setAttribute("data-intl-tel-input-id", a.id.toString()), I.instances[a.id] = a, e.iti = a, a;
  },
  {
    defaults: sr,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: () => document.readyState === "complete",
    //* Get the country data object.
    getCountryData: () => at,
    //* A getter for the plugin instance.
    getInstance: (e) => {
      const t = e.getAttribute("data-intl-tel-input-id");
      return t ? I.instances[t] : null;
    },
    //* A map from instance ID to instance object.
    instances: {},
    attachUtils: oc,
    startedLoadingUtilsScript: !1,
    startedLoadingAutoCountry: !1,
    version: "25.10.10"
  }
), nc = I, rc = kt(function({
  initialValue: e = "",
  onChangeNumber: t = () => {
  },
  onChangeCountry: a = () => {
  },
  onChangeValidity: o = () => {
  },
  onChangeErrorCode: n = () => {
  },
  usePreciseValidation: r = !1,
  initOptions: i = {},
  inputProps: l = {},
  disabled: c = void 0
}, s) {
  const u = bt(null), d = bt(null);
  Qr(s, () => ({
    getInstance: () => d.current,
    getInput: () => u.current
  }));
  const g = hn(() => {
    const b = d.current?.getNumber() || "", h = d.current?.getSelectedCountryData().iso2 || "";
    if (t(b), a(h), d.current)
      if (r ? d.current.isValidNumberPrecise() : d.current.isValidNumber())
        o(!0), n(null);
      else {
        const k = d.current.getValidationError();
        o(!1), n(k);
      }
  }, [a, n, t, o, r]);
  return Ie(() => (u.current && (d.current = nc(u.current, i)), () => {
    d.current?.destroy();
  }), []), Ie(() => {
    const b = u.current;
    return b && (b.addEventListener("countrychange", g), d.current.promise.then(g)), () => {
      b && b.removeEventListener("countrychange", g);
    };
  }, [g]), Ie(() => {
    d.current && c !== void 0 && d.current.setDisabled(c);
  }, [c]), /* @__PURE__ */ O.createElement(
    "input",
    {
      type: "tel",
      ref: u,
      onInput: g,
      defaultValue: e,
      ...l
    }
  );
}), ic = rc;
const Te = {
  "phone-number": "_phone-number_1ni27_30",
  "is-full-width": "_is-full-width_1ni27_41",
  "group-label": "_group-label_1ni27_44",
  "helper-text": "_helper-text_1ni27_53",
  "is-disabled": "_is-disabled_1ni27_58",
  "is-error": "_is-error_1ni27_73",
  "is-success": "_is-success_1ni27_144",
  "container-icon": "_container-icon_1ni27_166",
  "dialog-overlay-show": "_dialog-overlay-show_1ni27_1",
  "dialog-content-show": "_dialog-content-show_1ni27_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ni27_1"
};
kt(
  ({
    label: e,
    helperText: t,
    initialPhoneNumber: a,
    onChangePhoneNumber: o,
    initialCountry: n,
    onChangeCountry: r,
    locale: i = "en",
    message: l,
    status: c,
    disabled: s,
    isFullWidth: u,
    inputProps: d,
    setErrorCode: g,
    setIsValidPhoneNumber: b
  }, h) => {
    const { phoneNumber: k, country: v, handlePhoneNumberChange: P, handleCountryChange: y } = ns({
      initialPhoneNumber: a,
      initialCountry: n,
      onChangePhoneNumber: o,
      onChangeCountry: r
    }), M = H(
      Te["phone-number"],
      s && Te["is-disabled"],
      c && Te[Co[c]],
      u && Te["is-full-width"]
    );
    return /* @__PURE__ */ R("div", { className: M, children: [
      /* @__PURE__ */ R("div", { className: Te["group-label"], children: [
        e && /* @__PURE__ */ p("label", { children: e }),
        t && /* @__PURE__ */ p("div", { className: Te["helper-text"], children: t })
      ] }),
      /* @__PURE__ */ p(
        ic,
        {
          initialValue: k,
          onChangeErrorCode: g,
          onChangeValidity: b,
          onChangeCountry: y,
          onChangeNumber: P,
          inputProps: {
            disabled: s,
            "aria-label": d?.["aria-label"] || e,
            ...d
          },
          ref: h,
          initOptions: {
            strictMode: !0,
            initialCountry: v,
            i18n: Is[i],
            useFullscreenPopup: !1,
            // Manually load the utils to prevent issues on SSR pages
            loadUtils: () => import("./utils-CJDvlpOH-DLsHHipy.js")
          }
        }
      ),
      l && c && !s && /* @__PURE__ */ R("div", { className: Te["container-icon"], children: [
        /* @__PURE__ */ p(Ke, { name: So[c].name, size: "medium", color: So[c].color }),
        /* @__PURE__ */ p("span", { className: Te[Co[c]], children: l })
      ] })
    ] });
  }
);
const lc = 0;
function sc(e, t, a, o, n, r) {
  const [i, l] = xe(!1), c = i ? a : o, [s, u] = xe(c ? c.length : lc), [d, g] = xe(!1);
  return {
    valueCounter: s,
    isOnBlur: d,
    hasLabelOrHelperText: !!(e ?? t),
    handleBlur: () => {
      g(!0), r?.();
    },
    handleChange: (b) => {
      l(!0), u(b.target.value.length), n && n(b), g(!1);
    }
  };
}
const cc = "_container_1qc3k_29", uc = "_filled_1qc3k_46", dc = "_error_1qc3k_49", _c = "_success_1qc3k_52", gc = "_counter_1qc3k_131", be = {
  container: cc,
  "full-width": "_full-width_1qc3k_34",
  "group-label": "_group-label_1qc3k_37",
  filled: uc,
  error: dc,
  success: _c,
  "helper-text": "_helper-text_1qc3k_55",
  "container-counter-icon": "_container-counter-icon_1qc3k_110",
  "container-icon": "_container-icon_1qc3k_117",
  "icon-error-warning-fill": "_icon-error-warning-fill_1qc3k_122",
  counter: gc,
  "dialog-overlay-show": "_dialog-overlay-show_1qc3k_1",
  "dialog-content-show": "_dialog-content-show_1qc3k_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1qc3k_1"
};
function fc({
  id: e,
  disabled: t = !1,
  status: a,
  title: o,
  helperText: n,
  placeholder: r,
  maxLength: i,
  onChange: l,
  onBlur: c,
  message: s,
  value: u,
  defaultValue: d,
  name: g,
  isFullWidth: b = !1
}) {
  const {
    valueCounter: h,
    isOnBlur: k,
    handleBlur: v,
    handleChange: P,
    hasLabelOrHelperText: y
  } = sc(o, n, u, d, l, c);
  return /* @__PURE__ */ R("div", { className: H(be.container, b && be["full-width"]), children: [
    y && /* @__PURE__ */ R("div", { className: be["group-label"], children: [
      o && /* @__PURE__ */ p(
        "label",
        {
          htmlFor: e,
          className: H(a && be[a], (h > 0 && k || t) && be.filled),
          children: o
        }
      ),
      n && /* @__PURE__ */ p("div", { className: be["helper-text"], children: n })
    ] }),
    /* @__PURE__ */ p(
      "textarea",
      {
        id: e,
        name: g,
        "aria-label": "textarea",
        placeholder: r,
        onChange: P,
        className: H(a && be[a]),
        value: u,
        defaultValue: d,
        disabled: t,
        onBlur: v
      }
    ),
    /* @__PURE__ */ R("div", { className: be["container-counter-icon"], children: [
      s && a && /* @__PURE__ */ R("div", { className: be["container-icon"], children: [
        /* @__PURE__ */ p(
          Ke,
          {
            name: `${a === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: H(be[a])
          }
        ),
        /* @__PURE__ */ p("span", { className: be[a], children: s })
      ] }),
      i && /* @__PURE__ */ R("div", { className: H(be.counter, h > i && be.error), children: [
        h,
        "/",
        i
      ] })
    ] })
  ] });
}
const Ao = 640, ha = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function ur({
  srcMobile: e,
  width: t = "auto",
  borderRadius: a = "none",
  className: o = "",
  ...n
}) {
  const r = H(ha.img, o, ha[bc[t]], ha[hc[a]]);
  return /* @__PURE__ */ R("picture", { children: [
    e && /* @__PURE__ */ p("source", { media: `(max-width: ${Ao}px)`, srcSet: e }),
    /* @__PURE__ */ p("source", { media: `(min-width: ${Ao + 1}px)` }),
    /* @__PURE__ */ p("img", { ...n, className: r, alt: n.alt, style: { width: `${n.widthInPx}px` } })
  ] });
}
const bc = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, hc = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, mc = "_callout_7jl0x_29", pc = "_link_7jl0x_52", ct = {
  callout: mc,
  "is-full-width": "_is-full-width_7jl0x_37",
  "is-small": "_is-small_7jl0x_47",
  link: pc,
  "is-medium": "_is-medium_7jl0x_55",
  "is-info": "_is-info_7jl0x_58",
  "is-warning": "_is-warning_7jl0x_61",
  "is-success": "_is-success_7jl0x_64",
  "is-error": "_is-error_7jl0x_67",
  "is-neutral": "_is-neutral_7jl0x_70",
  "is-collection": "_is-collection_7jl0x_73",
  "content-container": "_content-container_7jl0x_79",
  "dialog-overlay-show": "_dialog-overlay-show_7jl0x_1",
  "dialog-content-show": "_dialog-content-show_7jl0x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7jl0x_1"
}, Po = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, yc = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, vc = {
  small: "is-small",
  medium: "is-medium"
};
function dr({
  status: e = "info",
  size: t = "medium",
  children: a,
  hasIcon: o = !1,
  backgroundImage: n,
  isFullWidth: r = !1
}) {
  const i = H(ct.callout, ct[yc[e]], ct[vc[t]], {
    [ct["is-full-width"]]: r
  });
  return /* @__PURE__ */ R("div", { className: i, children: [
    o && /* @__PURE__ */ p(Ke, { name: Po[e].name, color: Po[e].color, size: "2xl" }),
    /* @__PURE__ */ p("div", { className: ct["content-container"], children: a }),
    n && /* @__PURE__ */ p("img", { src: n, alt: "background" })
  ] });
}
const kc = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, $c = ({ imageSrc: e, imageSrcMobile: t, imageSrcTablet: a, alt: o, className: n }) => {
  const { isMobile: r, isTablet: i } = rr();
  let l = e;
  return r && t && (l = t), i && a && (l = a), /* @__PURE__ */ p("img", { className: n, src: l, alt: o });
}, wc = "_banner_17hqf_29", De = {
  "banner-container": "_banner-container_17hqf_29",
  banner: wc,
  "banner-image": "_banner-image_17hqf_39",
  "banner-content": "_banner-content_17hqf_42",
  "banner-text": "_banner-text_17hqf_48",
  "banner-cta": "_banner-cta_17hqf_51",
  "is-info": "_is-info_17hqf_92",
  "is-warning": "_is-warning_17hqf_95",
  "is-success": "_is-success_17hqf_98",
  "is-error": "_is-error_17hqf_101",
  "is-neutral": "_is-neutral_17hqf_104",
  "dialog-overlay-show": "_dialog-overlay-show_17hqf_1",
  "dialog-content-show": "_dialog-content-show_17hqf_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17hqf_1"
};
function xc({ color: e, image: t, className: a, cta: o, title: n, description: r }) {
  const i = H(De.banner, De[kc[e]], a);
  return /* @__PURE__ */ p("div", { className: De["banner-container"], children: /* @__PURE__ */ R("div", { className: i, children: [
    t && /* @__PURE__ */ p($c, { className: De["banner-image"], ...t }),
    /* @__PURE__ */ R("div", { className: De["banner-content"], children: [
      /* @__PURE__ */ R("div", { className: De["banner-text"], children: [
        /* @__PURE__ */ p(Ft, { isBold: !0, className: De.title, children: n }),
        /* @__PURE__ */ p(Ft, { className: De.description, children: r })
      ] }),
      o && /* @__PURE__ */ p(nt, { className: De["banner-cta"], color: o.color, onClick: o.onClick, children: o.text })
    ] })
  ] }) });
}
const Cc = "_columns_10k0l_29", Sc = "_column_10k0l_29", Ne = {
  columns: Cc,
  "align-items-center": "_align-items-center_10k0l_36",
  "align-items-flex-start": "_align-items-flex-start_10k0l_39",
  "align-items-flex-end": "_align-items-flex-end_10k0l_42",
  "reverse-on-mobile": "_reverse-on-mobile_10k0l_57",
  column: Sc,
  "gap-0": "_gap-0_10k0l_68",
  "gap-1": "_gap-1_10k0l_71",
  "gap-2": "_gap-2_10k0l_74",
  "gap-3": "_gap-3_10k0l_77",
  "gap-4": "_gap-4_10k0l_80",
  "gap-5": "_gap-5_10k0l_83",
  "gap-6": "_gap-6_10k0l_86",
  "gap-7": "_gap-7_10k0l_89",
  "gap-8": "_gap-8_10k0l_92",
  "gap-9": "_gap-9_10k0l_95",
  "gap-10": "_gap-10_10k0l_98",
  "gap-11": "_gap-11_10k0l_101",
  "gap-12": "_gap-12_10k0l_104",
  "gap-14": "_gap-14_10k0l_107",
  "gap-16": "_gap-16_10k0l_110",
  "gap-18": "_gap-18_10k0l_113",
  "gap-20": "_gap-20_10k0l_116",
  "gap-24": "_gap-24_10k0l_119",
  "gap-28": "_gap-28_10k0l_122",
  "gap-32": "_gap-32_10k0l_125",
  "gap-36": "_gap-36_10k0l_128",
  "gap-40": "_gap-40_10k0l_131",
  "gap-44": "_gap-44_10k0l_134",
  "gap-48": "_gap-48_10k0l_137",
  "gap-52": "_gap-52_10k0l_140",
  "gap-56": "_gap-56_10k0l_143",
  "gap-60": "_gap-60_10k0l_146",
  "gap-64": "_gap-64_10k0l_149",
  "gap-72": "_gap-72_10k0l_152",
  "gap-80": "_gap-80_10k0l_155",
  "gap-96": "_gap-96_10k0l_158",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_10k0l_161",
  "is-1": "_is-1_10k0l_180",
  "is-2": "_is-2_10k0l_184",
  "is-3": "_is-3_10k0l_188",
  "is-4": "_is-4_10k0l_192",
  "is-5": "_is-5_10k0l_196",
  "is-6": "_is-6_10k0l_200",
  "is-7": "_is-7_10k0l_204",
  "is-8": "_is-8_10k0l_208",
  "is-9": "_is-9_10k0l_212",
  "is-10": "_is-10_10k0l_216",
  "is-11": "_is-11_10k0l_220",
  "is-12": "_is-12_10k0l_224",
  "is-offset-1": "_is-offset-1_10k0l_228",
  "is-offset-2": "_is-offset-2_10k0l_231",
  "is-offset-3": "_is-offset-3_10k0l_234",
  "is-offset-4": "_is-offset-4_10k0l_237",
  "is-offset-5": "_is-offset-5_10k0l_240",
  "is-offset-6": "_is-offset-6_10k0l_243",
  "is-offset-7": "_is-offset-7_10k0l_246",
  "is-offset-8": "_is-offset-8_10k0l_249",
  "is-offset-9": "_is-offset-9_10k0l_252",
  "is-offset-10": "_is-offset-10_10k0l_255",
  "is-offset-11": "_is-offset-11_10k0l_258",
  "is-narrow": "_is-narrow_10k0l_261",
  "dialog-overlay-show": "_dialog-overlay-show_10k0l_1",
  "dialog-content-show": "_dialog-content-show_10k0l_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_10k0l_1"
};
function _r({ children: e, className: t = "", reverseOnMobile: a = !1, alignItems: o, ...n }) {
  const r = H(
    Ne.columns,
    a && Ne["reverse-on-mobile"],
    o && Ne[`align-items-${o}`],
    t
  );
  return /* @__PURE__ */ p("div", { className: r, ...n, children: e });
}
const zc = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, Ac = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function Vt({
  size: e = "auto",
  offset: t = "auto",
  isNarrow: a = !1,
  className: o = "",
  children: n,
  gap: r,
  hiddenContentOnMobile: i = !1,
  ...l
}) {
  const c = H(
    Ne.column,
    Ne[zc[e]],
    Ne[Ac[t]],
    a && Ne["is-narrow"],
    r && Ne[`gap-${r}`],
    i && Ne["hidden-content-on-mobile"],
    o
  );
  return /* @__PURE__ */ p("div", { className: c, ...l, children: n });
}
const Pc = "_container_68o99_29", Mo = {
  container: Pc,
  "is-fluid": "_is-fluid_68o99_50"
};
function Mc({ isFluid: e = !1, children: t, className: a = "", ...o }) {
  const n = H(Mo.container, e && Mo["is-fluid"], a);
  return /* @__PURE__ */ p("div", { className: n, ...o, children: t });
}
const Dc = "_section_g0e0c_29", Nc = "_content_g0e0c_32", he = {
  section: Dc,
  content: Nc,
  "is-top-bottom-padding": "_is-top-bottom-padding_g0e0c_35",
  "has-small-padding": "_has-small-padding_g0e0c_38",
  "has-medium-padding": "_has-medium-padding_g0e0c_41",
  "has-large-padding": "_has-large-padding_g0e0c_44",
  "bg-image": "_bg-image_g0e0c_48",
  "image-flex": "_image-flex_g0e0c_53",
  "image-container": "_image-container_g0e0c_63",
  "reverse-bg-color": "_reverse-bg-color_g0e0c_82",
  "image-reverse": "_image-reverse_g0e0c_88",
  "is-full-height": "_is-full-height_g0e0c_94",
  "center-content": "_center-content_g0e0c_97",
  "border-top": "_border-top_g0e0c_101",
  "border-bottom": "_border-bottom_g0e0c_104",
  "border-top-and-bottom": "_border-top-and-bottom_g0e0c_107",
  "is-primary": "_is-primary_g0e0c_111",
  "is-secondary": "_is-secondary_g0e0c_114",
  "is-tertiary": "_is-tertiary_g0e0c_117",
  "dialog-overlay-show": "_dialog-overlay-show_g0e0c_1",
  "dialog-content-show": "_dialog-content-show_g0e0c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_g0e0c_1"
}, Oc = {
  small: "has-small-padding",
  medium: "has-medium-padding",
  large: "has-large-padding"
}, Ic = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, jc = {
  none: "",
  top: "border-top",
  bottom: "border-bottom",
  topAndBottom: "border-top-and-bottom"
};
function Lc({
  children: e,
  className: t = "",
  color: a,
  border: o = "none",
  isFullHeight: n,
  centerContent: r,
  isTopBottomPadding: i,
  padding: l = "medium",
  imageSrc: c,
  imagePosition: s,
  imageAlt: u,
  reverseBGColor: d,
  bgImage: g,
  ...b
}) {
  const h = H(
    he.section,
    t,
    a && he[Ic[a]],
    he[jc[o]],
    n && he["is-full-height"],
    r && he["center-content"],
    c && he["image-flex"],
    s === "right" && he["image-reverse"],
    d && he["reverse-bg-color"]
  ), { isMobile: k } = rr();
  return /* @__PURE__ */ R("section", { ...b, className: h, children: [
    c && /* @__PURE__ */ p("div", { className: he["image-container"], children: /* @__PURE__ */ p("img", { src: c, alt: u }) }),
    /* @__PURE__ */ p(
      "div",
      {
        className: H(
          he.content,
          i && he["is-top-bottom-padding"],
          l && he[Oc[l]],
          g && he["bg-image"]
        ),
        style: !k && g ? { backgroundImage: `url(${g})` } : {},
        children: e
      }
    )
  ] });
}
function gr(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = gr(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function Ec() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = gr(e)) && (o && (o += " "), o += t);
  return o;
}
const Bc = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Tc = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Rc = Bc.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Tc[e]
})), Fc = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Vc = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Gc(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ p("span", { className: a }, a));
}
const Uc = kt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Rc.find((c) => c.name === e), l = Ec("icon", `ds-${i?.class}`, Vc[t], Fc[a], o);
    return /* @__PURE__ */ p("i", { className: l, ...n, ref: r, children: Gc(i?.paths) });
  }
);
Uc.displayName = "Icon";
const Zc = ["en", "fr", "it"], fr = Na({
  locale: "en"
});
function Wc({ children: e, ...t }) {
  return /* @__PURE__ */ p(fr.Provider, { value: t, children: e });
}
const Kc = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function qc(e) {
  return Zc.includes(e) && !0;
}
function Hc(e, t) {
  const a = Kc.test(t);
  let o;
  return qc(e) || a ? o = `${t}` : o = `/${e}${t}`, { url: o };
}
function Ua(e) {
  const { locale: t } = Oa(fr);
  return Hc(t, e);
}
function Jc() {
  const [e, t] = xe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ie(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function br() {
  const { width: e } = Jc();
  let t = "desktop";
  return e && e <= ro.MOBILE ? t = "mobile" : e && e <= ro.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
const Do = (e, t, a) => {
  if (e && "reportValidity" in e) {
    const o = C(a, t);
    e.setCustomValidity(o && o.message || ""), e.reportValidity();
  }
}, Ca = (e, t) => {
  for (const a in t.fields) {
    const o = t.fields[a];
    o && o.ref && "reportValidity" in o.ref ? Do(o.ref, a, e) : o && o.refs && o.refs.forEach((n) => Do(n, a, e));
  }
}, No = (e, t) => {
  t.shouldUseNativeValidation && Ca(e, t);
  const a = {};
  for (const o in e) {
    const n = C(t.fields, o), r = Object.assign(e[o] || {}, { ref: n && n.ref });
    if (Yc(t.names || Object.keys(e), o)) {
      const i = Object.assign({}, C(a, o));
      G(i, "root", r), G(a, o, i);
    } else G(a, o, r);
  }
  return a;
}, Yc = (e, t) => {
  const a = Oo(t);
  return e.some((o) => Oo(o).match(`^${a}\\.\\d+`));
};
function Oo(e) {
  return e.replace(/\]|\[/g, "");
}
function $(e, t, a) {
  function o(l, c) {
    var s;
    Object.defineProperty(l, "_zod", {
      value: l._zod ?? {},
      enumerable: !1
    }), (s = l._zod).traits ?? (s.traits = /* @__PURE__ */ new Set()), l._zod.traits.add(e), t(l, c);
    for (const u in i.prototype)
      u in l || Object.defineProperty(l, u, { value: i.prototype[u].bind(l) });
    l._zod.constr = i, l._zod.def = c;
  }
  const n = a?.Parent ?? Object;
  class r extends n {
  }
  Object.defineProperty(r, "name", { value: e });
  function i(l) {
    var c;
    const s = a?.Parent ? new r() : this;
    o(s, l), (c = s._zod).deferred ?? (c.deferred = []);
    for (const u of s._zod.deferred)
      u();
    return s;
  }
  return Object.defineProperty(i, "init", { value: o }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (l) => a?.Parent && l instanceof a.Parent ? !0 : l?._zod?.traits?.has(e)
  }), Object.defineProperty(i, "name", { value: e }), i;
}
class ot extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class hr extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const mr = {};
function He(e) {
  return mr;
}
function Qc(e) {
  const t = Object.values(e).filter((o) => typeof o == "number");
  return Object.entries(e).filter(([o, n]) => t.indexOf(+o) === -1).map(([o, n]) => n);
}
function Sa(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Za(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Wa(e) {
  return e == null;
}
function Ka(e) {
  const t = e.startsWith("^") ? 1 : 0, a = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, a);
}
const Io = Symbol("evaluating");
function K(e, t, a) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== Io)
        return o === void 0 && (o = Io, o = a()), o;
    },
    set(n) {
      Object.defineProperty(e, t, {
        value: n
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Xc(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function Re(e, t, a) {
  Object.defineProperty(e, t, {
    value: a,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function it(...e) {
  const t = {};
  for (const a of e) {
    const o = Object.getOwnPropertyDescriptors(a);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function jo(e) {
  return JSON.stringify(e);
}
const pr = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Gt(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const eu = Za(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function mt(e) {
  if (Gt(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const a = t.prototype;
  return !(Gt(a) === !1 || Object.prototype.hasOwnProperty.call(a, "isPrototypeOf") === !1);
}
function yr(e) {
  return mt(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const tu = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Xt(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Fe(e, t, a) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || a?.parent) && (o._zod.parent = e), o;
}
function L(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function au(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function ou(e, t) {
  const a = e._zod.def, o = it(e._zod.def, {
    get shape() {
      const n = {};
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && (n[r] = a.shape[r]);
      }
      return Re(this, "shape", n), n;
    },
    checks: []
  });
  return Fe(e, o);
}
function nu(e, t) {
  const a = e._zod.def, o = it(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape };
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && delete n[r];
      }
      return Re(this, "shape", n), n;
    },
    checks: []
  });
  return Fe(e, o);
}
function ru(e, t) {
  if (!mt(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const a = e._zod.def.checks;
  if (a && a.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const n = it(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Fe(e, n);
}
function iu(e, t) {
  if (!mt(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const a = {
    ...e._zod.def,
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return Re(this, "shape", o), o;
    },
    checks: e._zod.def.checks
  };
  return Fe(e, a);
}
function lu(e, t) {
  const a = it(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Re(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Fe(e, a);
}
function su(e, t, a) {
  const o = it(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in n))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i]);
        }
      else
        for (const i in n)
          r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i];
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Fe(t, o);
}
function cu(e, t, a) {
  const o = it(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in r))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          }));
        }
      else
        for (const i in n)
          r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          });
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Fe(t, o);
}
function tt(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let a = t; a < e.issues.length; a++)
    if (e.issues[a]?.continue !== !0)
      return !0;
  return !1;
}
function vr(e, t) {
  return t.map((a) => {
    var o;
    return (o = a).path ?? (o.path = []), a.path.unshift(e), a;
  });
}
function Mt(e) {
  return typeof e == "string" ? e : e?.message;
}
function Je(e, t, a) {
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const n = Mt(e.inst?._zod.def?.error?.(e)) ?? Mt(t?.error?.(e)) ?? Mt(a.customError?.(e)) ?? Mt(a.localeError?.(e)) ?? "Invalid input";
    o.message = n;
  }
  return delete o.inst, delete o.continue, t?.reportInput || delete o.input, o;
}
function qa(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function pt(...e) {
  const [t, a, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: a,
    inst: o
  } : { ...t };
}
const kr = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Sa, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Ha = $("$ZodError", kr), ea = $("$ZodError", kr, { Parent: Error });
function uu(e, t = (a) => a.message) {
  const a = {}, o = [];
  for (const n of e.issues)
    n.path.length > 0 ? (a[n.path[0]] = a[n.path[0]] || [], a[n.path[0]].push(t(n))) : o.push(t(n));
  return { formErrors: o, fieldErrors: a };
}
function du(e, t) {
  const a = t || function(r) {
    return r.message;
  }, o = { _errors: [] }, n = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((l) => n({ issues: l }));
      else if (i.code === "invalid_key")
        n({ issues: i.issues });
      else if (i.code === "invalid_element")
        n({ issues: i.issues });
      else if (i.path.length === 0)
        o._errors.push(a(i));
      else {
        let l = o, c = 0;
        for (; c < i.path.length; ) {
          const s = i.path[c];
          c === i.path.length - 1 ? (l[s] = l[s] || { _errors: [] }, l[s]._errors.push(a(i))) : l[s] = l[s] || { _errors: [] }, l = l[s], c++;
        }
      }
  };
  return n(e), o;
}
const ta = (e) => (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise)
    throw new ot();
  if (i.issues.length) {
    const l = new (n?.Err ?? e)(i.issues.map((c) => Je(c, r, He())));
    throw pr(l, n?.callee), l;
  }
  return i.value;
}, _u = /* @__PURE__ */ ta(ea), aa = (e) => async (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const l = new (n?.Err ?? e)(i.issues.map((c) => Je(c, r, He())));
    throw pr(l, n?.callee), l;
  }
  return i.value;
}, gu = /* @__PURE__ */ aa(ea), oa = (e) => (t, a, o) => {
  const n = o ? { ...o, async: !1 } : { async: !1 }, r = t._zod.run({ value: a, issues: [] }, n);
  if (r instanceof Promise)
    throw new ot();
  return r.issues.length ? {
    success: !1,
    error: new (e ?? Ha)(r.issues.map((i) => Je(i, n, He())))
  } : { success: !0, data: r.value };
}, fu = /* @__PURE__ */ oa(ea), na = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let r = t._zod.run({ value: a, issues: [] }, n);
  return r instanceof Promise && (r = await r), r.issues.length ? {
    success: !1,
    error: new e(r.issues.map((i) => Je(i, n, He())))
  } : { success: !0, data: r.value };
}, bu = /* @__PURE__ */ na(ea), hu = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return ta(e)(t, a, n);
}, mu = (e) => (t, a, o) => ta(e)(t, a, o), pu = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return aa(e)(t, a, n);
}, yu = (e) => async (t, a, o) => aa(e)(t, a, o), vu = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return oa(e)(t, a, n);
}, ku = (e) => (t, a, o) => oa(e)(t, a, o), $u = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return na(e)(t, a, n);
}, wu = (e) => async (t, a, o) => na(e)(t, a, o), xu = /^[cC][^\s-]{8,}$/, Cu = /^[0-9a-z]+$/, Su = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, zu = /^[0-9a-vA-V]{20}$/, Au = /^[A-Za-z0-9]{27}$/, Pu = /^[a-zA-Z0-9_-]{21}$/, Mu = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Du = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Lo = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Nu = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Ou = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Iu() {
  return new RegExp(Ou, "u");
}
const ju = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Lu = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Eu = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Bu = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Tu = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, $r = /^[A-Za-z0-9_-]*$/, Ru = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Fu = /^\+(?:[0-9]){6,14}[0-9]$/, wr = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Vu = /* @__PURE__ */ new RegExp(`^${wr}$`);
function xr(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Gu(e) {
  return new RegExp(`^${xr(e)}$`);
}
function Uu(e) {
  const t = xr({ precision: e.precision }), a = ["Z"];
  e.local && a.push(""), e.offset && a.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${a.join("|")})`;
  return new RegExp(`^${wr}T(?:${o})$`);
}
const Zu = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Wu = /^[^A-Z]*$/, Ku = /^[^a-z]*$/, ze = /* @__PURE__ */ $("$ZodCheck", (e, t) => {
  var a;
  e._zod ?? (e._zod = {}), e._zod.def = t, (a = e._zod).onattach ?? (a.onattach = []);
}), qu = /* @__PURE__ */ $("$ZodCheckMaxLength", (e, t) => {
  var a;
  ze.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Wa(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < n && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length <= t.maximum)
      return;
    const i = qa(n);
    o.issues.push({
      origin: i,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Hu = /* @__PURE__ */ $("$ZodCheckMinLength", (e, t) => {
  var a;
  ze.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Wa(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > n && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length >= t.minimum)
      return;
    const i = qa(n);
    o.issues.push({
      origin: i,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Ju = /* @__PURE__ */ $("$ZodCheckLengthEquals", (e, t) => {
  var a;
  ze.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Wa(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.minimum = t.length, n.maximum = t.length, n.length = t.length;
  }), e._zod.check = (o) => {
    const n = o.value, r = n.length;
    if (r === t.length)
      return;
    const i = qa(n), l = r > t.length;
    o.issues.push({
      origin: i,
      ...l ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ra = /* @__PURE__ */ $("$ZodCheckStringFormat", (e, t) => {
  var a, o;
  ze.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = t.format, t.pattern && (r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(t.pattern));
  }), t.pattern ? (a = e._zod).check ?? (a.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: n.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), Yu = /* @__PURE__ */ $("$ZodCheckRegex", (e, t) => {
  ra.init(e, t), e._zod.check = (a) => {
    t.pattern.lastIndex = 0, !t.pattern.test(a.value) && a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: a.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Qu = /* @__PURE__ */ $("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Wu), ra.init(e, t);
}), Xu = /* @__PURE__ */ $("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Ku), ra.init(e, t);
}), ed = /* @__PURE__ */ $("$ZodCheckIncludes", (e, t) => {
  ze.init(e, t);
  const a = Xt(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${a}` : a);
  t.pattern = o, e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(o);
  }), e._zod.check = (n) => {
    n.value.includes(t.includes, t.position) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), td = /* @__PURE__ */ $("$ZodCheckStartsWith", (e, t) => {
  ze.init(e, t);
  const a = new RegExp(`^${Xt(t.prefix)}.*`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ad = /* @__PURE__ */ $("$ZodCheckEndsWith", (e, t) => {
  ze.init(e, t);
  const a = new RegExp(`.*${Xt(t.suffix)}$`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), od = /* @__PURE__ */ $("$ZodCheckOverwrite", (e, t) => {
  ze.init(e, t), e._zod.check = (a) => {
    a.value = t.tx(a.value);
  };
});
class nd {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const o = t.split(`
`).filter((i) => i), n = Math.min(...o.map((i) => i.length - i.trimStart().length)), r = o.map((i) => i.slice(n)).map((i) => " ".repeat(this.indent * 2) + i);
    for (const i of r)
      this.content.push(i);
  }
  compile() {
    const t = Function, a = this?.args, n = [...(this?.content ?? [""]).map((r) => `  ${r}`)];
    return new t(...a, n.join(`
`));
  }
}
const rd = {
  major: 4,
  minor: 1,
  patch: 9
}, le = /* @__PURE__ */ $("$ZodType", (e, t) => {
  var a;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = rd;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const n of o)
    for (const r of n._zod.onattach)
      r(e);
  if (o.length === 0)
    (a = e._zod).deferred ?? (a.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const n = (i, l, c) => {
      let s = tt(i), u;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(i))
            continue;
        } else if (s)
          continue;
        const g = i.issues.length, b = d._zod.check(i);
        if (b instanceof Promise && c?.async === !1)
          throw new ot();
        if (u || b instanceof Promise)
          u = (u ?? Promise.resolve()).then(async () => {
            await b, i.issues.length !== g && (s || (s = tt(i, g)));
          });
        else {
          if (i.issues.length === g)
            continue;
          s || (s = tt(i, g));
        }
      }
      return u ? u.then(() => i) : i;
    }, r = (i, l, c) => {
      if (tt(i))
        return i.aborted = !0, i;
      const s = n(l, o, c);
      if (s instanceof Promise) {
        if (c.async === !1)
          throw new ot();
        return s.then((u) => e._zod.parse(u, c));
      }
      return e._zod.parse(s, c);
    };
    e._zod.run = (i, l) => {
      if (l.skipChecks)
        return e._zod.parse(i, l);
      if (l.direction === "backward") {
        const s = e._zod.parse({ value: i.value, issues: [] }, { ...l, skipChecks: !0 });
        return s instanceof Promise ? s.then((u) => r(u, i, l)) : r(s, i, l);
      }
      const c = e._zod.parse(i, l);
      if (c instanceof Promise) {
        if (l.async === !1)
          throw new ot();
        return c.then((s) => n(s, o, l));
      }
      return n(c, o, l);
    };
  }
  e["~standard"] = {
    validate: (n) => {
      try {
        const r = fu(e, n);
        return r.success ? { value: r.data } : { issues: r.error?.issues };
      } catch {
        return bu(e, n).then((i) => i.success ? { value: i.data } : { issues: i.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), Ja = /* @__PURE__ */ $("$ZodString", (e, t) => {
  le.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? Zu(e._zod.bag), e._zod.parse = (a, o) => {
    if (t.coerce)
      try {
        a.value = String(a.value);
      } catch {
      }
    return typeof a.value == "string" || a.issues.push({
      expected: "string",
      code: "invalid_type",
      input: a.value,
      inst: e
    }), a;
  };
}), J = /* @__PURE__ */ $("$ZodStringFormat", (e, t) => {
  ra.init(e, t), Ja.init(e, t);
}), id = /* @__PURE__ */ $("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Du), J.init(e, t);
}), ld = /* @__PURE__ */ $("$ZodUUID", (e, t) => {
  if (t.version) {
    const o = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (o === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Lo(o));
  } else
    t.pattern ?? (t.pattern = Lo());
  J.init(e, t);
}), sd = /* @__PURE__ */ $("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Nu), J.init(e, t);
}), cd = /* @__PURE__ */ $("$ZodURL", (e, t) => {
  J.init(e, t), e._zod.check = (a) => {
    try {
      const o = a.value.trim(), n = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(n.hostname) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Ru.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(n.protocol.endsWith(":") ? n.protocol.slice(0, -1) : n.protocol) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? a.value = n.href : a.value = o;
      return;
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "url",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), ud = /* @__PURE__ */ $("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Iu()), J.init(e, t);
}), dd = /* @__PURE__ */ $("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Pu), J.init(e, t);
}), _d = /* @__PURE__ */ $("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = xu), J.init(e, t);
}), gd = /* @__PURE__ */ $("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Cu), J.init(e, t);
}), fd = /* @__PURE__ */ $("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Su), J.init(e, t);
}), bd = /* @__PURE__ */ $("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = zu), J.init(e, t);
}), hd = /* @__PURE__ */ $("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Au), J.init(e, t);
}), md = /* @__PURE__ */ $("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Uu(t)), J.init(e, t);
}), pd = /* @__PURE__ */ $("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Vu), J.init(e, t);
}), yd = /* @__PURE__ */ $("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Gu(t)), J.init(e, t);
}), vd = /* @__PURE__ */ $("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Mu), J.init(e, t);
}), kd = /* @__PURE__ */ $("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = ju), J.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv4";
  });
}), $d = /* @__PURE__ */ $("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Lu), J.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (a) => {
    try {
      new URL(`http://[${a.value}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), wd = /* @__PURE__ */ $("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Eu), J.init(e, t);
}), xd = /* @__PURE__ */ $("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Bu), J.init(e, t), e._zod.check = (a) => {
    const o = a.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [n, r] = o;
      if (!r)
        throw new Error();
      const i = Number(r);
      if (`${i}` !== r)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${n}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Cr(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Cd = /* @__PURE__ */ $("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Tu), J.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (a) => {
    Cr(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Sd(e) {
  if (!$r.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), a = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Cr(a);
}
const zd = /* @__PURE__ */ $("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = $r), J.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (a) => {
    Sd(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ad = /* @__PURE__ */ $("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Fu), J.init(e, t);
});
function Pd(e, t = null) {
  try {
    const a = e.split(".");
    if (a.length !== 3)
      return !1;
    const [o] = a;
    if (!o)
      return !1;
    const n = JSON.parse(atob(o));
    return !("typ" in n && n?.typ !== "JWT" || !n.alg || t && (!("alg" in n) || n.alg !== t));
  } catch {
    return !1;
  }
}
const Md = /* @__PURE__ */ $("$ZodJWT", (e, t) => {
  J.init(e, t), e._zod.check = (a) => {
    Pd(a.value, t.alg) || a.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Dd = /* @__PURE__ */ $("$ZodUnknown", (e, t) => {
  le.init(e, t), e._zod.parse = (a) => a;
}), Nd = /* @__PURE__ */ $("$ZodNever", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => (a.issues.push({
    expected: "never",
    code: "invalid_type",
    input: a.value,
    inst: e
  }), a);
});
function Eo(e, t, a) {
  e.issues.length && t.issues.push(...vr(a, e.issues)), t.value[a] = e.value;
}
const Od = /* @__PURE__ */ $("$ZodArray", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value;
    if (!Array.isArray(n))
      return a.issues.push({
        expected: "array",
        code: "invalid_type",
        input: n,
        inst: e
      }), a;
    a.value = Array(n.length);
    const r = [];
    for (let i = 0; i < n.length; i++) {
      const l = n[i], c = t.element._zod.run({
        value: l,
        issues: []
      }, o);
      c instanceof Promise ? r.push(c.then((s) => Eo(s, a, i))) : Eo(c, a, i);
    }
    return r.length ? Promise.all(r).then(() => a) : a;
  };
});
function Ut(e, t, a, o) {
  e.issues.length && t.issues.push(...vr(a, e.issues)), e.value === void 0 ? a in o && (t.value[a] = void 0) : t.value[a] = e.value;
}
function Sr(e) {
  const t = Object.keys(e.shape);
  for (const o of t)
    if (!e.shape?.[o]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${o}": expected a Zod schema`);
  const a = au(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(a)
  };
}
function zr(e, t, a, o, n, r) {
  const i = [], l = n.keySet, c = n.catchall._zod, s = c.def.type;
  for (const u of Object.keys(t)) {
    if (l.has(u))
      continue;
    if (s === "never") {
      i.push(u);
      continue;
    }
    const d = c.run({ value: t[u], issues: [] }, o);
    d instanceof Promise ? e.push(d.then((g) => Ut(g, a, u, t))) : Ut(d, a, u, t);
  }
  return i.length && a.issues.push({
    code: "unrecognized_keys",
    keys: i,
    input: t,
    inst: r
  }), e.length ? Promise.all(e).then(() => a) : a;
}
const Id = /* @__PURE__ */ $("$ZodObject", (e, t) => {
  le.init(e, t);
  const a = Za(() => Sr(t));
  K(e._zod, "propValues", () => {
    const i = t.shape, l = {};
    for (const c in i) {
      const s = i[c]._zod;
      if (s.values) {
        l[c] ?? (l[c] = /* @__PURE__ */ new Set());
        for (const u of s.values)
          l[c].add(u);
      }
    }
    return l;
  });
  const o = Gt, n = t.catchall;
  let r;
  e._zod.parse = (i, l) => {
    r ?? (r = a.value);
    const c = i.value;
    if (!o(c))
      return i.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: e
      }), i;
    i.value = {};
    const s = [], u = r.shape;
    for (const d of r.keys) {
      const b = u[d]._zod.run({ value: c[d], issues: [] }, l);
      b instanceof Promise ? s.push(b.then((h) => Ut(h, i, d, c))) : Ut(b, i, d, c);
    }
    return n ? zr(s, c, i, l, a.value, e) : s.length ? Promise.all(s).then(() => i) : i;
  };
}), jd = /* @__PURE__ */ $("$ZodObjectJIT", (e, t) => {
  Id.init(e, t);
  const a = e._zod.parse, o = Za(() => Sr(t)), n = (g) => {
    const b = new nd(["shape", "payload", "ctx"]), h = o.value, k = (M) => {
      const A = jo(M);
      return `shape[${A}]._zod.run({ value: input[${A}], issues: [] }, ctx)`;
    };
    b.write("const input = payload.value;");
    const v = /* @__PURE__ */ Object.create(null);
    let P = 0;
    for (const M of h.keys)
      v[M] = `key_${P++}`;
    b.write("const newResult = {};");
    for (const M of h.keys) {
      const A = v[M], N = jo(M);
      b.write(`const ${A} = ${k(M)};`), b.write(`
        if (${A}.issues.length) {
          payload.issues = payload.issues.concat(${A}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${N}, ...iss.path] : [${N}]
          })));
        }
        
        
        if (${A}.value === undefined) {
          if (${N} in input) {
            newResult[${N}] = undefined;
          }
        } else {
          newResult[${N}] = ${A}.value;
        }
        
      `);
    }
    b.write("payload.value = newResult;"), b.write("return payload;");
    const y = b.compile();
    return (M, A) => y(g, M, A);
  };
  let r;
  const i = Gt, l = !mr.jitless, s = l && eu.value, u = t.catchall;
  let d;
  e._zod.parse = (g, b) => {
    d ?? (d = o.value);
    const h = g.value;
    return i(h) ? l && s && b?.async === !1 && b.jitless !== !0 ? (r || (r = n(t.shape)), g = r(g, b), u ? zr([], h, g, b, d, e) : g) : a(g, b) : (g.issues.push({
      expected: "object",
      code: "invalid_type",
      input: h,
      inst: e
    }), g);
  };
});
function Bo(e, t, a, o) {
  for (const r of e)
    if (r.issues.length === 0)
      return t.value = r.value, t;
  const n = e.filter((r) => !tt(r));
  return n.length === 1 ? (t.value = n[0].value, n[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: a,
    errors: e.map((r) => r.issues.map((i) => Je(i, o, He())))
  }), t);
}
const Ld = /* @__PURE__ */ $("$ZodUnion", (e, t) => {
  le.init(e, t), K(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), K(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), K(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), K(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${n.map((r) => Ka(r.source)).join("|")})$`);
    }
  });
  const a = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (n, r) => {
    if (a)
      return o(n, r);
    let i = !1;
    const l = [];
    for (const c of t.options) {
      const s = c._zod.run({
        value: n.value,
        issues: []
      }, r);
      if (s instanceof Promise)
        l.push(s), i = !0;
      else {
        if (s.issues.length === 0)
          return s;
        l.push(s);
      }
    }
    return i ? Promise.all(l).then((c) => Bo(c, n, e, r)) : Bo(l, n, e, r);
  };
}), Ed = /* @__PURE__ */ $("$ZodIntersection", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value, r = t.left._zod.run({ value: n, issues: [] }, o), i = t.right._zod.run({ value: n, issues: [] }, o);
    return r instanceof Promise || i instanceof Promise ? Promise.all([r, i]).then(([c, s]) => To(a, c, s)) : To(a, r, i);
  };
});
function za(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (mt(e) && mt(t)) {
    const a = Object.keys(t), o = Object.keys(e).filter((r) => a.indexOf(r) !== -1), n = { ...e, ...t };
    for (const r of o) {
      const i = za(e[r], t[r]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      n[r] = i.data;
    }
    return { valid: !0, data: n };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const a = [];
    for (let o = 0; o < e.length; o++) {
      const n = e[o], r = t[o], i = za(n, r);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...i.mergeErrorPath]
        };
      a.push(i.data);
    }
    return { valid: !0, data: a };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function To(e, t, a) {
  if (t.issues.length && e.issues.push(...t.issues), a.issues.length && e.issues.push(...a.issues), tt(e))
    return e;
  const o = za(t.value, a.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const Bd = /* @__PURE__ */ $("$ZodEnum", (e, t) => {
  le.init(e, t);
  const a = Qc(t.entries), o = new Set(a);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${a.filter((n) => tu.has(typeof n)).map((n) => typeof n == "string" ? Xt(n) : n.toString()).join("|")})$`), e._zod.parse = (n, r) => {
    const i = n.value;
    return o.has(i) || n.issues.push({
      code: "invalid_value",
      values: a,
      input: i,
      inst: e
    }), n;
  };
}), Td = /* @__PURE__ */ $("$ZodTransform", (e, t) => {
  le.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new hr(e.constructor.name);
    const n = t.transform(a.value, a);
    if (o.async)
      return (n instanceof Promise ? n : Promise.resolve(n)).then((i) => (a.value = i, a));
    if (n instanceof Promise)
      throw new ot();
    return a.value = n, a;
  };
});
function Ro(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Rd = /* @__PURE__ */ $("$ZodOptional", (e, t) => {
  le.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", K(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), K(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Ka(a.source)})?$`) : void 0;
  }), e._zod.parse = (a, o) => {
    if (t.innerType._zod.optin === "optional") {
      const n = t.innerType._zod.run(a, o);
      return n instanceof Promise ? n.then((r) => Ro(r, a.value)) : Ro(n, a.value);
    }
    return a.value === void 0 ? a : t.innerType._zod.run(a, o);
  };
}), Fd = /* @__PURE__ */ $("$ZodNullable", (e, t) => {
  le.init(e, t), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), K(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Ka(a.source)}|null)$`) : void 0;
  }), K(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (a, o) => a.value === null ? a : t.innerType._zod.run(a, o);
}), Vd = /* @__PURE__ */ $("$ZodDefault", (e, t) => {
  le.init(e, t), e._zod.optin = "optional", K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    if (a.value === void 0)
      return a.value = t.defaultValue, a;
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Fo(r, t)) : Fo(n, t);
  };
});
function Fo(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Gd = /* @__PURE__ */ $("$ZodPrefault", (e, t) => {
  le.init(e, t), e._zod.optin = "optional", K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => (o.direction === "backward" || a.value === void 0 && (a.value = t.defaultValue), t.innerType._zod.run(a, o));
}), Ud = /* @__PURE__ */ $("$ZodNonOptional", (e, t) => {
  le.init(e, t), K(e._zod, "values", () => {
    const a = t.innerType._zod.values;
    return a ? new Set([...a].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (a, o) => {
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Vo(r, e)) : Vo(n, e);
  };
});
function Vo(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Zd = /* @__PURE__ */ $("$ZodCatch", (e, t) => {
  le.init(e, t), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), K(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => (a.value = r.value, r.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: r.issues.map((i) => Je(i, o, He()))
      },
      input: a.value
    }), a.issues = []), a)) : (a.value = n.value, n.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: n.issues.map((r) => Je(r, o, He()))
      },
      input: a.value
    }), a.issues = []), a);
  };
}), Wd = /* @__PURE__ */ $("$ZodPipe", (e, t) => {
  le.init(e, t), K(e._zod, "values", () => t.in._zod.values), K(e._zod, "optin", () => t.in._zod.optin), K(e._zod, "optout", () => t.out._zod.optout), K(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (a, o) => {
    if (o.direction === "backward") {
      const r = t.out._zod.run(a, o);
      return r instanceof Promise ? r.then((i) => Dt(i, t.in, o)) : Dt(r, t.in, o);
    }
    const n = t.in._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Dt(r, t.out, o)) : Dt(n, t.out, o);
  };
});
function Dt(e, t, a) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, a);
}
const Kd = /* @__PURE__ */ $("$ZodReadonly", (e, t) => {
  le.init(e, t), K(e._zod, "propValues", () => t.innerType._zod.propValues), K(e._zod, "values", () => t.innerType._zod.values), K(e._zod, "optin", () => t.innerType._zod.optin), K(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then(Go) : Go(n);
  };
});
function Go(e) {
  return e.value = Object.freeze(e.value), e;
}
const qd = /* @__PURE__ */ $("$ZodCustom", (e, t) => {
  ze.init(e, t), le.init(e, t), e._zod.parse = (a, o) => a, e._zod.check = (a) => {
    const o = a.value, n = t.fn(o);
    if (n instanceof Promise)
      return n.then((r) => Uo(r, a, o, e));
    Uo(n, a, o, e);
  };
});
function Uo(e, t, a, o) {
  if (!e) {
    const n = {
      code: "custom",
      input: a,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (n.params = o._zod.def.params), t.issues.push(pt(n));
  }
}
class Hd {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...a) {
    const o = a[0];
    if (this._map.set(t, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const a = this._map.get(t);
    return a && typeof a == "object" && "id" in a && this._idmap.delete(a.id), this._map.delete(t), this;
  }
  get(t) {
    const a = t._zod.parent;
    if (a) {
      const o = { ...this.get(a) ?? {} };
      delete o.id;
      const n = { ...o, ...this._map.get(t) };
      return Object.keys(n).length ? n : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Jd() {
  return new Hd();
}
const Nt = /* @__PURE__ */ Jd();
function Yd(e, t) {
  return new e({
    type: "string",
    ...L(t)
  });
}
function Qd(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function Zo(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function Xd(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function e_(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...L(t)
  });
}
function t_(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...L(t)
  });
}
function a_(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...L(t)
  });
}
function o_(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function n_(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function r_(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function i_(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function l_(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function s_(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function c_(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function u_(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function d_(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function __(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function g_(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function f_(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function b_(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function h_(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function m_(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function p_(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...L(t)
  });
}
function y_(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...L(t)
  });
}
function v_(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...L(t)
  });
}
function k_(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...L(t)
  });
}
function $_(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...L(t)
  });
}
function w_(e) {
  return new e({
    type: "unknown"
  });
}
function x_(e, t) {
  return new e({
    type: "never",
    ...L(t)
  });
}
function Ar(e, t) {
  return new qu({
    check: "max_length",
    ...L(t),
    maximum: e
  });
}
function Zt(e, t) {
  return new Hu({
    check: "min_length",
    ...L(t),
    minimum: e
  });
}
function Pr(e, t) {
  return new Ju({
    check: "length_equals",
    ...L(t),
    length: e
  });
}
function C_(e, t) {
  return new Yu({
    check: "string_format",
    format: "regex",
    ...L(t),
    pattern: e
  });
}
function S_(e) {
  return new Qu({
    check: "string_format",
    format: "lowercase",
    ...L(e)
  });
}
function z_(e) {
  return new Xu({
    check: "string_format",
    format: "uppercase",
    ...L(e)
  });
}
function A_(e, t) {
  return new ed({
    check: "string_format",
    format: "includes",
    ...L(t),
    includes: e
  });
}
function P_(e, t) {
  return new td({
    check: "string_format",
    format: "starts_with",
    ...L(t),
    prefix: e
  });
}
function M_(e, t) {
  return new ad({
    check: "string_format",
    format: "ends_with",
    ...L(t),
    suffix: e
  });
}
function xt(e) {
  return new od({
    check: "overwrite",
    tx: e
  });
}
function D_(e) {
  return xt((t) => t.normalize(e));
}
function N_() {
  return xt((e) => e.trim());
}
function O_() {
  return xt((e) => e.toLowerCase());
}
function I_() {
  return xt((e) => e.toUpperCase());
}
function j_(e, t, a) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...L(a)
  });
}
function L_(e, t, a) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...L(a)
  });
}
function E_(e) {
  const t = B_((a) => (a.addIssue = (o) => {
    if (typeof o == "string")
      a.issues.push(pt(o, a.value, t._zod.def));
    else {
      const n = o;
      n.fatal && (n.continue = !1), n.code ?? (n.code = "custom"), n.input ?? (n.input = a.value), n.inst ?? (n.inst = t), n.continue ?? (n.continue = !t._zod.def.abort), a.issues.push(pt(n));
    }
  }, e(a.value, a)));
  return t;
}
function B_(e, t) {
  const a = new ze({
    check: "custom",
    ...L(t)
  });
  return a._zod.check = e, a;
}
function Wo(e, t) {
  try {
    var a = e();
  } catch (o) {
    return t(o);
  }
  return a && a.then ? a.then(void 0, t) : a;
}
function T_(e, t) {
  for (var a = {}; e.length; ) {
    var o = e[0], n = o.code, r = o.message, i = o.path.join(".");
    if (!a[i]) if ("unionErrors" in o) {
      var l = o.unionErrors[0].errors[0];
      a[i] = { message: l.message, type: l.code };
    } else a[i] = { message: r, type: n };
    if ("unionErrors" in o && o.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(d) {
        return e.push(d);
      });
    }), t) {
      var c = a[i].types, s = c && c[o.code];
      a[i] = Ta(i, t, a, n, s ? [].concat(s, o.message) : o.message);
    }
    e.shift();
  }
  return a;
}
function R_(e, t) {
  for (var a = {}; e.length; ) {
    var o = e[0], n = o.code, r = o.message, i = o.path.join(".");
    if (!a[i]) if (o.code === "invalid_union" && o.errors.length > 0) {
      var l = o.errors[0][0];
      a[i] = { message: l.message, type: l.code };
    } else a[i] = { message: r, type: n };
    if (o.code === "invalid_union" && o.errors.forEach(function(u) {
      return u.forEach(function(d) {
        return e.push(d);
      });
    }), t) {
      var c = a[i].types, s = c && c[o.code];
      a[i] = Ta(i, t, a, n, s ? [].concat(s, o.message) : o.message);
    }
    e.shift();
  }
  return a;
}
function F_(e, t, a) {
  if (a === void 0 && (a = {}), function(o) {
    return "_def" in o && typeof o._def == "object" && "typeName" in o._def;
  }(e)) return function(o, n, r) {
    try {
      return Promise.resolve(Wo(function() {
        return Promise.resolve(e[a.mode === "sync" ? "parse" : "parseAsync"](o, t)).then(function(i) {
          return r.shouldUseNativeValidation && Ca({}, r), { errors: {}, values: a.raw ? Object.assign({}, o) : i };
        });
      }, function(i) {
        if (function(l) {
          return Array.isArray(l?.issues);
        }(i)) return { values: {}, errors: No(T_(i.errors, !r.shouldUseNativeValidation && r.criteriaMode === "all"), r) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  if (function(o) {
    return "_zod" in o && typeof o._zod == "object";
  }(e)) return function(o, n, r) {
    try {
      return Promise.resolve(Wo(function() {
        return Promise.resolve((a.mode === "sync" ? _u : gu)(e, o, t)).then(function(i) {
          return r.shouldUseNativeValidation && Ca({}, r), { errors: {}, values: a.raw ? Object.assign({}, o) : i };
        });
      }, function(i) {
        if (function(l) {
          return l instanceof Ha;
        }(i)) return { values: {}, errors: No(R_(i.issues, !r.shouldUseNativeValidation && r.criteriaMode === "all"), r) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  throw new Error("Invalid input: not a Zod schema");
}
const V_ = /* @__PURE__ */ $("ZodISODateTime", (e, t) => {
  md.init(e, t), Y.init(e, t);
});
function G_(e) {
  return y_(V_, e);
}
const U_ = /* @__PURE__ */ $("ZodISODate", (e, t) => {
  pd.init(e, t), Y.init(e, t);
});
function Z_(e) {
  return v_(U_, e);
}
const W_ = /* @__PURE__ */ $("ZodISOTime", (e, t) => {
  yd.init(e, t), Y.init(e, t);
});
function K_(e) {
  return k_(W_, e);
}
const q_ = /* @__PURE__ */ $("ZodISODuration", (e, t) => {
  vd.init(e, t), Y.init(e, t);
});
function H_(e) {
  return $_(q_, e);
}
const J_ = (e, t) => {
  Ha.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (a) => du(e, a)
      // enumerable: false,
    },
    flatten: {
      value: (a) => uu(e, a)
      // enumerable: false,
    },
    addIssue: {
      value: (a) => {
        e.issues.push(a), e.message = JSON.stringify(e.issues, Sa, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (a) => {
        e.issues.push(...a), e.message = JSON.stringify(e.issues, Sa, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, ye = $("ZodError", J_, {
  Parent: Error
}), Y_ = /* @__PURE__ */ ta(ye), Q_ = /* @__PURE__ */ aa(ye), X_ = /* @__PURE__ */ oa(ye), eg = /* @__PURE__ */ na(ye), tg = /* @__PURE__ */ hu(ye), ag = /* @__PURE__ */ mu(ye), og = /* @__PURE__ */ pu(ye), ng = /* @__PURE__ */ yu(ye), rg = /* @__PURE__ */ vu(ye), ig = /* @__PURE__ */ ku(ye), lg = /* @__PURE__ */ $u(ye), sg = /* @__PURE__ */ wu(ye), se = /* @__PURE__ */ $("ZodType", (e, t) => (le.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...a) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...a.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
    ]
  }
  // { parent: true }
), e.clone = (a, o) => Fe(e, a, o), e.brand = () => e, e.register = (a, o) => (a.add(e, o), e), e.parse = (a, o) => Y_(e, a, o, { callee: e.parse }), e.safeParse = (a, o) => X_(e, a, o), e.parseAsync = async (a, o) => Q_(e, a, o, { callee: e.parseAsync }), e.safeParseAsync = async (a, o) => eg(e, a, o), e.spa = e.safeParseAsync, e.encode = (a, o) => tg(e, a, o), e.decode = (a, o) => ag(e, a, o), e.encodeAsync = async (a, o) => og(e, a, o), e.decodeAsync = async (a, o) => ng(e, a, o), e.safeEncode = (a, o) => rg(e, a, o), e.safeDecode = (a, o) => ig(e, a, o), e.safeEncodeAsync = async (a, o) => lg(e, a, o), e.safeDecodeAsync = async (a, o) => sg(e, a, o), e.refine = (a, o) => e.check(Xg(a, o)), e.superRefine = (a) => e.check(ef(a)), e.overwrite = (a) => e.check(xt(a)), e.optional = () => Jo(e), e.nullable = () => Yo(e), e.nullish = () => Jo(Yo(e)), e.nonoptional = (a) => Wg(e, a), e.array = () => Dg(e), e.or = (a) => jg([e, a]), e.and = (a) => Eg(e, a), e.transform = (a) => Qo(e, Rg(a)), e.default = (a) => Gg(e, a), e.prefault = (a) => Zg(e, a), e.catch = (a) => qg(e, a), e.pipe = (a) => Qo(e, a), e.readonly = () => Yg(e), e.describe = (a) => {
  const o = e.clone();
  return Nt.add(o, { description: a }), o;
}, Object.defineProperty(e, "description", {
  get() {
    return Nt.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...a) => {
  if (a.length === 0)
    return Nt.get(e);
  const o = e.clone();
  return Nt.add(o, a[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Mr = /* @__PURE__ */ $("_ZodString", (e, t) => {
  Ja.init(e, t), se.init(e, t);
  const a = e._zod.bag;
  e.format = a.format ?? null, e.minLength = a.minimum ?? null, e.maxLength = a.maximum ?? null, e.regex = (...o) => e.check(C_(...o)), e.includes = (...o) => e.check(A_(...o)), e.startsWith = (...o) => e.check(P_(...o)), e.endsWith = (...o) => e.check(M_(...o)), e.min = (...o) => e.check(Zt(...o)), e.max = (...o) => e.check(Ar(...o)), e.length = (...o) => e.check(Pr(...o)), e.nonempty = (...o) => e.check(Zt(1, ...o)), e.lowercase = (o) => e.check(S_(o)), e.uppercase = (o) => e.check(z_(o)), e.trim = () => e.check(N_()), e.normalize = (...o) => e.check(D_(...o)), e.toLowerCase = () => e.check(O_()), e.toUpperCase = () => e.check(I_());
}), cg = /* @__PURE__ */ $("ZodString", (e, t) => {
  Ja.init(e, t), Mr.init(e, t), e.email = (a) => e.check(Qd(ug, a)), e.url = (a) => e.check(o_(dg, a)), e.jwt = (a) => e.check(p_(Sg, a)), e.emoji = (a) => e.check(n_(_g, a)), e.guid = (a) => e.check(Zo(qo, a)), e.uuid = (a) => e.check(Xd(Ot, a)), e.uuidv4 = (a) => e.check(e_(Ot, a)), e.uuidv6 = (a) => e.check(t_(Ot, a)), e.uuidv7 = (a) => e.check(a_(Ot, a)), e.nanoid = (a) => e.check(r_(gg, a)), e.guid = (a) => e.check(Zo(qo, a)), e.cuid = (a) => e.check(i_(fg, a)), e.cuid2 = (a) => e.check(l_(bg, a)), e.ulid = (a) => e.check(s_(hg, a)), e.base64 = (a) => e.check(b_(wg, a)), e.base64url = (a) => e.check(h_(xg, a)), e.xid = (a) => e.check(c_(mg, a)), e.ksuid = (a) => e.check(u_(pg, a)), e.ipv4 = (a) => e.check(d_(yg, a)), e.ipv6 = (a) => e.check(__(vg, a)), e.cidrv4 = (a) => e.check(g_(kg, a)), e.cidrv6 = (a) => e.check(f_($g, a)), e.e164 = (a) => e.check(m_(Cg, a)), e.datetime = (a) => e.check(G_(a)), e.date = (a) => e.check(Z_(a)), e.time = (a) => e.check(K_(a)), e.duration = (a) => e.check(H_(a));
});
function Ko(e) {
  return Yd(cg, e);
}
const Y = /* @__PURE__ */ $("ZodStringFormat", (e, t) => {
  J.init(e, t), Mr.init(e, t);
}), ug = /* @__PURE__ */ $("ZodEmail", (e, t) => {
  sd.init(e, t), Y.init(e, t);
}), qo = /* @__PURE__ */ $("ZodGUID", (e, t) => {
  id.init(e, t), Y.init(e, t);
}), Ot = /* @__PURE__ */ $("ZodUUID", (e, t) => {
  ld.init(e, t), Y.init(e, t);
}), dg = /* @__PURE__ */ $("ZodURL", (e, t) => {
  cd.init(e, t), Y.init(e, t);
}), _g = /* @__PURE__ */ $("ZodEmoji", (e, t) => {
  ud.init(e, t), Y.init(e, t);
}), gg = /* @__PURE__ */ $("ZodNanoID", (e, t) => {
  dd.init(e, t), Y.init(e, t);
}), fg = /* @__PURE__ */ $("ZodCUID", (e, t) => {
  _d.init(e, t), Y.init(e, t);
}), bg = /* @__PURE__ */ $("ZodCUID2", (e, t) => {
  gd.init(e, t), Y.init(e, t);
}), hg = /* @__PURE__ */ $("ZodULID", (e, t) => {
  fd.init(e, t), Y.init(e, t);
}), mg = /* @__PURE__ */ $("ZodXID", (e, t) => {
  bd.init(e, t), Y.init(e, t);
}), pg = /* @__PURE__ */ $("ZodKSUID", (e, t) => {
  hd.init(e, t), Y.init(e, t);
}), yg = /* @__PURE__ */ $("ZodIPv4", (e, t) => {
  kd.init(e, t), Y.init(e, t);
}), vg = /* @__PURE__ */ $("ZodIPv6", (e, t) => {
  $d.init(e, t), Y.init(e, t);
}), kg = /* @__PURE__ */ $("ZodCIDRv4", (e, t) => {
  wd.init(e, t), Y.init(e, t);
}), $g = /* @__PURE__ */ $("ZodCIDRv6", (e, t) => {
  xd.init(e, t), Y.init(e, t);
}), wg = /* @__PURE__ */ $("ZodBase64", (e, t) => {
  Cd.init(e, t), Y.init(e, t);
}), xg = /* @__PURE__ */ $("ZodBase64URL", (e, t) => {
  zd.init(e, t), Y.init(e, t);
}), Cg = /* @__PURE__ */ $("ZodE164", (e, t) => {
  Ad.init(e, t), Y.init(e, t);
}), Sg = /* @__PURE__ */ $("ZodJWT", (e, t) => {
  Md.init(e, t), Y.init(e, t);
}), zg = /* @__PURE__ */ $("ZodUnknown", (e, t) => {
  Dd.init(e, t), se.init(e, t);
});
function Ho() {
  return w_(zg);
}
const Ag = /* @__PURE__ */ $("ZodNever", (e, t) => {
  Nd.init(e, t), se.init(e, t);
});
function Pg(e) {
  return x_(Ag, e);
}
const Mg = /* @__PURE__ */ $("ZodArray", (e, t) => {
  Od.init(e, t), se.init(e, t), e.element = t.element, e.min = (a, o) => e.check(Zt(a, o)), e.nonempty = (a) => e.check(Zt(1, a)), e.max = (a, o) => e.check(Ar(a, o)), e.length = (a, o) => e.check(Pr(a, o)), e.unwrap = () => e.element;
});
function Dg(e, t) {
  return j_(Mg, e, t);
}
const Ng = /* @__PURE__ */ $("ZodObject", (e, t) => {
  jd.init(e, t), se.init(e, t), K(e, "shape", () => t.shape), e.keyof = () => Bg(Object.keys(e._zod.def.shape)), e.catchall = (a) => e.clone({ ...e._zod.def, catchall: a }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Ho() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Ho() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Pg() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (a) => ru(e, a), e.safeExtend = (a) => iu(e, a), e.merge = (a) => lu(e, a), e.pick = (a) => ou(e, a), e.omit = (a) => nu(e, a), e.partial = (...a) => su(Dr, e, a[0]), e.required = (...a) => cu(Nr, e, a[0]);
});
function Og(e, t) {
  const a = {
    type: "object",
    get shape() {
      return Re(this, "shape", e ? Xc(e) : {}), this.shape;
    },
    ...L(t)
  };
  return new Ng(a);
}
const Ig = /* @__PURE__ */ $("ZodUnion", (e, t) => {
  Ld.init(e, t), se.init(e, t), e.options = t.options;
});
function jg(e, t) {
  return new Ig({
    type: "union",
    options: e,
    ...L(t)
  });
}
const Lg = /* @__PURE__ */ $("ZodIntersection", (e, t) => {
  Ed.init(e, t), se.init(e, t);
});
function Eg(e, t) {
  return new Lg({
    type: "intersection",
    left: e,
    right: t
  });
}
const Aa = /* @__PURE__ */ $("ZodEnum", (e, t) => {
  Bd.init(e, t), se.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const a = new Set(Object.keys(t.entries));
  e.extract = (o, n) => {
    const r = {};
    for (const i of o)
      if (a.has(i))
        r[i] = t.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new Aa({
      ...t,
      checks: [],
      ...L(n),
      entries: r
    });
  }, e.exclude = (o, n) => {
    const r = { ...t.entries };
    for (const i of o)
      if (a.has(i))
        delete r[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new Aa({
      ...t,
      checks: [],
      ...L(n),
      entries: r
    });
  };
});
function Bg(e, t) {
  const a = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new Aa({
    type: "enum",
    entries: a,
    ...L(t)
  });
}
const Tg = /* @__PURE__ */ $("ZodTransform", (e, t) => {
  Td.init(e, t), se.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new hr(e.constructor.name);
    a.addIssue = (r) => {
      if (typeof r == "string")
        a.issues.push(pt(r, a.value, t));
      else {
        const i = r;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = a.value), i.inst ?? (i.inst = e), a.issues.push(pt(i));
      }
    };
    const n = t.transform(a.value, a);
    return n instanceof Promise ? n.then((r) => (a.value = r, a)) : (a.value = n, a);
  };
});
function Rg(e) {
  return new Tg({
    type: "transform",
    transform: e
  });
}
const Dr = /* @__PURE__ */ $("ZodOptional", (e, t) => {
  Rd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Jo(e) {
  return new Dr({
    type: "optional",
    innerType: e
  });
}
const Fg = /* @__PURE__ */ $("ZodNullable", (e, t) => {
  Fd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Yo(e) {
  return new Fg({
    type: "nullable",
    innerType: e
  });
}
const Vg = /* @__PURE__ */ $("ZodDefault", (e, t) => {
  Vd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Gg(e, t) {
  return new Vg({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : yr(t);
    }
  });
}
const Ug = /* @__PURE__ */ $("ZodPrefault", (e, t) => {
  Gd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Zg(e, t) {
  return new Ug({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : yr(t);
    }
  });
}
const Nr = /* @__PURE__ */ $("ZodNonOptional", (e, t) => {
  Ud.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Wg(e, t) {
  return new Nr({
    type: "nonoptional",
    innerType: e,
    ...L(t)
  });
}
const Kg = /* @__PURE__ */ $("ZodCatch", (e, t) => {
  Zd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function qg(e, t) {
  return new Kg({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Hg = /* @__PURE__ */ $("ZodPipe", (e, t) => {
  Wd.init(e, t), se.init(e, t), e.in = t.in, e.out = t.out;
});
function Qo(e, t) {
  return new Hg({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Jg = /* @__PURE__ */ $("ZodReadonly", (e, t) => {
  Kd.init(e, t), se.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Yg(e) {
  return new Jg({
    type: "readonly",
    innerType: e
  });
}
const Qg = /* @__PURE__ */ $("ZodCustom", (e, t) => {
  qd.init(e, t), se.init(e, t);
});
function Xg(e, t = {}) {
  return L_(Qg, e, t);
}
function ef(e) {
  return E_(e);
}
const Or = Na(void 0), Xo = (e) => {
  let t;
  const a = /* @__PURE__ */ new Set(), o = (s, u) => {
    const d = typeof s == "function" ? s(t) : s;
    if (!Object.is(d, t)) {
      const g = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), a.forEach((b) => b(t, g));
    }
  }, n = () => t, l = { setState: o, getState: n, getInitialState: () => c, subscribe: (s) => (a.add(s), () => a.delete(s)) }, c = t = e(o, n, l);
  return l;
}, tf = (e) => e ? Xo(e) : Xo, af = (e) => e;
function of(e, t = af) {
  const a = O.useSyncExternalStore(
    e.subscribe,
    O.useCallback(() => t(e.getState()), [e, t]),
    O.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return O.useDebugValue(a), a;
}
function nf(e) {
  const t = {
    config: {
      apiUrl: "",
      assetsUrl: ""
    }
  };
  return tf((a) => ({
    ...t,
    ...e,
    setConfig: (o) => a({ config: o })
  }));
}
function rf({ children: e, ...t }) {
  const a = bt(null);
  return a.current || (a.current = nf(t)), /* @__PURE__ */ p(Or.Provider, { value: a.current, children: e });
}
function Ir(e) {
  const t = Oa(Or);
  if (!t) throw new Error("Missing ConversationsContext.Provider in the tree");
  return of(t, e);
}
const Wt = "9", lf = Og({
  reasonId: Ko({ error: "reasons_for_cancellation_needed" }),
  comment: Ko().optional()
}).refine((e) => !(e.reasonId === Wt && !e.comment), {
  error: "reasons_other_comment_needed",
  path: ["comment"]
}).refine((e) => !(e.reasonId === Wt && e.comment && e.comment.length > 255), {
  error: "common:error.characters_max_limit",
  path: ["comment"]
});
function sf({ onClickContinue: e, cancellationReasons: t, conversation: a, user: o }) {
  const n = Ir((v) => v.config.assetsUrl), { t: r, i18n: i } = Va(["conversations", "common"]), [l, c] = xe(!1), [s, u] = xe(!1), d = async (v) => {
    try {
      c(!0), await Xr(a.id, v.reasonId, v.comment);
      const P = t.find((y) => y.id.toString() === v.reasonId);
      LL(
        {
          exchange_status: "cancelled",
          cancellation_reason: P?.name,
          exchange_type: a.exchanges.length === 1 ? "guest_point_exchange" : "reciprocal_exchange",
          collection: o.is_he_collection
        },
        { eventCallback: () => e(), eventTimeout: 2e3 }
      );
    } catch (P) {
      throw u(!0), P;
    } finally {
      c(!1);
    }
  }, g = yi({
    resolver: F_(lf)
  }), { watch: b } = g, h = mn(
    () => t.reduce((v, P) => (i.exists(`conversations:reasons_for_cancellation_${P.name}`) && v.push({
      id: P.id.toString(),
      name: r(`reasons_for_cancellation_${P.name}`)
    }), v), []),
    [t, r, i]
  ), k = b("reasonId") === Wt;
  return {
    isLoading: l,
    requestHasError: s,
    onSubmitCancellationForm: d,
    cancellationReasonsRadioItems: h,
    displayCommentTextarea: k,
    cancellationForm: g,
    assetsUrl: n
  };
}
function cf({ onClickContinue: e, cancellationReasons: t, conversation: a, user: o }) {
  const { url: n } = Ua(`/conversations/${a.id}`), { t: r } = Va(["conversations", "common"]), { isDesktop: i } = br(), {
    assetsUrl: l,
    isLoading: c,
    requestHasError: s,
    onSubmitCancellationForm: u,
    cancellationReasonsRadioItems: d,
    displayCommentTextarea: g,
    cancellationForm: {
      control: b,
      handleSubmit: h,
      setValue: k,
      formState: { errors: v }
    }
  } = sf({ onClickContinue: e, cancellationReasons: t, conversation: a, user: o });
  return /* @__PURE__ */ R(_r, { children: [
    /* @__PURE__ */ p(Vt, { size: 6, children: /* @__PURE__ */ R(We, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", children: [
      /* @__PURE__ */ p(Ln, { level: 2, children: r("cancellation-page.reason_step.title") }),
      /* @__PURE__ */ p("form", { onSubmit: h(u), children: /* @__PURE__ */ R(We, { isFullWidth: !0, flexGrow: !0, alignItems: "stretch", direction: "column", children: [
        /* @__PURE__ */ p(
          io,
          {
            name: "reasonId",
            control: b,
            render: ({ field: P }) => /* @__PURE__ */ p(
              wa,
              {
                ...P,
                errorMessage: v.reasonId?.message ? r(v.reasonId.message) : void 0,
                onChange: (y) => {
                  y !== Wt && g && k("comment", ""), P.onChange(y);
                },
                label: r("cancellation-page.reason_step.checboxes_label"),
                children: d.map((y) => /* @__PURE__ */ p(wa.Item, { value: y.id, id: y.id, label: y.name }, y.id))
              }
            )
          }
        ),
        g && /* @__PURE__ */ p(
          io,
          {
            name: "comment",
            control: b,
            render: ({ field: P }) => /* @__PURE__ */ p(
              fc,
              {
                placeholder: r("cancellation-page.reason_step.comment_placeholder"),
                id: "reason-comment",
                status: v.comment?.message ? "error" : void 0,
                message: v.comment?.message ? r(v.comment?.message, { limit: 255 }) : void 0,
                maxLength: 255,
                ...P
              }
            )
          }
        ),
        s && !c && /* @__PURE__ */ R(dr, { status: "error", hasIcon: !0, children: [
          /* @__PURE__ */ p("span", { style: { fontWeight: "bold" }, children: r("common:errors.unable_to_submit.title") }),
          /* @__PURE__ */ p(Ft, { children: r("common:errors.unable_to_submit.subtitle") })
        ] }),
        /* @__PURE__ */ R(jn, { flexGrowButtons: !0, children: [
          /* @__PURE__ */ p(nt, { isLoading: c, disabled: c, color: "destructive", type: "submit", children: r("cancellation-page.cancel-exchange") }),
          /* @__PURE__ */ p(nt, { disabled: c, color: "tertiary", href: n, children: r("cancellation-page.keep-exchange") })
        ] })
      ] }) })
    ] }) }),
    i && /* @__PURE__ */ p(Vt, { size: 6, children: /* @__PURE__ */ p(We, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", children: /* @__PURE__ */ p(
      ur,
      {
        width: "full",
        src: `${l}/cancellation/cancellation-${o.is_he_collection ? "collection" : "regular"}-desktop.svg`,
        alt: "cancellation-warning"
      }
    ) }) })
  ] });
}
const uf = ({ conversation: e, user: t }) => {
  const { t: a } = Va("conversations"), o = br(), { url: n } = Ua(`/conversations/${e.id}`);
  let r = "";
  const { exchanges: i } = e;
  return i.length === 2 ? r = a("page_cancellation_reciprocal_calloutBody") : Number(i[0].guest.id) === t.id ? r = a("page_cancellation_guest_calloutBody") : Number(i[0].host.id) === t.id && (r = a("page_cancellation_host_calloutBody")), { t: a, conversationUrl: n, calloutMessage: r, ...o };
};
function df({ onClickContinue: e, conversation: t, user: a }) {
  const { t: o, conversationUrl: n, calloutMessage: r, isMobile: i, isTablet: l, isDesktop: c } = uf({ conversation: t, user: a }), s = Ir((d) => d.config.assetsUrl), u = /* @__PURE__ */ R(jn, { flexGrowButtons: !0, children: [
    /* @__PURE__ */ p(nt, { onClick: e, children: o("cancellation-page.continue-cancellation") }),
    /* @__PURE__ */ p(nt, { color: "tertiary", href: n, children: o("cancellation-page.keep-exchange") })
  ] });
  return /* @__PURE__ */ R(_r, { children: [
    /* @__PURE__ */ p(Vt, { size: 6, children: /* @__PURE__ */ R(We, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", gap: "7", children: [
      /* @__PURE__ */ R(We, { justifyContent: "center", alignItems: "stretch", direction: "column", children: [
        /* @__PURE__ */ p(Ln, { level: 2, children: o("cancellation-page.cancel-exchange") }),
        /* @__PURE__ */ p(Ft, { children: o("cancellation-page.warning-step.first-warning") }),
        r && /* @__PURE__ */ p(dr, { hasIcon: !0, status: "warning", children: r })
      ] }),
      c && u
    ] }) }),
    /* @__PURE__ */ p(Vt, { size: 6, children: /* @__PURE__ */ R(We, { isFullHeight: !0, justifyContent: "center", alignItems: "stretch", direction: "column", children: [
      /* @__PURE__ */ p(
        ur,
        {
          width: "full",
          src: `${s}/cancellation/cancellation-${a.is_he_collection ? "collection" : "regular"}-desktop.svg`,
          alt: "cancellation-warning"
        }
      ),
      (l || i) && u
    ] }) })
  ] });
}
const jr = "https://www.homeexchange.com/blog/calculate-the-carbon-footprint-of-your-trip/", _f = {
  fr: "https://www.homeexchange.fr/blog/calculez-lempreinte-carbone-de-votre-voyage/",
  es: "https://es.homeexchange.com/es/blog/calcula-la-huella-de-carbono-de-tus-viajes/",
  en: jr
};
function ZL({
  className: e,
  title: t,
  description: a,
  locale: o,
  ctaText: n,
  onClickCTA: r
}) {
  return /* @__PURE__ */ p(
    xc,
    {
      className: e,
      color: "info",
      title: t,
      description: a,
      image: {
        alt: "transportation-banner-logo",
        imageSrc: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo.svg",
        imageSrcMobile: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo-small.svg"
      },
      cta: {
        color: "eco-green",
        text: n,
        onClick: async () => {
          await r(), window.open(_f[o] || jr, "_blank");
        }
      }
    }
  );
}
const gf = (e, t, a, o) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null, page_data: null, user_data: null });
  const { eventCallback: n, ...r } = {}, i = (l) => {
    n && typeof n == "function" && l.startsWith("GTM-") && n(l);
  };
  window.dataLayer.push({
    event: "data_layer_init",
    event_data: {
      collection: a,
      method: null,
      text: null
    },
    page_data: {
      location: window.location.href,
      referrer: document.referrer,
      title: document.title,
      language: navigator.language
    },
    user_data: {
      login_status: "logged",
      uid: e,
      profile: t
    },
    eventCallback: i,
    ...r
  });
}, Lr = (e, t, a) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null });
  const { eventCallback: o, ...n } = a || {}, r = (i) => {
    o && typeof o == "function" && i.startsWith("GTM-") && o(i);
  };
  window.dataLayer.push({
    event: e,
    event_data: t,
    ...n,
    eventCallback: r
  }), !window.google_tag_manager && a?.eventCallback && typeof a.eventCallback == "function" && a.eventCallback();
}, ff = (e, t, a) => {
  Lr("funnel_progress", {
    funnel_name: e,
    funnel_step: t,
    ...a
  });
}, bf = (e) => e.subscriptionEndOn ? e.isHeCollection ? "member_collection" : new Date(e.subscriptionEndOn) < /* @__PURE__ */ new Date() ? "expired" : "member_regular" : "lead", j = (e) => typeof e == "string", ut = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, en = (e) => e == null ? "" : "" + e, hf = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, mf = /###/g, tn = (e) => e && e.indexOf("###") > -1 ? e.replace(mf, ".") : e, an = (e) => !e || j(e), ft = (e, t, a) => {
  const o = j(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (an(e)) return {};
    const r = tn(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return an(e) ? {} : {
    obj: e,
    k: tn(o[n])
  };
}, on = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = ft(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), l = ft(e, i, Object);
  for (; l.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), l = ft(e, i, Object), l?.obj && typeof l.obj[`${l.k}.${r}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${r}`] = a;
}, pf = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = ft(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Kt = (e, t) => {
  const {
    obj: a,
    k: o
  } = ft(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, yf = (e, t, a) => {
  const o = Kt(e, a);
  return o !== void 0 ? o : Kt(t, a);
}, Er = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? j(e[o]) || e[o] instanceof String || j(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : Er(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, et = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var vf = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const kf = (e) => j(e) ? e.replace(/[&<>"'\/]/g, (t) => vf[t]) : e;
class $f {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const wf = [" ", ",", "?", "!", ";"], xf = new $f(20), Cf = (e, t, a) => {
  t = t || "", a = a || "";
  const o = wf.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = xf.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Pa = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, l = "";
    for (let c = r; c < o.length; ++c)
      if (c !== r && (l += a), l += o[c], i = n[l], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && c < o.length - 1)
          continue;
        r += c - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, yt = (e) => e?.replace("_", "-"), Sf = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class qt {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || Sf, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (j(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new qt(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new qt(this.logger, t);
  }
}
var Se = new qt();
class ia {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n.apply(n, [t, ...a]);
    });
  }
}
class nn extends ia {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    t.indexOf(".") > -1 ? l = t.split(".") : (l = [t, a], o && (Array.isArray(o) ? l.push(...o) : j(o) && r ? l.push(...o.split(r)) : l.push(o)));
    const c = Kt(this.data, l);
    return !c && !a && !o && t.indexOf(".") > -1 && (t = l[0], a = l[1], o = l.slice(2).join(".")), c || !i || !j(o) ? c : Pa(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let l = [t, a];
    o && (l = l.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (l = t.split("."), n = a, a = l[1]), this.addNamespaces(a), on(this.data, l, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (j(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let l = [t, a];
    t.indexOf(".") > -1 && (l = t.split("."), n = o, o = a, a = l[1]), this.addNamespaces(a);
    let c = Kt(this.data, l) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? Er(c, o, r) : c = {
      ...c,
      ...o
    }, on(this.data, l, c), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((n) => a[n] && Object.keys(a[n]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Br = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const Tr = Symbol("i18next/PATH_KEY");
function zf() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === Tr ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function Ma(e, t) {
  const {
    [Tr]: a
  } = e(zf());
  return a.join(t?.keySeparator ?? ".");
}
const rn = {}, ln = (e) => !j(e) && typeof e != "boolean" && typeof e != "number";
class Ht extends ia {
  constructor(t, a = {}) {
    super(), hf(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Se.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, l = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !Cf(t, o, n);
    if (i && !l) {
      const c = t.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: t,
          namespaces: j(r) ? [r] : r
        };
      const s = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(s[0]) > -1) && (r = s.shift()), t = s.join(n);
    }
    return {
      key: t,
      namespaces: j(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = Ma(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: l,
      namespaces: c
    } = this.extractFromKey(t[t.length - 1], n), s = c[c.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, g = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return g ? r ? {
        res: `${s}${u}${l}`,
        usedKey: l,
        exactUsedKey: l,
        usedLng: d,
        usedNS: s,
        usedParams: this.getUsedParamsDetails(n)
      } : `${s}${u}${l}` : r ? {
        res: l,
        usedKey: l,
        exactUsedKey: l,
        usedLng: d,
        usedNS: s,
        usedParams: this.getUsedParamsDetails(n)
      } : l;
    const b = this.resolve(t, n);
    let h = b?.res;
    const k = b?.usedKey || l, v = b?.exactUsedKey || l, P = ["[object Number]", "[object Function]", "[object RegExp]"], y = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, M = !this.i18nFormat || this.i18nFormat.handleAsObject, A = n.count !== void 0 && !j(n.count), N = Ht.hasDefaultValue(n), F = A ? this.pluralResolver.getSuffix(d, n.count, n) : "", U = n.ordinal && A ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", ae = A && !n.ordinal && n.count === 0, Q = ae && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${F}`] || n[`defaultValue${U}`] || n.defaultValue;
    let X = h;
    M && !h && N && (X = Q);
    const ce = ln(X), B = Object.prototype.toString.apply(X);
    if (M && X && ce && P.indexOf(B) < 0 && !(j(y) && Array.isArray(X))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const E = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(k, X, {
          ...n,
          ns: c
        }) : `key '${l} (${this.language})' returned an object instead of string.`;
        return r ? (b.res = E, b.usedParams = this.getUsedParamsDetails(n), b) : E;
      }
      if (i) {
        const E = Array.isArray(X), T = E ? [] : {}, Z = E ? v : k;
        for (const q in X)
          if (Object.prototype.hasOwnProperty.call(X, q)) {
            const oe = `${Z}${i}${q}`;
            N && !h ? T[q] = this.translate(oe, {
              ...n,
              defaultValue: ln(Q) ? Q[q] : void 0,
              joinArrays: !1,
              ns: c
            }) : T[q] = this.translate(oe, {
              ...n,
              joinArrays: !1,
              ns: c
            }), T[q] === oe && (T[q] = X[q]);
          }
        h = T;
      }
    } else if (M && j(y) && Array.isArray(h))
      h = h.join(y), h && (h = this.extendTranslation(h, t, n, o));
    else {
      let E = !1, T = !1;
      !this.isValidLookup(h) && N && (E = !0, h = Q), this.isValidLookup(h) || (T = !0, h = l);
      const q = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && T ? void 0 : h, oe = N && Q !== h && this.options.updateMissing;
      if (T || E || oe) {
        if (this.logger.log(oe ? "updateKey" : "missingKey", d, s, l, oe ? Q : h), i) {
          const ue = this.resolve(l, {
            ...n,
            keySeparator: !1
          });
          ue && ue.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let ve = [];
        const ke = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && ke && ke[0])
          for (let ue = 0; ue < ke.length; ue++)
            ve.push(ke[ue]);
        else this.options.saveMissingTo === "all" ? ve = this.languageUtils.toResolveHierarchy(n.lng || this.language) : ve.push(n.lng || this.language);
        const Ve = (ue, Ae, Le) => {
          const Ct = N && Le !== h ? Le : q;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(ue, s, Ae, Ct, oe, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(ue, s, Ae, Ct, oe, n), this.emit("missingKey", ue, s, Ae, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && A ? ve.forEach((ue) => {
          const Ae = this.pluralResolver.getSuffixes(ue, n);
          ae && n[`defaultValue${this.options.pluralSeparator}zero`] && Ae.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Ae.push(`${this.options.pluralSeparator}zero`), Ae.forEach((Le) => {
            Ve([ue], l + Le, n[`defaultValue${Le}`] || Q);
          });
        }) : Ve(ve, l, Q));
      }
      h = this.extendTranslation(h, t, n, b, o), T && h === l && this.options.appendNamespaceToMissingKey && (h = `${s}${u}${l}`), (T || E) && this.options.parseMissingKeyHandler && (h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${s}${u}${l}` : l, E ? h : void 0, n));
    }
    return r ? (b.res = h, b.usedParams = this.getUsedParamsDetails(n), b) : h;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const c = j(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let s;
      if (c) {
        const d = t.match(this.interpolator.nestingRegexp);
        s = d && d.length;
      }
      let u = o.replace && !j(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), c) {
        const d = t.match(this.interpolator.nestingRegexp), g = d && d.length;
        s < g && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, l = j(i) ? [i] : i;
    return t != null && l?.length && o.applyPostProcessor !== !1 && (t = Br.handle(l, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, l;
    return j(t) && (t = [t]), t.forEach((c) => {
      if (this.isValidLookup(o)) return;
      const s = this.extractFromKey(c, a), u = s.key;
      n = u;
      let d = s.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const g = a.count !== void 0 && !j(a.count), b = g && !a.ordinal && a.count === 0, h = a.context !== void 0 && (j(a.context) || typeof a.context == "number") && a.context !== "", k = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((v) => {
        this.isValidLookup(o) || (l = v, !rn[`${k[0]}-${v}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(l) && (rn[`${k[0]}-${v}`] = !0, this.logger.warn(`key "${n}" for languages "${k.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), k.forEach((P) => {
          if (this.isValidLookup(o)) return;
          i = P;
          const y = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(y, u, P, v, a);
          else {
            let A;
            g && (A = this.pluralResolver.getSuffix(P, a.count, a));
            const N = `${this.options.pluralSeparator}zero`, F = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (g && (a.ordinal && A.indexOf(F) === 0 && y.push(u + A.replace(F, this.options.pluralSeparator)), y.push(u + A), b && y.push(u + N)), h) {
              const U = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              y.push(U), g && (a.ordinal && A.indexOf(F) === 0 && y.push(U + A.replace(F, this.options.pluralSeparator)), y.push(U + A), b && y.push(U + N));
            }
          }
          let M;
          for (; M = y.pop(); )
            this.isValidLookup(o) || (r = M, o = this.getResource(P, v, M, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: l
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !j(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class sn {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Se.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = yt(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = yt(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (j(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r) return i;
        if (!(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), j(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return j(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : j(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const cn = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, un = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class Af {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Se.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = yt(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), un;
      if (!t.match(/-|_/)) return un;
      const c = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(c, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => cn[n] - cn[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
}
const dn = (e, t, a, o = ".", n = !0) => {
  let r = yf(e, t, a);
  return !r && n && j(a) && (r = Pa(e, a, o), r === void 0 && (r = Pa(t, a, o))), r;
}, ma = (e) => e.replace(/\$/g, "$$$$");
class Pf {
  constructor(t = {}) {
    this.logger = Se.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: l,
      suffixEscaped: c,
      formatSeparator: s,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: g,
      nestingPrefixEscaped: b,
      nestingSuffix: h,
      nestingSuffixEscaped: k,
      nestingOptionsSeparator: v,
      maxReplaces: P,
      alwaysFormat: y
    } = t.interpolation;
    this.escape = a !== void 0 ? a : kf, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? et(r) : i || "{{", this.suffix = l ? et(l) : c || "}}", this.formatSeparator = s || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = g ? et(g) : b || et("$t("), this.nestingSuffix = h ? et(h) : k || et(")"), this.nestingOptionsSeparator = v || ",", this.maxReplaces = P || 1e3, this.alwaysFormat = y !== void 0 ? y : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, s = (b) => {
      if (b.indexOf(this.formatSeparator) < 0) {
        const P = dn(a, c, b, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(P, void 0, o, {
          ...n,
          ...a,
          interpolationkey: b
        }) : P;
      }
      const h = b.split(this.formatSeparator), k = h.shift().trim(), v = h.join(this.formatSeparator).trim();
      return this.format(dn(a, c, k, this.options.keySeparator, this.options.ignoreJSONStructure), v, o, {
        ...n,
        ...a,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (b) => ma(b)
    }, {
      regex: this.regexp,
      safeValue: (b) => this.escapeValue ? ma(this.escape(b)) : ma(b)
    }].forEach((b) => {
      for (l = 0; r = b.regex.exec(t); ) {
        const h = r[1].trim();
        if (i = s(h), i === void 0)
          if (typeof u == "function") {
            const v = u(t, r, n);
            i = j(v) ? v : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, h))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), i = "";
        else !j(i) && !this.useRawValueToEscape && (i = en(i));
        const k = b.safeValue(i);
        if (t = t.replace(r[0], k), d ? (b.regex.lastIndex += i.length, b.regex.lastIndex -= r[0].length) : b.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const l = (c, s) => {
      const u = this.nestingOptionsSeparator;
      if (c.indexOf(u) < 0) return c;
      const d = c.split(new RegExp(`${u}[ ]*{`));
      let g = `{${d[1]}`;
      c = d[0], g = this.interpolate(g, i);
      const b = g.match(/'/g), h = g.match(/"/g);
      ((b?.length ?? 0) % 2 === 0 && !h || h.length % 2 !== 0) && (g = g.replace(/'/g, '"'));
      try {
        i = JSON.parse(g), s && (i = {
          ...s,
          ...i
        });
      } catch (k) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, k), `${c}${u}${g}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, c;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let c = [];
      i = {
        ...o
      }, i = i.replace && !j(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const s = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (s !== -1 && (c = n[1].slice(s).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, s)), r = a(l.call(this, n[1].trim(), i), i), r && n[0] === t && !j(r)) return r;
      j(r) || (r = en(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), c.length && (r = c.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const Mf = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((i) => {
      if (i) {
        const [l, ...c] = i.split(":"), s = c.join(":").trim().replace(/^'+|'+$/g, ""), u = l.trim();
        a[u] || (a[u] = s), s === "false" && (a[u] = !1), s === "true" && (a[u] = !0), isNaN(s) || (a[u] = parseInt(s, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, _n = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let l = t[i];
    return l || (l = e(yt(o), n), t[i] = l), l(a);
  };
}, Df = (e) => (t, a, o) => e(yt(a), o)(t);
class Nf {
  constructor(t = {}) {
    this.logger = Se.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? _n : Df;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (l) => i.format(l);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (l) => i.format(l);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (l) => i.format(l);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (l) => i.format(l, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (l) => i.format(l);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = _n(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((l) => l.indexOf(")") > -1)) {
      const l = r.findIndex((c) => c.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, l)].join(this.formatSeparator);
    }
    return r.reduce((l, c) => {
      const {
        formatName: s,
        formatOptions: u
      } = Mf(c);
      if (this.formats[s]) {
        let d = l;
        try {
          const g = n?.formatParams?.[n.interpolationkey] || {}, b = g.locale || g.lng || n.locale || n.lng || o;
          d = this.formats[s](l, b, {
            ...u,
            ...n,
            ...g
          });
        } catch (g) {
          this.logger.warn(g);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${s}`);
      return l;
    }, t);
  }
}
const Of = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class If extends ia {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Se.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, l = {}, c = {};
    return t.forEach((s) => {
      let u = !0;
      a.forEach((d) => {
        const g = `${s}|${d}`;
        !o.reload && this.store.hasResourceBundle(s, d) ? this.state[g] = 2 : this.state[g] < 0 || (this.state[g] === 1 ? i[g] === void 0 && (i[g] = !0) : (this.state[g] = 1, u = !1, i[g] === void 0 && (i[g] = !0), r[g] === void 0 && (r[g] = !0), c[d] === void 0 && (c[d] = !0)));
      }), u || (l[s] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const l = {};
    this.queue.forEach((c) => {
      pf(c.loaded, [r], i), Of(c, t), a && c.errors.push(a), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((s) => {
        l[s] || (l[s] = {});
        const u = c.loaded[s];
        u.length && u.forEach((d) => {
          l[s][d] === void 0 && (l[s][d] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((c) => !c.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const l = (s, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (s && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(s, u);
    }, c = this.backend[o].bind(this.backend);
    if (c.length === 2) {
      try {
        const s = c(t, a);
        s && typeof s.then == "function" ? s.then((u) => l(null, u)).catch(l) : l(null, s);
      } catch (s) {
        l(s);
      }
      return;
    }
    return c(t, a, l);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    j(t) && (t = this.languageUtils.toResolveHierarchy(t)), j(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, l) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && l && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, l), this.loaded(t, i, l);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, l = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const c = {
          ...i,
          isUpdate: r
        }, s = this.backend.create.bind(this.backend);
        if (s.length < 6)
          try {
            let u;
            s.length === 5 ? u = s(t, a, o, n, c) : u = s(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => l(null, d)).catch(l) : l(null, u);
          } catch (u) {
            l(u);
          }
        else
          s(t, a, o, n, l, c);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
}
const gn = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), j(e[1]) && (t.defaultValue = e[1]), j(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), fn = (e) => (j(e.ns) && (e.ns = [e.ns]), j(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), j(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), It = () => {
}, jf = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((a) => {
    typeof e[a] == "function" && (e[a] = e[a].bind(e));
  });
};
class vt extends ia {
  constructor(t = {}, a) {
    if (super(), this.options = fn(t), this.services = {}, this.logger = Se, this.modules = {
      external: []
    }, jf(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (j(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = gn();
    this.options = {
      ...o,
      ...this.options,
      ...fn(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? Se.init(n(this.modules.logger), this.options) : Se.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = Nf;
      const u = new sn(this.options);
      this.store = new nn(this.options.resources, this.options);
      const d = this.services;
      d.logger = Se, d.resourceStore = this.store, d.languageUtils = u, d.pluralResolver = new Af(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (d.formatter = n(s), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Pf(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new If(n(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (b, ...h) => {
        this.emit(b, ...h);
      }), this.modules.languageDetector && (d.languageDetector = n(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = n(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Ht(this.services, this.options), this.translator.on("*", (b, ...h) => {
        this.emit(b, ...h);
      }), this.modules.external.forEach((b) => {
        b.init && b.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = It), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...u) => this.store[s](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...u) => (this.store[s](...u), this);
    });
    const l = ut(), c = () => {
      const s = (u, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(d), a(u, d);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? c() : setTimeout(c, 0), l;
  }
  loadResources(t, a = It) {
    let o = a;
    const n = j(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (l) => {
        if (!l || l === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((s) => {
          s !== "cimode" && r.indexOf(s) < 0 && r.push(s);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => i(c)), this.options.preload?.forEach?.((l) => i(l)), this.services.backendConnector.load(r, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(l);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = ut();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = It), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Br.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = ut();
    this.emit("languageChanging", t);
    const n = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, r = (l, c) => {
      c ? this.isLanguageChangingTo === t && (n(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, o.resolve((...s) => this.t(...s)), a && a(l, (...s) => this.t(...s));
    }, i = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = j(l) ? l : l && l[0], s = this.store.hasLanguageSomeTranslations(c) ? c : this.services.languageUtils.getBestMatchFromCodes(j(l) ? [l] : l);
      s && (this.language || n(s), this.translator.language || this.translator.changeLanguage(s), this.services.languageDetector?.cacheUserLanguage?.(s)), this.loadResources(s, (u) => {
        r(u, s);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...l) => {
      let c;
      typeof i != "object" ? c = this.options.overloadTranslationOptionHandler([r, i].concat(l)) : c = {
        ...i
      }, c.lng = c.lng || n.lng, c.lngs = c.lngs || n.lngs, c.ns = c.ns || n.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || o || n.keyPrefix);
      const s = this.options.keySeparator || ".";
      let u;
      return c.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = Ma(d, {
        ...this.options,
        ...i
      })), `${c.keyPrefix}${s}${d}`)) : (typeof r == "function" && (r = Ma(r, {
        ...this.options,
        ...i
      })), u = c.keyPrefix ? `${c.keyPrefix}${s}${r}` : r), this.t(u, c);
    };
    return j(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (l, c) => {
      const s = this.services.backendConnector.state[`${l}|${c}`];
      return s === -1 || s === 0 || s === 2;
    };
    if (a.precheck) {
      const l = a.precheck(this, i);
      if (l !== void 0) return l;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = ut();
    return this.options.ns ? (j(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = ut();
    j(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new sn(gn());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new vt(t, a);
  }
  cloneInstance(t = {}, a = It) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new vt(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((l) => {
      r[l] = this[l];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const l = Object.keys(this.store.data).reduce((c, s) => (c[s] = {
        ...this.store.data[s]
      }, c[s] = Object.keys(c[s]).reduce((u, d) => (u[d] = {
        ...c[s][d]
      }, u), c[s]), c), {});
      r.store = new nn(l, n), r.services.resourceStore = r.store;
    }
    return r.translator = new Ht(r.services, n), r.translator.on("*", (l, ...c) => {
      r.emit(l, ...c);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const _e = vt.createInstance();
_e.createInstance = vt.createInstance;
const Lf = _e.createInstance;
_e.dir;
_e.init;
_e.loadResources;
_e.reloadResources;
_e.use;
_e.changeLanguage;
_e.getFixedT;
_e.t;
_e.exists;
_e.setDefaultNamespace;
_e.hasLoadedNamespace;
_e.loadNamespaces;
_e.loadLanguages;
const Ef = "Studio", Bf = "{{count}} soveværelse", Tf = "{{count}} soveværelser", Rf = "", Ff = "{{count}} seng", Vf = "{{count}} senge", Gf = "Voksne", Uf = "Babyer", Zf = "Din kalender er blevet opdateret.", Wf = "En måned", Kf = "Præcise datoer", qf = "Uge", Hf = "", Jf = "", Yf = "", Qf = "", Xf = "To uger", eb = "Annuller", tb = "Børn", ab = "Datoer", ob = "Slet", nb = "Beskrivelse", rb = "Destination", ib = "Sådan!", lb = "Rediger", sb = "Enhver form for udveksling", cb = "Badekar", ub = "Grill", db = "Cykel", _b = "Bil", gb = "Kat", fb = "By", bb = "På landet", hb = "Opvaskemaskine", mb = "Hund", pb = "Tørretumbler", yb = "Elevator", vb = "Favoritboliger", kb = "Pejs/brændeovn", $b = "Lejlighed", wb = "Privat have", xb = "under {{max}} GP", Cb = "fra {{min}} GP", Sb = "Mellem {{min}} og {{max}} GP", zb = "Privat fitnessrum", Ab = "Hus", Pb = "En Ø", Mb = "Isoleret", Db = "Jacuzzi", Nb = "Søer", Ob = "Collection-hjem", Ib = "Bjerge", jb = "{{count}} badeværelser", Lb = "Andre dyr", Eb = "Klaver", Bb = "Legeplads", Tb = "Primære bolig", Rb = "Gensifig udveksling", Fb = "Omvendt søgning", Vb = "Flod", Gb = "Kystnær", Ub = "Feriebolig", Zb = "TV", Wb = "Landsby", Kb = "Wi-Fi", qb = "Filtre", Hb = "Faste datoer", Jb = "En måned i {{date}}", Yb = "En weekend i {{date}}", Qb = "En uge i {{date}}", Xb = "To uger i {{date}}", eh = "Fleksible datoer", th = "Gæster", ah = "boliger", oh = "Sidste minut", nh = "Lokation", rh = "Rediger", ih = "Navn", lh = "Næste", sh = "", ch = "", uh = "{{count}} voksne", dh = "", _h = "", gh = "{{count}} babyer", fh = "", bh = "", hh = "{{count}} børn", mh = "", ph = "{{count}} gæst", yh = "{{count}} gæster", vh = "Telefonnummerets format er ikke gyldigt.", kh = "Modtag e-mailnotifikationer", $h = "Gem", wh = "Ingen lokationer fundet", xh = "Flere beskeder", Ch = "Rejseliste", Sh = "", zh = "valgfrit", Ah = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: Ef,
  bedroomsNumbers_one: Bf,
  bedroomsNumbers_other: Tf,
  beds_zero: Rf,
  beds_one: Ff,
  beds_other: Vf,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: Gf,
  global_babies: Uf,
  global_calendarUpdated_toast: Zf,
  global_calendar_aMonth: Wf,
  global_calendar_exactDates: Kf,
  global_calendar_oneWeek: qf,
  global_calendar_oneWeekend: Hf,
  global_calendar_plusMinusDay_zero: Jf,
  global_calendar_plusMinusDay_one: Yf,
  global_calendar_plusMinusDay_other: Qf,
  global_calendar_twoWeeks: Xf,
  global_cancel: eb,
  global_children: tb,
  global_dates: ab,
  global_delete: ob,
  global_description: nb,
  global_destination: rb,
  global_done: ib,
  global_edit: lb,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: sb,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: cb,
  global_filter_bbq: ub,
  global_filter_bicycle: db,
  global_filter_car: _b,
  global_filter_cat: gb,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: fb,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: bb,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: hb,
  global_filter_dog: mb,
  global_filter_dryer: pb,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: yb,
  global_filter_favorite: vb,
  global_filter_fireplace: kb,
  global_filter_flat: $b,
  global_filter_garden: wb,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: xb,
  global_filter_guestPointsMin: Cb,
  global_filter_guestPointsMinMax: Sb,
  global_filter_gym: zb,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: Ab,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: Pb,
  global_filter_isolated: Mb,
  global_filter_jacuzzi: Db,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: Nb,
  global_filter_luxury: Ob,
  global_filter_mountains: Ib,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: jb,
  global_filter_other: Lb,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: Eb,
  global_filter_playground: Bb,
  global_filter_primary: Tb,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: Rb,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: Fb,
  global_filter_river: Vb,
  global_filter_seaside: Gb,
  global_filter_secondary: Ub,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Zb,
  global_filter_villages: Wb,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: Kb,
  global_filters: qb,
  global_fixDates: Hb,
  global_flexDates_aMonth: Jb,
  global_flexDates_aWeekend: Yb,
  global_flexDates_oneWeek: Qb,
  global_flexDates_twoWeek: Xb,
  global_flexibleDates: eh,
  global_guests: th,
  global_homes: ah,
  global_lastMinute: oh,
  global_location: nh,
  global_modify: rh,
  global_name: ih,
  global_next: lh,
  global_numberOfAdults_zero: sh,
  global_numberOfAdults_one: ch,
  global_numberOfAdults_other: uh,
  global_numberOfBabies_zero: dh,
  global_numberOfBabies_one: _h,
  global_numberOfBabies_other: gh,
  global_numberOfChildren_zero: fh,
  global_numberOfChildren_one: bh,
  global_numberOfChildren_other: hh,
  global_numberOfGuests_zero: mh,
  global_numberOfGuests_one: ph,
  global_numberOfGuests_other: yh,
  global_phoneNumber_notValid: vh,
  global_receiveEmailAlerts: kh,
  global_save: $h,
  global_searchBar_noLocationFound: wh,
  global_seeMore_link: xh,
  global_travelWishlist: Ch,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: Sh,
  optional: zh,
  "privacy-policy": "Privatpolitik"
}, Ph = "Din vært kan frit vælge, om de vil beholde eller returnere GuestPoints.", Mh = "Ubegrundede eller gentagne aflysninger kan medføre, at din konto bliver suspenderet.", Dh = "Ubegrundede eller gentagne aflysninger kan medføre, at din konto bliver suspenderet. Hvis der var GuestPoints involveret, kan din byttepartner vælge, om de vil beholde eller returnere dem.", Nh = "Når du har forhåndsgodkendt  dette boligbytte, skal din byttepartner bekræfte det. Byttepartneren har {nbDays} dage til at bekræfte boligbyttet (indtil {date}). Ellers vil din forhåndsgodkendelse udløbe, og du bliver nødt til at forhåndsgodkende boligbyttet igen.", Oh = "Min byttepartner bad mig om at aflyse boligbyttet.", Ih = "Dobbelt booking (via en anden platform)", jh = "Familieproblemer", Lh = "Helbredsproblemer", Eh = "Skader i hjemmet", Bh = "Flytning", Th = "Du skal angive årsagerne til, at du vil annullere boligbyttet.", Rh = "Andre", Fh = "Transportproblemer", Vh = "Tillidsproblem", Gh = "Arbejdsrelateret", Uh = "Du er nødt til at indtaste en årsag", Zh = {
  "cancellation-page.cancel-exchange": "Annuller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsæt annulleringen",
  "cancellation-page.keep-exchange": "Behold mit boligbytte",
  "cancellation-page.reason_step.checboxes_label": "Vælg hovedårsagen til din annullering:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv årsagen til din annullering her",
  "cancellation-page.reason_step.error": "Du er nødt til at indtaste en årsag",
  "cancellation-page.reason_step.title": "Hvorfor er du nødt til at annullere?",
  "cancellation-page.warning-step.first-warning": "Husk, at annullering af dit boligbytte kan have en negativ indvirkning på din byttepartner, som måske allerede har lavet rejseplaner!",
  "cancellation-page.warning-step.second-warning": "Vigtigt: I tilfælde af for mange uberettigede aflysninger som vært, kan din konto blive taget offline. Og som gæst får du muligvis ikke alle dine GuestPoints tilbage.",
  page_cancellation_guest_calloutBody: Ph,
  page_cancellation_host_calloutBody: Mh,
  page_cancellation_reciprocal_calloutBody: Dh,
  pre_approval_modal_expiration_description: Nh,
  reasons_for_cancellation_asked_by_exchange_partner: Oh,
  reasons_for_cancellation_double_booking_rental: Ih,
  reasons_for_cancellation_family_issues: jh,
  reasons_for_cancellation_health_issues: Lh,
  reasons_for_cancellation_home_damage: Eh,
  reasons_for_cancellation_moving: Bh,
  reasons_for_cancellation_needed: Th,
  reasons_for_cancellation_other: Rh,
  reasons_for_cancellation_transportation_issues: Fh,
  reasons_for_cancellation_trust_issues: Vh,
  reasons_for_cancellation_work_related: Gh,
  reasons_other_comment_needed: Uh
}, Wh = "Studio", Kh = "{{count}} schlafzimmer", qh = "{{count}} schlafzimmer", Hh = "", Jh = "{{count}} Bett", Yh = "{{count}} Betten", Qh = "Erwachsene", Xh = "Babys", em = "Ihr Kalender wurde aktualisiert.", tm = "Ein Monat", am = "Genaue Daten", om = "Eine Woche", nm = "Ein Wochenende", rm = "", im = "± {{count}} Tag", lm = "± {{count}} Tage", sm = "Zwei Wochen", cm = "Abbrechen", um = "Kinder", dm = "Daten", _m = "Löschen", gm = "Beschreibung", fm = "Reiseziel", bm = "Fertig!", hm = "Bearbeiten", mm = "Jede Tauschanfrage", pm = "Badewanne", ym = "Grill", vm = "Fahrrad", km = "Auto", $m = "Katze", wm = "Stadt", xm = "Auf dem Land", Cm = "Geschirrspüler", Sm = "Hund", zm = "Trockner", Am = "Aufzug", Pm = "Lieblingshäuser", Mm = "Kamin", Dm = "Apartment", Nm = "Privater Garten", Om = "weniger als {{max}} GP", Im = "von {{min}} GP", jm = "Zwischen {{min}} und {{max}} GP", Lm = "Privater Fitnessraum", Em = "Haus", Bm = "Insel", Tm = "Abgelegen", Rm = "Whirlpool", Fm = "See", Vm = "Häuser der Collection", Gm = "Berge", Um = "{{count}} Badezimmer", Zm = "Andere Tiere", Wm = "Klavier", Km = "Spielplatz", qm = "Hauptwohnung", Hm = "Gegenseitiger Austausch", Jm = "Umgekehrte Suche", Ym = "Fluss", Qm = "An der Küste", Xm = "Zweitwohnung", ep = "Fernseher", tp = "Dorf", ap = "WLAN", op = "Filter", np = "Feste Daten", rp = "Eine Woche im {{date}}", ip = "Ein Wochenende im {{date}}", lp = "Eine Woche im {{date}}", sp = "Zwei Wochen im {{date}}", cp = "Flexible Daten", up = "Gäste", dp = "Unterkünfte", _p = "Last Minute", gp = "Ort", fp = "Ändern", bp = "Name", hp = "Weiter", mp = "", pp = "{{count}} Erwachsener", yp = "{{count}} Erwachsene", vp = "", kp = "{{count}} Baby", $p = "{{count}} Babys", wp = "", xp = "{{count}} Kind", Cp = "{{count}} Kinder", Sp = "", zp = "{{count}} Gast", Ap = "{{count}} Gäste", Pp = "Das Format der Telefonnummer ist ungültig.", Mp = "Benachrichtigungen per E-Mail erhalten", Dp = "Speichern", Np = "Kein Reiseziel gefunden", Op = "Mehr anzeigen", Ip = "Reiseprojekte", jp = "", Lp = "optional", Ep = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: Wh,
  bedroomsNumbers_one: Kh,
  bedroomsNumbers_other: qh,
  beds_zero: Hh,
  beds_one: Jh,
  beds_other: Yh,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: Qh,
  global_babies: Xh,
  global_calendarUpdated_toast: em,
  global_calendar_aMonth: tm,
  global_calendar_exactDates: am,
  global_calendar_oneWeek: om,
  global_calendar_oneWeekend: nm,
  global_calendar_plusMinusDay_zero: rm,
  global_calendar_plusMinusDay_one: im,
  global_calendar_plusMinusDay_other: lm,
  global_calendar_twoWeeks: sm,
  global_cancel: cm,
  global_children: um,
  global_dates: dm,
  global_delete: _m,
  global_description: gm,
  global_destination: fm,
  global_done: bm,
  global_edit: hm,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: mm,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: pm,
  global_filter_bbq: ym,
  global_filter_bicycle: vm,
  global_filter_car: km,
  global_filter_cat: $m,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: wm,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: xm,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: Cm,
  global_filter_dog: Sm,
  global_filter_dryer: zm,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: Am,
  global_filter_favorite: Pm,
  global_filter_fireplace: Mm,
  global_filter_flat: Dm,
  global_filter_garden: Nm,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: Om,
  global_filter_guestPointsMin: Im,
  global_filter_guestPointsMinMax: jm,
  global_filter_gym: Lm,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: Em,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: Bm,
  global_filter_isolated: Tm,
  global_filter_jacuzzi: Rm,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: Fm,
  global_filter_luxury: Vm,
  global_filter_mountains: Gm,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: Um,
  global_filter_other: Zm,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: Wm,
  global_filter_playground: Km,
  global_filter_primary: qm,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: Hm,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: Jm,
  global_filter_river: Ym,
  global_filter_seaside: Qm,
  global_filter_secondary: Xm,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: ep,
  global_filter_villages: tp,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: ap,
  global_filters: op,
  global_fixDates: np,
  global_flexDates_aMonth: rp,
  global_flexDates_aWeekend: ip,
  global_flexDates_oneWeek: lp,
  global_flexDates_twoWeek: sp,
  global_flexibleDates: cp,
  global_guests: up,
  global_homes: dp,
  global_lastMinute: _p,
  global_location: gp,
  global_modify: fp,
  global_name: bp,
  global_next: hp,
  global_numberOfAdults_zero: mp,
  global_numberOfAdults_one: pp,
  global_numberOfAdults_other: yp,
  global_numberOfBabies_zero: vp,
  global_numberOfBabies_one: kp,
  global_numberOfBabies_other: $p,
  global_numberOfChildren_zero: wp,
  global_numberOfChildren_one: xp,
  global_numberOfChildren_other: Cp,
  global_numberOfGuests_zero: Sp,
  global_numberOfGuests_one: zp,
  global_numberOfGuests_other: Ap,
  global_phoneNumber_notValid: Pp,
  global_receiveEmailAlerts: Mp,
  global_save: Dp,
  global_searchBar_noLocationFound: Np,
  global_seeMore_link: Op,
  global_travelWishlist: Ip,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: jp,
  optional: Lp,
  "privacy-policy": "Datenschutz"
}, Bp = "Ihr Gastgeber hat die Wahl, die GuestPoints zu behalten oder zurückzugeben.", Tp = "Unbegründete oder wiederholte Stornierungen können zur Sperrung Ihres Kontos führen.", Rp = "Unbegründete oder wiederholte Stornierungen können zur Sperrung Ihres Kontos führen. Wenn GuestPoints im Spiel waren, kann Ihr Tauschpartner entscheiden, ob er sie behalten oder zurückgeben möchte.", Fp = "Nachdem Sie diesen Haustausch vorläufig bestätigt haben, muss Ihr Tauschpartner ihn finalisieren. Dazu hat Ihr Partner {nbDays} Tage Zeit (bis {date}). Nach Ablauf dieser Frist erlischt Ihre Vorabbestätigung und Sie müssen den Haustausch erneut vorläufig bestätigen.", Vp = "Mein Tauschpartner hat mich gebeten, den Tausch zu stornieren", Gp = "Doppelbuchung (über eine andere Plattform)", Up = "Familiäre Gründe", Zp = "Gesundheitliche Probleme", Wp = "Schäden an der Unterkunft", Kp = "Umzug", qp = "Sie müssten bitte die Gründe für Ihre Stornierung angeben.", Hp = "Andere", Jp = "Probleme bei der An-/Abreise", Yp = "Vertrauensprobleme", Qp = "Arbeitsbedingte Gründe", Xp = "Sie müssen einen Grund angeben", ey = {
  "cancellation-page.cancel-exchange": "Den Tausch stornieren",
  "cancellation-page.continue-cancellation": "Stornierung fortsetzen",
  "cancellation-page.keep-exchange": "Meinen Haustausch beibehalten",
  "cancellation-page.reason_step.checboxes_label": "Wählen Sie den Hauptgrund für Ihre Stornierung aus:",
  "cancellation-page.reason_step.comment_placeholder": "Bitte geben Sie hier den Grund für Ihre Stornierung an",
  "cancellation-page.reason_step.error": "Sie müssen einen Grund angeben",
  "cancellation-page.reason_step.title": "Warum müssen Sie stornieren?",
  "cancellation-page.warning-step.first-warning": "HomeExchange basiert auf Vertrauen und Verlässlichkeit. Denken Sie daran, dass eine Stornierung Auswirkungen auf Ihren Tauschpartner hat.",
  "cancellation-page.warning-step.second-warning": "Wichtig: Bei mehreren unbegründeten Stornierungen als Gastgeber kann Ihr Konto deaktiviert werden. Als Gast erhalten Sie außerdem möglicherweise nicht alle Ihre GuestPoints zurück.",
  page_cancellation_guest_calloutBody: Bp,
  page_cancellation_host_calloutBody: Tp,
  page_cancellation_reciprocal_calloutBody: Rp,
  pre_approval_modal_expiration_description: Fp,
  reasons_for_cancellation_asked_by_exchange_partner: Vp,
  reasons_for_cancellation_double_booking_rental: Gp,
  reasons_for_cancellation_family_issues: Up,
  reasons_for_cancellation_health_issues: Zp,
  reasons_for_cancellation_home_damage: Wp,
  reasons_for_cancellation_moving: Kp,
  reasons_for_cancellation_needed: qp,
  reasons_for_cancellation_other: Hp,
  reasons_for_cancellation_transportation_issues: Jp,
  reasons_for_cancellation_trust_issues: Yp,
  reasons_for_cancellation_work_related: Qp,
  reasons_other_comment_needed: Xp
}, ty = "Studio", ay = "{{count}} bedroom", oy = "{{count}} bedrooms", ny = "", ry = "{{count}} bed", iy = "{{count}} beds", ly = "Adults", sy = "Babies", cy = "Your calendar has been updated.", uy = "A month", dy = "Exact dates", _y = "One week", gy = "One weekend", fy = "", by = "± {{count}} day", hy = "± {{count}} days", my = "Two weeks", py = "Cancel", yy = "Children", vy = "Dates", ky = "Delete", $y = "Description", wy = "Destination", xy = "Done!", Cy = "Edit", Sy = "Any type of exchange", zy = "Bathtub", Ay = "BBQ", Py = "Bicycle", My = "Car", Dy = "Cat", Ny = "City", Oy = "Countryside", Iy = "Dishwasher", jy = "Dog", Ly = "Dryer", Ey = "Elevator", By = "Favorite homes", Ty = "Fireplace", Ry = "Apartment", Fy = "Private backyard", Vy = "less than {{max}} GP", Gy = "from {{min}} GP", Uy = "Between {{min}} and {{max}} GP", Zy = "Private gym", Wy = "House", Ky = "Island", qy = "Isolated", Hy = "Jacuzzi", Jy = "Lake", Yy = "Collection homes", Qy = "Mountain", Xy = "{{count}} bathrooms", ev = "Other animals", tv = "Piano", av = "Kid's playground", ov = "Primary", nv = "Reciprocal exchange", rv = "Reverse search", iv = "River", lv = "Coastal", sv = "Secondary", cv = "TV", uv = "Village", dv = "WiFi", _v = "Filters", gv = "Fixed dates", fv = "A month in {{date}}", bv = "A Week-end in {{date}}", hv = "One week in {{date}}", mv = "Two weeks in {{date}}", pv = "Flexible dates", yv = "Guests", vv = "homes", kv = "Last minute", $v = "Location", wv = "Modify", xv = "Name", Cv = "Next", Sv = "", zv = "{{count}} adult", Av = "{{count}} adults", Pv = "", Mv = "{{count}} baby", Dv = "{{count}} babies", Nv = "", Ov = "{{count}} child", Iv = "{{count}} children", jv = "{{count}} guest", Lv = "{{count}} guest", Ev = "{{count}} guests", Bv = "The phone number format is not valid", Tv = "Receive email alerts", Rv = "Save", Fv = "No locations found", Vv = "See more", Gv = "Travel wishlist", Uv = "No result", Zv = "optional", Wv = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: ty,
  bedroomsNumbers_one: ay,
  bedroomsNumbers_other: oy,
  beds_zero: ny,
  beds_one: ry,
  beds_other: iy,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: ly,
  global_babies: sy,
  global_calendarUpdated_toast: cy,
  global_calendar_aMonth: uy,
  global_calendar_exactDates: dy,
  global_calendar_oneWeek: _y,
  global_calendar_oneWeekend: gy,
  global_calendar_plusMinusDay_zero: fy,
  global_calendar_plusMinusDay_one: by,
  global_calendar_plusMinusDay_other: hy,
  global_calendar_twoWeeks: my,
  global_cancel: py,
  global_children: yy,
  global_dates: vy,
  global_delete: ky,
  global_description: $y,
  global_destination: wy,
  global_done: xy,
  global_edit: Cy,
  "global_filter_a-c": "A/C",
  global_filter_available: Sy,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: zy,
  global_filter_bbq: Ay,
  global_filter_bicycle: Py,
  global_filter_car: My,
  global_filter_cat: Dy,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: Ny,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: Oy,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: Iy,
  global_filter_dog: jy,
  global_filter_dryer: Ly,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: Ey,
  global_filter_favorite: By,
  global_filter_fireplace: Ty,
  global_filter_flat: Ry,
  global_filter_garden: Fy,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: Vy,
  global_filter_guestPointsMin: Gy,
  global_filter_guestPointsMinMax: Uy,
  global_filter_gym: Zy,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: Wy,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: Ky,
  global_filter_isolated: qy,
  global_filter_jacuzzi: Hy,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: Jy,
  global_filter_luxury: Yy,
  global_filter_mountains: Qy,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: Xy,
  global_filter_other: ev,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: tv,
  global_filter_playground: av,
  global_filter_primary: ov,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: nv,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: rv,
  global_filter_river: iv,
  global_filter_seaside: lv,
  global_filter_secondary: sv,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: cv,
  global_filter_villages: uv,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: dv,
  global_filters: _v,
  global_fixDates: gv,
  global_flexDates_aMonth: fv,
  global_flexDates_aWeekend: bv,
  global_flexDates_oneWeek: hv,
  global_flexDates_twoWeek: mv,
  global_flexibleDates: pv,
  global_guests: yv,
  global_homes: vv,
  global_lastMinute: kv,
  global_location: $v,
  global_modify: wv,
  global_name: xv,
  global_next: Cv,
  global_numberOfAdults_zero: Sv,
  global_numberOfAdults_one: zv,
  global_numberOfAdults_other: Av,
  global_numberOfBabies_zero: Pv,
  global_numberOfBabies_one: Mv,
  global_numberOfBabies_other: Dv,
  global_numberOfChildren_zero: Nv,
  global_numberOfChildren_one: Ov,
  global_numberOfChildren_other: Iv,
  global_numberOfGuests_zero: jv,
  global_numberOfGuests_one: Lv,
  global_numberOfGuests_other: Ev,
  global_phoneNumber_notValid: Bv,
  global_receiveEmailAlerts: Tv,
  global_save: Rv,
  global_searchBar_noLocationFound: Fv,
  global_seeMore_link: Vv,
  global_travelWishlist: Gv,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: Uv,
  optional: Zv,
  "privacy-policy": "Privacy Policy"
}, Kv = "Your host will have the choice to keep or return the GuestPoints as they wish.", qv = "Unjustified or repeated cancellations may result in your account being suspended.", Hv = "Unjustified or repeated cancellations may result in your account being suspended. If GuestPoints were involved, your exchange partner will have the choice to keep or return them.", Jv = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", Yv = "My exchange partner asked me to cancel the exchange", Qv = "Double booking (via another platform)", Xv = "Family issue", ek = "Health issue", tk = "Damage to home", ak = "Moving home", ok = "You need to indicate the reasons for your cancellation.", nk = "Other", rk = "Transport issue", ik = "Trust issue", lk = "Work related", sk = "You need to enter a reason", ck = {
  "cancellation-page.cancel-exchange": "Cancel this exchange",
  "cancellation-page.continue-cancellation": "Continue with cancellation",
  "cancellation-page.keep-exchange": "Keep this exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "Write the reason for your cancellation here",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "HomeExchange relies on trust and reliability. Remember that cancelling might have an impact on your exchange partner.",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  page_cancellation_guest_calloutBody: Kv,
  page_cancellation_host_calloutBody: qv,
  page_cancellation_reciprocal_calloutBody: Hv,
  pre_approval_modal_expiration_description: Jv,
  reasons_for_cancellation_asked_by_exchange_partner: Yv,
  reasons_for_cancellation_double_booking_rental: Qv,
  reasons_for_cancellation_family_issues: Xv,
  reasons_for_cancellation_health_issues: ek,
  reasons_for_cancellation_home_damage: tk,
  reasons_for_cancellation_moving: ak,
  reasons_for_cancellation_needed: ok,
  reasons_for_cancellation_other: nk,
  reasons_for_cancellation_transportation_issues: rk,
  reasons_for_cancellation_trust_issues: ik,
  reasons_for_cancellation_work_related: lk,
  reasons_other_comment_needed: sk
}, uk = "Estudio", dk = "{{count}} dormitorio", _k = "{{count}} dormitorios", gk = "", fk = "{{count}} cama", bk = "{{count}} camas", hk = "", mk = "", pk = "Tu calendario ha sido actualizado.", yk = "Un mes", vk = "Fechas exactas", kk = "Una semana", $k = "Un fin de semana", wk = "", xk = "± {{count}} día", Ck = "± {{count}} días", Sk = "Dos semanas", zk = "Cancelar", Ak = "", Pk = "Fechas", Mk = "Eliminar", Dk = "Descripción", Nk = "Destino", Ok = "¡Listo!", Ik = "Editar", jk = "Cualquier tipo de intercambio", Lk = "Bañera", Ek = "Barbacoa", Bk = "Bicicleta", Tk = "Coche", Rk = "Gato", Fk = "Ciudad", Vk = "Campo", Gk = "Lavavajillas", Uk = "Perro", Zk = "Secadora", Wk = "Ascensor", Kk = "Casas favoritas", qk = "Chimenea", Hk = "Piso", Jk = "Patio privado", Yk = "", Qk = "", Xk = "", e$ = "", t$ = "Casa", a$ = "Isla", o$ = "Aislado", n$ = "Jacuzzi", r$ = "Lagos", i$ = "Casas Collection", l$ = "", s$ = "{{count}} baños", c$ = "Otros animales", u$ = "Piano", d$ = "Columpios", _$ = "Principal", g$ = "Intercambio recíproco", f$ = "Búsqueda inversa", b$ = "Río", h$ = "En la costa", m$ = "Secundaria", p$ = "TV", y$ = "Pueblo", v$ = "WiFi", k$ = "Filtros", $$ = "Fechas fijas", w$ = "Un mes en {{date}}", x$ = "Un fin de semana en {{date}}", C$ = "Una semana en {{date}}", S$ = "Dos semanas en {{date}}", z$ = "Fechas flexibles", A$ = "Invitados", P$ = "casas", M$ = "Último minuto", D$ = "Ubicación", N$ = "Modificar", O$ = "Nombre", I$ = "Siguiente", j$ = "", L$ = "{{count}} adulto", E$ = "{{count}} adultos", B$ = "", T$ = "{{count}} bebé", R$ = "bebé", F$ = "", V$ = "{{count}} niño/a", G$ = "{{count}} niños", U$ = "", Z$ = "{{count}} invitado/a", W$ = "{{count}} invitados", K$ = "El formato del número de teléfono no es válido.", q$ = "Recibir notificaciones por correo electrónico", H$ = "Guardar", J$ = "No encontramos este lugar", Y$ = "Ver más", Q$ = "Proyectos de viaje", X$ = "", ew = "opcional", tw = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: uk,
  bedroomsNumbers_one: dk,
  bedroomsNumbers_other: _k,
  beds_zero: gk,
  beds_one: fk,
  beds_other: bk,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: hk,
  global_babies: mk,
  global_calendarUpdated_toast: pk,
  global_calendar_aMonth: yk,
  global_calendar_exactDates: vk,
  global_calendar_oneWeek: kk,
  global_calendar_oneWeekend: $k,
  global_calendar_plusMinusDay_zero: wk,
  global_calendar_plusMinusDay_one: xk,
  global_calendar_plusMinusDay_other: Ck,
  global_calendar_twoWeeks: Sk,
  global_cancel: zk,
  global_children: Ak,
  global_dates: Pk,
  global_delete: Mk,
  global_description: Dk,
  global_destination: Nk,
  global_done: Ok,
  global_edit: Ik,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: jk,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: Lk,
  global_filter_bbq: Ek,
  global_filter_bicycle: Bk,
  global_filter_car: Tk,
  global_filter_cat: Rk,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: Fk,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: Vk,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: Gk,
  global_filter_dog: Uk,
  global_filter_dryer: Zk,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: Wk,
  global_filter_favorite: Kk,
  global_filter_fireplace: qk,
  global_filter_flat: Hk,
  global_filter_garden: Jk,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: Yk,
  global_filter_guestPointsMin: Qk,
  global_filter_guestPointsMinMax: Xk,
  global_filter_gym: e$,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: t$,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: a$,
  global_filter_isolated: o$,
  global_filter_jacuzzi: n$,
  "global_filter_kids-toys": "",
  global_filter_lakes: r$,
  global_filter_luxury: i$,
  global_filter_mountains: l$,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: s$,
  global_filter_other: c$,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: u$,
  global_filter_playground: d$,
  global_filter_primary: _$,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: g$,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: f$,
  global_filter_river: b$,
  global_filter_seaside: h$,
  global_filter_secondary: m$,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: p$,
  global_filter_villages: y$,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: v$,
  global_filters: k$,
  global_fixDates: $$,
  global_flexDates_aMonth: w$,
  global_flexDates_aWeekend: x$,
  global_flexDates_oneWeek: C$,
  global_flexDates_twoWeek: S$,
  global_flexibleDates: z$,
  global_guests: A$,
  global_homes: P$,
  global_lastMinute: M$,
  global_location: D$,
  global_modify: N$,
  global_name: O$,
  global_next: I$,
  global_numberOfAdults_zero: j$,
  global_numberOfAdults_one: L$,
  global_numberOfAdults_other: E$,
  global_numberOfBabies_zero: B$,
  global_numberOfBabies_one: T$,
  global_numberOfBabies_other: R$,
  global_numberOfChildren_zero: F$,
  global_numberOfChildren_one: V$,
  global_numberOfChildren_other: G$,
  global_numberOfGuests_zero: U$,
  global_numberOfGuests_one: Z$,
  global_numberOfGuests_other: W$,
  global_phoneNumber_notValid: K$,
  global_receiveEmailAlerts: q$,
  global_save: H$,
  global_searchBar_noLocationFound: J$,
  global_seeMore_link: Y$,
  global_travelWishlist: Q$,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: X$,
  optional: ew,
  "privacy-policy": "Política de Privacidad"
}, aw = "Tus anfitriones podrán elegir si desean quedarse los GuestPoints o devolverlos.", ow = "Las cancelaciones sin causa justificada o reiteradas pueden dar lugar a la suspensión de tu cuenta.", nw = "Las cancelaciones sin causa justificada o reiteradas pueden dar lugar a la suspensión de una cuenta. Si hubiera GuestPoints de por medio, tus compañeros de intercambio tendrán la opción de conservarlos o devolverlos.", rw = "Después de preaprobar este intercambio, tus compañeros de intercambio tendrán que registrarlo. Tienes {nbDays} días para registrar el intercambio (hasta el {date}). De lo contrario, la preaprobación caducará y tendrás que volver a preaprobar el intercambio.", iw = "Mis compañeros de intercambio me han pedido que cancele el intercambio", lw = "Reserva doble (por otra plataforma)", sw = "Motivos familiares", cw = "Problemas de salud", uw = "Daños en la casa", dw = "Mudanza", _w = "Por favor, indica el motivo de la cancelación", gw = "Otros", fw = "Problemas con el transporte", bw = "Temas de confianza", hw = "Motivos laborales", mw = "Debes introducir un motivo", pw = {
  "cancellation-page.cancel-exchange": "Cancelar el intercambio",
  "cancellation-page.continue-cancellation": "Continuar con la cancelación",
  "cancellation-page.keep-exchange": "Mantener el intercambio",
  "cancellation-page.reason_step.checboxes_label": "Selecciona el motivo principal de la cancelación:",
  "cancellation-page.reason_step.comment_placeholder": "Escribe aquí el motivo de tu cancelación",
  "cancellation-page.reason_step.error": "Tienes que elegir un motivo",
  "cancellation-page.reason_step.title": "¿Por qué quieres cancelar el intercambio?",
  "cancellation-page.warning-step.first-warning": "HomeExchange se basa en la confianza. Recuerda que la cancelación puede afectar a tus compañeros de intercambio.",
  "cancellation-page.warning-step.second-warning": "Importante: un exceso de cancelaciones sin causa justificada por parte de los anfitriones puede resultar en la desactivación de su cuenta y, por parte de los invitados, puede implicar que no se recuperen todos los GuestPoints.",
  page_cancellation_guest_calloutBody: aw,
  page_cancellation_host_calloutBody: ow,
  page_cancellation_reciprocal_calloutBody: nw,
  pre_approval_modal_expiration_description: rw,
  reasons_for_cancellation_asked_by_exchange_partner: iw,
  reasons_for_cancellation_double_booking_rental: lw,
  reasons_for_cancellation_family_issues: sw,
  reasons_for_cancellation_health_issues: cw,
  reasons_for_cancellation_home_damage: uw,
  reasons_for_cancellation_moving: dw,
  reasons_for_cancellation_needed: _w,
  reasons_for_cancellation_other: gw,
  reasons_for_cancellation_transportation_issues: fw,
  reasons_for_cancellation_trust_issues: bw,
  reasons_for_cancellation_work_related: hw,
  reasons_other_comment_needed: mw
}, yw = "Studio", vw = "{{count}} chambre", kw = "{{count}} chambres", $w = "", ww = "{{count}} lit", xw = "{{count}} lits", Cw = "Adultes", Sw = "Bébés", zw = "Votre calendrier a été mis à jour.", Aw = "Un mois", Pw = "Dates exactes", Mw = "Une semaine", Dw = "Un week-end", Nw = "Vide", Ow = "± {{count}} jour", Iw = "± {{count}} jours", jw = "Deux semaines", Lw = "Annuler", Ew = "Enfants", Bw = "Dates", Tw = "Supprimer", Rw = "Description", Fw = "Destination", Vw = "C'est prêt !", Gw = "Modifier", Uw = "Tout type d'échange", Zw = "Baignoire", Ww = "Barbecue", Kw = "Vélo", qw = "Voiture", Hw = "Chat", Jw = "Ville", Yw = "Campagne", Qw = "Lave-vaisselle", Xw = "Chien", ex = "Sèche linge", tx = "Ascenseur", ax = "Maisons favorites", ox = "Cheminée", nx = "Appartement", rx = "Jardin privé", ix = "moins de {{max}} GP", lx = "à partir de {{min}} GP", sx = "Entre {{min}} et {{max}} GP", cx = "Salle de sport privée", ux = "Maison", dx = "Île", _x = "Isolé", gx = "Jacuzzi", fx = "Lac", bx = "Maisons Collection", hx = "Montagne", mx = "{{count}} salles de bain", px = "Autre", yx = "Piano", vx = "Aire de jeux", kx = "Principale", $x = "Échange réciproque", wx = "Recherche inversée", xx = "Rivière", Cx = "Bord de mer", Sx = "Secondaire", zx = "TV", Ax = "Village", Px = "WiFi", Mx = "Filtres", Dx = "Dates fixes", Nx = "Un mois en {{date}}", Ox = "Un week-end en {{date}}", Ix = "Une semaine en {{date}}", jx = "Deux semaines en {{date}}", Lx = "Dates flexibles", Ex = "Personnes", Bx = "maisons", Tx = "Dernière minute", Rx = "Lieu", Fx = "Modifier", Vx = "Titre", Gx = "Suivant", Ux = "Vide", Zx = "{{count}} adulte", Wx = "{{count}} adultes", Kx = "Vide", qx = "{{count}} bébé", Hx = "{{count}} bébés", Jx = "Vide", Yx = "{{count}} enfant", Qx = "{{count}} enfants", Xx = "{{count}} personne", eC = "{{count}} personne", tC = "{{count}} personnes", aC = "Le format du numéro de téléphone est invalide.", oC = "Recevoir des alertes par email", nC = "Enregistrer", rC = "Aucun lieu trouvé", iC = "Voir plus", lC = "Projets de voyage", sC = "", cC = "facultatif", uC = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: yw,
  bedroomsNumbers_one: vw,
  bedroomsNumbers_other: kw,
  beds_zero: $w,
  beds_one: ww,
  beds_other: xw,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: Cw,
  global_babies: Sw,
  global_calendarUpdated_toast: zw,
  global_calendar_aMonth: Aw,
  global_calendar_exactDates: Pw,
  global_calendar_oneWeek: Mw,
  global_calendar_oneWeekend: Dw,
  global_calendar_plusMinusDay_zero: Nw,
  global_calendar_plusMinusDay_one: Ow,
  global_calendar_plusMinusDay_other: Iw,
  global_calendar_twoWeeks: jw,
  global_cancel: Lw,
  global_children: Ew,
  global_dates: Bw,
  global_delete: Tw,
  global_description: Rw,
  global_destination: Fw,
  global_done: Vw,
  global_edit: Gw,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: Uw,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: Zw,
  global_filter_bbq: Ww,
  global_filter_bicycle: Kw,
  global_filter_car: qw,
  global_filter_cat: Hw,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: Jw,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: Yw,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: Qw,
  global_filter_dog: Xw,
  global_filter_dryer: ex,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: tx,
  global_filter_favorite: ax,
  global_filter_fireplace: ox,
  global_filter_flat: nx,
  global_filter_garden: rx,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: ix,
  global_filter_guestPointsMin: lx,
  global_filter_guestPointsMinMax: sx,
  global_filter_gym: cx,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: ux,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: dx,
  global_filter_isolated: _x,
  global_filter_jacuzzi: gx,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: fx,
  global_filter_luxury: bx,
  global_filter_mountains: hx,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: mx,
  global_filter_other: px,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: yx,
  global_filter_playground: vx,
  global_filter_primary: kx,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: $x,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: wx,
  global_filter_river: xx,
  global_filter_seaside: Cx,
  global_filter_secondary: Sx,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: zx,
  global_filter_villages: Ax,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: Px,
  global_filters: Mx,
  global_fixDates: Dx,
  global_flexDates_aMonth: Nx,
  global_flexDates_aWeekend: Ox,
  global_flexDates_oneWeek: Ix,
  global_flexDates_twoWeek: jx,
  global_flexibleDates: Lx,
  global_guests: Ex,
  global_homes: Bx,
  global_lastMinute: Tx,
  global_location: Rx,
  global_modify: Fx,
  global_name: Vx,
  global_next: Gx,
  global_numberOfAdults_zero: Ux,
  global_numberOfAdults_one: Zx,
  global_numberOfAdults_other: Wx,
  global_numberOfBabies_zero: Kx,
  global_numberOfBabies_one: qx,
  global_numberOfBabies_other: Hx,
  global_numberOfChildren_zero: Jx,
  global_numberOfChildren_one: Yx,
  global_numberOfChildren_other: Qx,
  global_numberOfGuests_zero: Xx,
  global_numberOfGuests_one: eC,
  global_numberOfGuests_other: tC,
  global_phoneNumber_notValid: aC,
  global_receiveEmailAlerts: oC,
  global_save: nC,
  global_searchBar_noLocationFound: rC,
  global_seeMore_link: iC,
  global_travelWishlist: lC,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: sC,
  optional: cC,
  "privacy-policy": "Charte de vie privée"
}, dC = "Votre hôte pourra choisir de conserver ou de vous restituer les GuestPoints.", _C = "Des annulations injustifiées ou répétées peuvent entraîner la suspension de votre compte.", gC = "Des annulations injustifiées ou répétées peuvent entraîner la suspension de votre compte. Si des GuestPoints ont été utilisés, votre partenaire d'échange aura le choix de les conserver ou de vous les restituer.", fC = "Après cette pré-approbation, votre partenaire d'échange disposera de {nbDays} jour(s) pour finaliser (jusqu'au {date}). Sinon, votre pré-approbation expirera et vous devrez pré-approuver l'échange de nouveau.", bC = "C'est mon partenaire d'échange qui m'a demandé d'annuler", hC = "Double réservation (via une autre plateforme)", mC = "Imprévu familial", pC = "Problème de santé", yC = "Dégâts à mon domicile", vC = "Déménagement", kC = "Vous devez indiquer la raison de votre annulation.", $C = "Autre", wC = "Problème de transport", xC = "Problème de confiance", CC = "Imprévu professionnel", SC = "Vous devez saisir un motif", zC = {
  "cancellation-page.cancel-exchange": "Annuler l'échange",
  "cancellation-page.continue-cancellation": "Poursuivre l'annulation",
  "cancellation-page.keep-exchange": "Conserver mon échange",
  "cancellation-page.reason_step.checboxes_label": "Sélectionnez la raison principale de votre annulation :",
  "cancellation-page.reason_step.comment_placeholder": "Indiquez la raison de votre annulation juste ici",
  "cancellation-page.reason_step.error": "Vous devez saisir un motif",
  "cancellation-page.reason_step.title": "Pourquoi devez-vous annuler ?",
  "cancellation-page.warning-step.first-warning": "HomeExchange repose sur la confiance. N'oubliez pas que l'annulation de votre échange peut avoir un impact négatif sur votre partenaire d'échange.",
  "cancellation-page.warning-step.second-warning": "Important : Face à un nombre excessif d'annulations injustifiées en tant qu'hôte, votre compte pourrait être mis hors ligne et, en tant qu'invité-e, vous pourriez ne pas récupérer l'intégralité de vos GuestPoints.",
  page_cancellation_guest_calloutBody: dC,
  page_cancellation_host_calloutBody: _C,
  page_cancellation_reciprocal_calloutBody: gC,
  pre_approval_modal_expiration_description: fC,
  reasons_for_cancellation_asked_by_exchange_partner: bC,
  reasons_for_cancellation_double_booking_rental: hC,
  reasons_for_cancellation_family_issues: mC,
  reasons_for_cancellation_health_issues: pC,
  reasons_for_cancellation_home_damage: yC,
  reasons_for_cancellation_moving: vC,
  reasons_for_cancellation_needed: kC,
  reasons_for_cancellation_other: $C,
  reasons_for_cancellation_transportation_issues: wC,
  reasons_for_cancellation_trust_issues: xC,
  reasons_for_cancellation_work_related: CC,
  reasons_other_comment_needed: SC
}, AC = "Studio", PC = "{{count}} soba", MC = "{{count}} sobe", DC = "{{count}} sobe", NC = "", OC = "{{count}} krevet", IC = "{{count}} kreveti", jC = "{{count}} kreveti", LC = "Odrasle osobe", EC = "Bebe", BC = "Vaš je kalendar ažuriran.", TC = "Mjesec", RC = "Točni datumi", FC = "Jedan tjedan", VC = "Jedan vikend", GC = "dana", UC = "dan", ZC = "dana", WC = "± {{count}} dan", KC = "Dva tjedna", qC = "Odustani", HC = "Djeca", JC = "Datumi", YC = "Izbrišite", QC = "Opis", XC = "Odredište", eS = "Gotovo!", tS = "Uredite", aS = "Sve vrste zamjene", oS = "Kada", nS = "Roštilj", rS = "Bicikl", iS = "Automobil", lS = "Mačka", sS = "Grad", cS = "Ruralno", uS = "Perilica suđa", dS = "Pas", _S = "Sušilica", gS = "Dizalo", fS = "Favoriti", bS = "Kamin", hS = "Stan", mS = "Privatno dvorište", pS = "manje od {{max}} GP", yS = "od {{min}} GP", vS = "Između {{min}} i {{max}} GP", kS = "Privatna teretana", $S = "Kuća", wS = "Otok", xS = "Izoliran", CS = "Jacuzzi", SS = "Jezera", zS = "Domove iz Collectiona", AS = "Planine", PS = "broj kupanica: %{count}", MS = "Ostale životinje", DS = "Glasovir", NS = "Dječje igralište", OS = "Moj dom", IS = "Recipročna zamjena", jS = "Obrnuta pretraga", LS = "Rijeka", ES = "Na obali", BS = "Drugi", TS = "TV", RS = "Selo", FS = "WiFi", VS = "Filtri", GS = "Fiksni datumi", US = "{{date}}: jedan mjesec", ZS = "{{date}}: jedan vikend", WS = "{{date}}: jedan tjedan", KS = "{{date}}: dva tjedna", qS = "Fleksibilni datumi", HS = "Gosti", JS = "domova", YS = "U zadnji tren", QS = "Lokacija", XS = "Uredi", e1 = "", t1 = "Dalje", a1 = "odraslih osoba", o1 = "odrasla osoba", n1 = "odrasle osobe", r1 = "odraslih osoba", i1 = "beba", l1 = "beba", s1 = "bebe", c1 = "beba", u1 = "djece", d1 = "dijete", _1 = "djeteta", g1 = "djece", f1 = "gostiju", b1 = "gost", h1 = "gosta", m1 = "gostiju", p1 = "Format telefonskog broja nije valjan.", y1 = "Primajte obavijesti e-poštom", v1 = "Spremi", k1 = "Nema pronađenih lokacija", $1 = "Saznajte više", w1 = "Planovi putovanja", x1 = "", C1 = "nije obavezno", S1 = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: AC,
  bedroomsNumbers_one: PC,
  bedroomsNumbers_few: MC,
  bedroomsNumbers_other: DC,
  beds_zero: NC,
  beds_one: OC,
  beds_few: IC,
  beds_other: jC,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: LC,
  global_babies: EC,
  global_calendarUpdated_toast: BC,
  global_calendar_aMonth: TC,
  global_calendar_exactDates: RC,
  global_calendar_oneWeek: FC,
  global_calendar_oneWeekend: VC,
  global_calendar_plusMinusDay_zero: GC,
  global_calendar_plusMinusDay_one: UC,
  global_calendar_plusMinusDay_few: ZC,
  global_calendar_plusMinusDay_other: WC,
  global_calendar_twoWeeks: KC,
  global_cancel: qC,
  global_children: HC,
  global_dates: JC,
  global_delete: YC,
  global_description: QC,
  global_destination: XC,
  global_done: eS,
  global_edit: tS,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: aS,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: oS,
  global_filter_bbq: nS,
  global_filter_bicycle: rS,
  global_filter_car: iS,
  global_filter_cat: lS,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: sS,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: cS,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: uS,
  global_filter_dog: dS,
  global_filter_dryer: _S,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: gS,
  global_filter_favorite: fS,
  global_filter_fireplace: bS,
  global_filter_flat: hS,
  global_filter_garden: mS,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: pS,
  global_filter_guestPointsMin: yS,
  global_filter_guestPointsMinMax: vS,
  global_filter_gym: kS,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: $S,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: wS,
  global_filter_isolated: xS,
  global_filter_jacuzzi: CS,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: SS,
  global_filter_luxury: zS,
  global_filter_mountains: AS,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: PS,
  global_filter_other: MS,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: DS,
  global_filter_playground: NS,
  global_filter_primary: OS,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: IS,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: jS,
  global_filter_river: LS,
  global_filter_seaside: ES,
  global_filter_secondary: BS,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: TS,
  global_filter_villages: RS,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: FS,
  global_filters: VS,
  global_fixDates: GS,
  global_flexDates_aMonth: US,
  global_flexDates_aWeekend: ZS,
  global_flexDates_oneWeek: WS,
  global_flexDates_twoWeek: KS,
  global_flexibleDates: qS,
  global_guests: HS,
  global_homes: JS,
  global_lastMinute: YS,
  global_location: QS,
  global_modify: XS,
  global_name: e1,
  global_next: t1,
  global_numberOfAdults_zero: a1,
  global_numberOfAdults_one: o1,
  global_numberOfAdults_few: n1,
  global_numberOfAdults_other: r1,
  global_numberOfBabies_zero: i1,
  global_numberOfBabies_one: l1,
  global_numberOfBabies_few: s1,
  global_numberOfBabies_other: c1,
  global_numberOfChildren_zero: u1,
  global_numberOfChildren_one: d1,
  global_numberOfChildren_few: _1,
  global_numberOfChildren_other: g1,
  global_numberOfGuests_zero: f1,
  global_numberOfGuests_one: b1,
  global_numberOfGuests_few: h1,
  global_numberOfGuests_other: m1,
  global_phoneNumber_notValid: p1,
  global_receiveEmailAlerts: y1,
  global_save: v1,
  global_searchBar_noLocationFound: k1,
  global_seeMore_link: $1,
  global_travelWishlist: w1,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: x1,
  optional: C1,
  "privacy-policy": "Pravila o privatnosti"
}, z1 = "Vaš će domaćin moći odabrati hoće li zadržati ili vratiti GuestPoints.", A1 = "Neopravdana ili ponavljana otkazivanja mogu dovesti do suspenzije Vašeg računa.", P1 = "Neopravdana ili ponavljana otkazivanja mogu dovesti do suspenzije Vašeg računa. Ako je zamjena bila temeljena na GuestPoints, Vaš partner za zamjenu će moći birati hoće li ih zadržati ili vratiti.", M1 = "Nakon što unaprijed odobrite ovu zamjenu, Vaš partner za zamjenu ju mora finalizirati. Za to ima {nbDays} dana (do {date}). Ako ne, Vaše će prethodno odobrenje isteći i trebat ćete ponovno prethodno odobriti zamjenu.", D1 = "Moj partner za zamjenu me zamolio da otkažem zamjenu", N1 = "Dvostruka rezervacija (druga platforma)", O1 = "Obiteljski problemi", I1 = "Zdravstveni problemi", j1 = "Oštećenje doma", L1 = "Preseljenje", E1 = "Morate navesti razloge otkazivanja.", B1 = "Ostalo", T1 = "Problemi s prijevozom", R1 = "Nepovjerenje", F1 = "Poslovni problemi", V1 = "Trebate unijeti razlog", G1 = {
  "cancellation-page.cancel-exchange": "Otkažite ovu zamjenu",
  "cancellation-page.continue-cancellation": "Nastavite s otkazivanjem",
  "cancellation-page.keep-exchange": "Zadržite ovu zamjenu",
  "cancellation-page.reason_step.checboxes_label": "Odaberite glavni razlog zašto otkazujete:",
  "cancellation-page.reason_step.comment_placeholder": "Ovdje unesite razlog otkazivanja zamjene",
  "cancellation-page.reason_step.error": "Trebate unijeti razlog",
  "cancellation-page.reason_step.title": "Zašto trebate otkazati?",
  "cancellation-page.warning-step.first-warning": "HomeExchange se oslanja na povjerenje i pouzdanost. Vodite računa o tome da otkazivanje može utjecati na Vašeg partnera za zamjenu.",
  "cancellation-page.warning-step.second-warning": "Važno: U slučaju pretjeranih neopradanih otkazivanja u svojstvu domaćina, Vaš račun može biti ugašen.. A kao gost, možda Vam neće biti vraćeni Vaši GuestPoints.",
  page_cancellation_guest_calloutBody: z1,
  page_cancellation_host_calloutBody: A1,
  page_cancellation_reciprocal_calloutBody: P1,
  pre_approval_modal_expiration_description: M1,
  reasons_for_cancellation_asked_by_exchange_partner: D1,
  reasons_for_cancellation_double_booking_rental: N1,
  reasons_for_cancellation_family_issues: O1,
  reasons_for_cancellation_health_issues: I1,
  reasons_for_cancellation_home_damage: j1,
  reasons_for_cancellation_moving: L1,
  reasons_for_cancellation_needed: E1,
  reasons_for_cancellation_other: B1,
  reasons_for_cancellation_transportation_issues: T1,
  reasons_for_cancellation_trust_issues: R1,
  reasons_for_cancellation_work_related: F1,
  reasons_other_comment_needed: V1
}, U1 = "Monolocale", Z1 = "{{count}} camera da letto", W1 = "{{count}} camere da letto", K1 = "", q1 = "{{count}} letto", H1 = "{{count}} letti", J1 = "Adulti", Y1 = "Neonati", Q1 = "Il tuo calendario è stato aggiornato.", X1 = "Un mese", ez = "Date esatte", tz = "Una settimana", az = "", oz = "", nz = "", rz = "", iz = "Due settimane", lz = "Annulla", sz = "Bambini", cz = "Date", uz = "Elimina", dz = "Descrizione", _z = "Destinazione", gz = "Fatto!", fz = "Modifica", bz = "Qualsiasi tipo di scambio", hz = "Vasca da bagno", mz = "Barbecue", pz = "Bicicletta", yz = "Automobile", vz = "Gatto", kz = "Città", $z = "Campagna", wz = "Lavastoviglie", xz = "Cane", Cz = "Asciugatrice", Sz = "Ascensore", zz = "Case preferite", Az = "Camino", Pz = "Appartamento", Mz = "Cortile privato", Dz = "Meno di {{max}} GP", Nz = "da {{min}} GP", Oz = "Tra {{min}} e {{max}} GP", Iz = "Palestra privata", jz = "Casa", Lz = "Isola o penisola", Ez = "Isolata", Bz = "Idromassaggio", Tz = "Lago", Rz = "Case Collection", Fz = "Montagna", Vz = "{{count}} bagni", Gz = "Altri animali", Uz = "Pianoforte", Zz = "Zona giochi per bambini", Wz = "Prima", Kz = "Scambio reciproco", qz = "Ricerca inversa", Hz = "Fiume", Jz = "Sulla costa", Yz = "Seconda", Qz = "TV", Xz = "Paese", eA = "WiFi", tA = "Filtri", aA = "Date esatte", oA = "Un mese in {{date}}", nA = "Un fine settimana in {{date}}", rA = "Una settimana in {{date}}", iA = "Due settimane in {{date}}", lA = "Date flessibili", sA = "Ospiti", cA = "case", uA = "Ultimo minuto", dA = "Posizione", _A = "Modifica", gA = "Nome", fA = "Avanti", bA = "Zero", hA = "Uno", mA = "Altro", pA = "Zero", yA = "Uno", vA = "Altro", kA = "Zero", $A = "Uno", wA = "Altro", xA = "Zero", CA = "Uno", SA = "Altro", zA = "Il formato del numero di telefono non è valido.", AA = "Ricevi avvisi via email", PA = "Salva", MA = "Nessuna posizione trovata", DA = "Vedere di più", NA = "Progetti di viaggio", OA = "", IA = "facoltativo", jA = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: U1,
  bedroomsNumbers_one: Z1,
  bedroomsNumbers_other: W1,
  beds_zero: K1,
  beds_one: q1,
  beds_other: H1,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: J1,
  global_babies: Y1,
  global_calendarUpdated_toast: Q1,
  global_calendar_aMonth: X1,
  global_calendar_exactDates: ez,
  global_calendar_oneWeek: tz,
  global_calendar_oneWeekend: az,
  global_calendar_plusMinusDay_zero: oz,
  global_calendar_plusMinusDay_one: nz,
  global_calendar_plusMinusDay_other: rz,
  global_calendar_twoWeeks: iz,
  global_cancel: lz,
  global_children: sz,
  global_dates: cz,
  global_delete: uz,
  global_description: dz,
  global_destination: _z,
  global_done: gz,
  global_edit: fz,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: bz,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: hz,
  global_filter_bbq: mz,
  global_filter_bicycle: pz,
  global_filter_car: yz,
  global_filter_cat: vz,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: kz,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: $z,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: wz,
  global_filter_dog: xz,
  global_filter_dryer: Cz,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: Sz,
  global_filter_favorite: zz,
  global_filter_fireplace: Az,
  global_filter_flat: Pz,
  global_filter_garden: Mz,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: Dz,
  global_filter_guestPointsMin: Nz,
  global_filter_guestPointsMinMax: Oz,
  global_filter_gym: Iz,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: jz,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: Lz,
  global_filter_isolated: Ez,
  global_filter_jacuzzi: Bz,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: Tz,
  global_filter_luxury: Rz,
  global_filter_mountains: Fz,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: Vz,
  global_filter_other: Gz,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: Uz,
  global_filter_playground: Zz,
  global_filter_primary: Wz,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: Kz,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: qz,
  global_filter_river: Hz,
  global_filter_seaside: Jz,
  global_filter_secondary: Yz,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: Qz,
  global_filter_villages: Xz,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: eA,
  global_filters: tA,
  global_fixDates: aA,
  global_flexDates_aMonth: oA,
  global_flexDates_aWeekend: nA,
  global_flexDates_oneWeek: rA,
  global_flexDates_twoWeek: iA,
  global_flexibleDates: lA,
  global_guests: sA,
  global_homes: cA,
  global_lastMinute: uA,
  global_location: dA,
  global_modify: _A,
  global_name: gA,
  global_next: fA,
  global_numberOfAdults_zero: bA,
  global_numberOfAdults_one: hA,
  global_numberOfAdults_other: mA,
  global_numberOfBabies_zero: pA,
  global_numberOfBabies_one: yA,
  global_numberOfBabies_other: vA,
  global_numberOfChildren_zero: kA,
  global_numberOfChildren_one: $A,
  global_numberOfChildren_other: wA,
  global_numberOfGuests_zero: xA,
  global_numberOfGuests_one: CA,
  global_numberOfGuests_other: SA,
  global_phoneNumber_notValid: zA,
  global_receiveEmailAlerts: AA,
  global_save: PA,
  global_searchBar_noLocationFound: MA,
  global_seeMore_link: DA,
  global_travelWishlist: NA,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: OA,
  optional: IA,
  "privacy-policy": "Informativa sulla privacy"
}, LA = "Il tuo host potrà scegliere se conservare o restituire i GuestPoints a suo piacimento.", EA = "Cancellazioni ingiustificate o ripetute potrebbero comportare la sospensione del tuo account.", BA = "Cancellazioni ingiustificate o ripetute potrebbero comportare la sospensione del tuo account. Se sono coinvolti GuestPoints, il tuo partner di scambio avrà la possibilità di conservarli o restituirli.", TA = "Dopo aver pre-approvato questo scambio, il tuo partner di scambio dovrà finalizzarlo. Avrà tempo {nbDays} giorni per finalizzare lo scambio (fino al giorno {date}). In caso contrario, la tua pre-approvazione scadrà e dovrai pre-approvare lo scambio nuovamente.", RA = "Il mio partner di scambio mi ha chiesto di annullare lo scambio", FA = "Doppia prenotazione (con un'altra piattaforma)", VA = "Ragioni familiari", GA = "Motivi di salute", UA = "Danni alla proprietà", ZA = "Trasferimento", WA = "È necessario indicare i motivi per la cancellazione.", KA = "Altro", qA = "Problemi di trasporto", HA = "Problemi di fiducia", JA = "Motivi legati al lavoro", YA = "È necessario inserire un motivo", QA = {
  "cancellation-page.cancel-exchange": "Annulla questo scambio",
  "cancellation-page.continue-cancellation": "Continua con la cancellazione",
  "cancellation-page.keep-exchange": "Mantieni questo scambio",
  "cancellation-page.reason_step.checboxes_label": "Seleziona il motivo principale della tua cancellazione:",
  "cancellation-page.reason_step.comment_placeholder": "Inserisci qui la ragione della cancellazione",
  "cancellation-page.reason_step.error": "È necessario inserire un motivo",
  "cancellation-page.reason_step.title": "Perché devi annullare?",
  "cancellation-page.warning-step.first-warning": "HomeExchange si basa sulla fiducia e sull'affidabilità. Ricorda che la cancellazione potrebbe avere ripercussioni sul tuo partner di scambio.",
  "cancellation-page.warning-step.second-warning": "Importante: In caso di eccessive cancellazioni ingiustificate in qualità di host, il tuo account potrebbe essere disattivato. Come ospite, invece, potresti non recuperare tutti i tuoi GuestPoints.",
  page_cancellation_guest_calloutBody: LA,
  page_cancellation_host_calloutBody: EA,
  page_cancellation_reciprocal_calloutBody: BA,
  pre_approval_modal_expiration_description: TA,
  reasons_for_cancellation_asked_by_exchange_partner: RA,
  reasons_for_cancellation_double_booking_rental: FA,
  reasons_for_cancellation_family_issues: VA,
  reasons_for_cancellation_health_issues: GA,
  reasons_for_cancellation_home_damage: UA,
  reasons_for_cancellation_moving: ZA,
  reasons_for_cancellation_needed: WA,
  reasons_for_cancellation_other: KA,
  reasons_for_cancellation_transportation_issues: qA,
  reasons_for_cancellation_trust_issues: HA,
  reasons_for_cancellation_work_related: JA,
  reasons_other_comment_needed: YA
}, XA = "Studio", e0 = "{{count}} soverom", t0 = "{{count}} soverom", a0 = "", o0 = "{{count}} seng", n0 = "{{count}} senger", r0 = "Voksne", i0 = "Babyer", l0 = "", s0 = "En måned", c0 = "Nøyaktige datoer", u0 = "Uke", d0 = "", _0 = "", g0 = "", f0 = "", b0 = "To uker", h0 = "", m0 = "Barn", p0 = "Datoer", y0 = "", v0 = "Beskrivelse", k0 = "Reisemål", $0 = "", w0 = "", x0 = "alle typer boligbytter", C0 = "Badekar", S0 = "Grill", z0 = "Sykkel", A0 = "Bil", P0 = "Katt", M0 = "By", D0 = "Landlig", N0 = "Oppvaskmaskin", O0 = "Hund", I0 = "Tørketrommel", j0 = "Heis", L0 = "Favoritthjem", E0 = "Peis", B0 = "Leilighet", T0 = "", R0 = "mindre enn {{max}} GP", F0 = "fra {{min}} GP", V0 = "Mellom {{min}} og {{max}} GP", G0 = "Privat treningsrom", U0 = "Hus", Z0 = "Øy", W0 = "Isolert", K0 = "Jacuzzi", q0 = "Innsjøer", H0 = "Collection-hjem", J0 = "Fjell", Y0 = "", Q0 = "Andre dyr", X0 = "Piano", eP = "", tP = "Primær", aP = "Gjensidig boligbytte", oP = "Omvendt søk", nP = "Elv", rP = "", iP = "Sekundær", lP = "TV", sP = "Landsbygd", cP = "WiFi", uP = "Filtrer", dP = "Nøyaktige datoer", _P = "", gP = "", fP = "", bP = "", hP = "Fleksible datoer", mP = "Gjester", pP = "", yP = "Siste øyeblikk", vP = "Beliggenhet", kP = "", $P = "", wP = "", xP = "", CP = "", SP = "", zP = "", AP = "", PP = "", MP = "", DP = "", NP = "", OP = "", IP = "", jP = "", LP = "", EP = "", BP = "Lagre", TP = "", RP = "Se mer", FP = "Reiseplaner", VP = "", GP = "", UP = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: XA,
  bedroomsNumbers_one: e0,
  bedroomsNumbers_other: t0,
  beds_zero: a0,
  beds_one: o0,
  beds_other: n0,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: r0,
  global_babies: i0,
  global_calendarUpdated_toast: l0,
  global_calendar_aMonth: s0,
  global_calendar_exactDates: c0,
  global_calendar_oneWeek: u0,
  global_calendar_oneWeekend: d0,
  global_calendar_plusMinusDay_zero: _0,
  global_calendar_plusMinusDay_one: g0,
  global_calendar_plusMinusDay_other: f0,
  global_calendar_twoWeeks: b0,
  global_cancel: h0,
  global_children: m0,
  global_dates: p0,
  global_delete: y0,
  global_description: v0,
  global_destination: k0,
  global_done: $0,
  global_edit: w0,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: x0,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: C0,
  global_filter_bbq: S0,
  global_filter_bicycle: z0,
  global_filter_car: A0,
  global_filter_cat: P0,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: M0,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: D0,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: N0,
  global_filter_dog: O0,
  global_filter_dryer: I0,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: j0,
  global_filter_favorite: L0,
  global_filter_fireplace: E0,
  global_filter_flat: B0,
  global_filter_garden: T0,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: R0,
  global_filter_guestPointsMin: F0,
  global_filter_guestPointsMinMax: V0,
  global_filter_gym: G0,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: U0,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: Z0,
  global_filter_isolated: W0,
  global_filter_jacuzzi: K0,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: q0,
  global_filter_luxury: H0,
  global_filter_mountains: J0,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: Y0,
  global_filter_other: Q0,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: X0,
  global_filter_playground: eP,
  global_filter_primary: tP,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: aP,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: oP,
  global_filter_river: nP,
  global_filter_seaside: rP,
  global_filter_secondary: iP,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: lP,
  global_filter_villages: sP,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: cP,
  global_filters: uP,
  global_fixDates: dP,
  global_flexDates_aMonth: _P,
  global_flexDates_aWeekend: gP,
  global_flexDates_oneWeek: fP,
  global_flexDates_twoWeek: bP,
  global_flexibleDates: hP,
  global_guests: mP,
  global_homes: pP,
  global_lastMinute: yP,
  global_location: vP,
  global_modify: kP,
  global_name: $P,
  global_next: wP,
  global_numberOfAdults_zero: xP,
  global_numberOfAdults_one: CP,
  global_numberOfAdults_other: SP,
  global_numberOfBabies_zero: zP,
  global_numberOfBabies_one: AP,
  global_numberOfBabies_other: PP,
  global_numberOfChildren_zero: MP,
  global_numberOfChildren_one: DP,
  global_numberOfChildren_other: NP,
  global_numberOfGuests_zero: OP,
  global_numberOfGuests_one: IP,
  global_numberOfGuests_other: jP,
  global_phoneNumber_notValid: LP,
  global_receiveEmailAlerts: EP,
  global_save: BP,
  global_searchBar_noLocationFound: TP,
  global_seeMore_link: RP,
  global_travelWishlist: FP,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: VP,
  optional: GP,
  "privacy-policy": "Personvernpolicy"
}, ZP = "", WP = "", KP = "", qP = "Etter at du har forhåndsgodkjent dette boligbyttet må din boligbyttepartner ferdigstille det. De har {nbDays} dager på seg til å ferdigstille boligbyttet (frem til {date}). Om ikke vil forhåndsgodkjenningen din utløpe, og du må forhåndsgodkjenne boligbyttet på nytt.", HP = "", JP = "Dobbelbooking (via en annen plattform)", YP = "Famileproblemer", QP = "Helseproblemer", XP = "Skade på boligen", eM = "Flytting", tM = "Du må angi årsakene til avbestillingen.", aM = "Annet", oM = "Transportproblemer", nM = "Tillitsbrudd", rM = "Arbeidsrelatert", iM = "Du må oppgi en grunn", lM = {
  "cancellation-page.cancel-exchange": "Kanseller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsett kansellering",
  "cancellation-page.keep-exchange": "Behold boligbyttet",
  "cancellation-page.reason_step.checboxes_label": "Velg hovedårsaken for din kansellering:",
  "cancellation-page.reason_step.comment_placeholder": "Oppgi årsaken for din kansellering her",
  "cancellation-page.reason_step.error": "Du må oppgi en grunn",
  "cancellation-page.reason_step.title": "Hvorfor ønsker du å kansellere?",
  "cancellation-page.warning-step.first-warning": "Husk at det å kansellere boligbyttet kan ha en negativ innvirkning på din boligbyttepartner, som kanskje allerede har lagt reiseplaner!",
  "cancellation-page.warning-step.second-warning": "Viktig: Dersom du kansellerer et boligbytte som vert uten gyldig grunn kan din konto bli sperret. Som gjest kan konsekvensen være at du ikke får refundert alle dine GuestPoints.",
  page_cancellation_guest_calloutBody: ZP,
  page_cancellation_host_calloutBody: WP,
  page_cancellation_reciprocal_calloutBody: KP,
  pre_approval_modal_expiration_description: qP,
  reasons_for_cancellation_asked_by_exchange_partner: HP,
  reasons_for_cancellation_double_booking_rental: JP,
  reasons_for_cancellation_family_issues: YP,
  reasons_for_cancellation_health_issues: QP,
  reasons_for_cancellation_home_damage: XP,
  reasons_for_cancellation_moving: eM,
  reasons_for_cancellation_needed: tM,
  reasons_for_cancellation_other: aM,
  reasons_for_cancellation_transportation_issues: oM,
  reasons_for_cancellation_trust_issues: nM,
  reasons_for_cancellation_work_related: rM,
  reasons_other_comment_needed: iM
}, sM = "Studio", cM = "{{count}} slaapkamer", uM = "{{count}} slaapkamers", dM = "", _M = "{{count}} bed", gM = "{{count}} bedden", fM = "Volwassenen", bM = "Baby's", hM = "Je kalender is bijgewerkt.", mM = "Een maand", pM = "Exacte data", yM = "Een week", vM = "Een weekend", kM = "", $M = "± {{count}} dag", wM = "± {{count}} dagen", xM = "Twee weken", CM = "Annuleren", SM = "Kinderen", zM = "Data", AM = "Verwijderen", PM = "Beschrijving", MM = "Bestemming", DM = "Klaar!", NM = "Bewerken", OM = "Elk type ruil", IM = "Bad", jM = "BBQ", LM = "Fiets", EM = "Auto", BM = "Kat", TM = "De stad", RM = "Het platteland", FM = "Vaatwasmachine", VM = "Hond", GM = "Droger", UM = "Lift", ZM = "Favoriete huizen", WM = "Open haard", KM = "Appartement", qM = "Privétuin", HM = "Minder dan {{max}} GP", JM = "vanaf {{min}} GP", YM = "Tussen {{min}} en {{max}} GP", QM = "Privésportzaal", XM = "Huis", eD = "Een eiland", tD = "Geïsoleerd", aD = "Jacuzzi", oD = "Een meer", nD = "Collection-huizen", rD = "De bergen", iD = "{{count}} badkamers", lD = "Andere dieren", sD = "", cD = "Speeltuin", uD = "Eerste", dD = "Wederzijdse huizenruil", _D = "Omgekeerd zoeken", gD = "Rivier", fD = "Kust", bD = "Vakantiehuis", hD = "TV", mD = "Dorp", pD = "WiFi", yD = "Filters", vD = "Vaste data", kD = "Een maand in {{date}}", $D = "Een weekend in {{date}}", wD = "Een week in {{date}}", xD = "Twee weken in {{date}}", CD = "Flexibele data", SD = "Gasten", zD = "huizen", AD = "Last minute", PD = "Locatie", MD = "Wijzigen", DD = "Naam", ND = "Volgende", OD = "", ID = "{{count}} volwassene", jD = "{{count}} volwassenen", LD = "", ED = "{{count}} baby", BD = "{{count}} baby's", TD = "", RD = "{{count}} kind", FD = "{{count}} kinderen", VD = "", GD = "{{count}} gast", UD = "{{count}} gasten", ZD = "De indeling van het telefoonnummer is niet geldig.", WD = "E-mailmeldingen ontvangen", KD = "Opslaan", qD = "Geen locaties gevonden", HD = "Bekijk meer", JD = "Reisplannen", YD = "Geen resultaat", QD = "optioneel", XD = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: sM,
  bedroomsNumbers_one: cM,
  bedroomsNumbers_other: uM,
  beds_zero: dM,
  beds_one: _M,
  beds_other: gM,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: fM,
  global_babies: bM,
  global_calendarUpdated_toast: hM,
  global_calendar_aMonth: mM,
  global_calendar_exactDates: pM,
  global_calendar_oneWeek: yM,
  global_calendar_oneWeekend: vM,
  global_calendar_plusMinusDay_zero: kM,
  global_calendar_plusMinusDay_one: $M,
  global_calendar_plusMinusDay_other: wM,
  global_calendar_twoWeeks: xM,
  global_cancel: CM,
  global_children: SM,
  global_dates: zM,
  global_delete: AM,
  global_description: PM,
  global_destination: MM,
  global_done: DM,
  global_edit: NM,
  "global_filter_a-c": "Airco",
  global_filter_available: OM,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: IM,
  global_filter_bbq: jM,
  global_filter_bicycle: LM,
  global_filter_car: EM,
  global_filter_cat: BM,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: TM,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: RM,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijke woning",
  global_filter_dishwasher: FM,
  global_filter_dog: VM,
  global_filter_dryer: GM,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: UM,
  global_filter_favorite: ZM,
  global_filter_fireplace: WM,
  global_filter_flat: KM,
  global_filter_garden: qM,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: HM,
  global_filter_guestPointsMin: JM,
  global_filter_guestPointsMinMax: YM,
  global_filter_gym: QM,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: XM,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: eD,
  global_filter_isolated: tD,
  global_filter_jacuzzi: aD,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: oD,
  global_filter_luxury: nD,
  global_filter_mountains: rD,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: iD,
  global_filter_other: lD,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: sD,
  global_filter_playground: cD,
  global_filter_primary: uD,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: dD,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: _D,
  global_filter_river: gD,
  global_filter_seaside: fD,
  global_filter_secondary: bD,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: hD,
  global_filter_villages: mD,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: pD,
  global_filters: yD,
  global_fixDates: vD,
  global_flexDates_aMonth: kD,
  global_flexDates_aWeekend: $D,
  global_flexDates_oneWeek: wD,
  global_flexDates_twoWeek: xD,
  global_flexibleDates: CD,
  global_guests: SD,
  global_homes: zD,
  global_lastMinute: AD,
  global_location: PD,
  global_modify: MD,
  global_name: DD,
  global_next: ND,
  global_numberOfAdults_zero: OD,
  global_numberOfAdults_one: ID,
  global_numberOfAdults_other: jD,
  global_numberOfBabies_zero: LD,
  global_numberOfBabies_one: ED,
  global_numberOfBabies_other: BD,
  global_numberOfChildren_zero: TD,
  global_numberOfChildren_one: RD,
  global_numberOfChildren_other: FD,
  global_numberOfGuests_zero: VD,
  global_numberOfGuests_one: GD,
  global_numberOfGuests_other: UD,
  global_phoneNumber_notValid: ZD,
  global_receiveEmailAlerts: WD,
  global_save: KD,
  global_searchBar_noLocationFound: qD,
  global_seeMore_link: HD,
  global_travelWishlist: JD,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: YD,
  optional: QD,
  "privacy-policy": "Privacy"
}, eN = "Je gastheer/-vrouw heeft de keuze om de GuestPoints te houden of terug te geven.", tN = "Ongerechtvaardigde of herhaalde annuleringen kunnen ertoe leiden dat je account wordt opgeschort.", aN = "Ongerechtvaardigde of herhaalde annuleringen kunnen ertoe leiden dat je account wordt opgeschort. Als er GuestPoints bij betrokken waren, heeft je uitwisselingspartner de keuze om deze te houden of terug te geven.", oN = "Nadat je de uitwisseling hebt goedgekeurd, moet je uitwisselingspartner deze bevestigen. Hij of zij heeft {nbDays} dagen de tijd om dit te doen (tot {date}). Anders vervalt je voorlopige goedkeuring en moet je de uitwisseling opnieuw goedkeuren.", nN = "Mijn uitwisselingspartner heeft me gevraagd de uitwisseling te annuleren", rN = "Dubbele boeking (via een ander platform)", iN = "Familiale redenen", lN = "Gezondheidsproblemen", sN = "Schade aan het huis", cN = "Verhuis", uN = "Je moet de redenen voor je annulering aangeven.", dN = "Andere", _N = "Problemen met het transport", gN = "Vertrouwenskwestie", fN = "Werkgerelateerde redenen", bN = "Je moet een reden opgeven", hN = {
  "cancellation-page.cancel-exchange": "Annuleer de uitwisseling",
  "cancellation-page.continue-cancellation": "Doorgaan met annuleren",
  "cancellation-page.keep-exchange": "Mijn uitwisseling behouden",
  "cancellation-page.reason_step.checboxes_label": "Selecteer de hoofdreden voor je annulering:",
  "cancellation-page.reason_step.comment_placeholder": "Schrijf hier de reden van de annulering.",
  "cancellation-page.reason_step.error": "Je moet een reden opgeven",
  "cancellation-page.reason_step.title": "Waarom moet je annuleren?",
  "cancellation-page.warning-step.first-warning": "HomeExchange is gebaseerd op vertrouwen en betrouwbaarheid. Vergeet niet dat annuleren gevolgen kan hebben voor je uitwisselingspartner.",
  "cancellation-page.warning-step.second-warning": "Belangrijk: Als je als gastheer/-vrouw te vaak onterecht annuleert, kan je account offline worden gehaald. En als gast kan het zijn dat je niet al je GuestPoints terugkrijgt.",
  page_cancellation_guest_calloutBody: eN,
  page_cancellation_host_calloutBody: tN,
  page_cancellation_reciprocal_calloutBody: aN,
  pre_approval_modal_expiration_description: oN,
  reasons_for_cancellation_asked_by_exchange_partner: nN,
  reasons_for_cancellation_double_booking_rental: rN,
  reasons_for_cancellation_family_issues: iN,
  reasons_for_cancellation_health_issues: lN,
  reasons_for_cancellation_home_damage: sN,
  reasons_for_cancellation_moving: cN,
  reasons_for_cancellation_needed: uN,
  reasons_for_cancellation_other: dN,
  reasons_for_cancellation_transportation_issues: _N,
  reasons_for_cancellation_trust_issues: gN,
  reasons_for_cancellation_work_related: fN,
  reasons_other_comment_needed: bN
}, mN = "Studio", pN = "{{count}} quarto", yN = "{{count}} quartos", vN = "", kN = "{{count}} cama", $N = "{{count}} camas", wN = "", xN = "", CN = "O seu calendário foi atualizado.", SN = "Um mês", zN = "Datas exatas", AN = "Uma semana", PN = "Um fim de semana", MN = "", DN = "± {{count}} dia", NN = "± {{count]] dias", ON = "Duas semanas", IN = "Cancelar", jN = "", LN = "Datas", EN = "Eliminar", BN = "Descrição", TN = "Destino", RN = "Feito!", FN = "Editar", VN = "Qualquer tipo de pedido de Troca", GN = "Banheiro", UN = "BBQ", ZN = "Bicicleta", WN = "Carro", KN = "Gato", qN = "Cidade", HN = "Campo", JN = "Lavadora de louças", YN = "Cão", QN = "Secadora", XN = "Elevador", eO = "Casas favoritas", tO = "Lareira", aO = "Apartamento", oO = "Quintal privado", nO = "", rO = "", iO = "", lO = "", sO = "Casa", cO = "Ilha", uO = "Isolada", dO = "Jacuzzi", _O = "Lagos", gO = "Casas Collection", fO = "", bO = "{{count}} casas de banho", hO = "Outros animais", mO = "Piano", pO = "Parque infantil", yO = "Principal", vO = "Troca Reciproca", kO = "Busca invertida", $O = "Rio", wO = "Litoral", xO = "Secundária", CO = "TV", SO = "Aldeia", zO = "WiFi", AO = "Filtros", PO = "Datas fixas", MO = "Um mês em {{date}}", DO = "Um fim de semana em {{date}}", NO = "Uma semana em {{date}}", OO = "Duas semanas em {{date}}", IO = "Datas flexíveis", jO = "Convidados", LO = "casas", EO = "Última hora", BO = "Localização", TO = "Modificar", RO = "Nome", FO = "Seguinte", VO = "", GO = "{{count}} adulto", UO = "{{count}} adultos", ZO = "", WO = "{{count}} bebé", KO = "{{count}} bebés", qO = "", HO = "{{count}} criança", JO = "{{count}} crianças", YO = "", QO = "{{count}} convidado", XO = "{{count}} convidados", eI = "O formato do número de telefone não é válido.", tI = "Receber alertas por e-mail", aI = "Guardar", oI = "Não foram encontradas localizações", nI = "Ver mais", rI = "Ideias de viagens", iI = "", lI = "", sI = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: mN,
  bedroomsNumbers_one: pN,
  bedroomsNumbers_other: yN,
  beds_zero: vN,
  beds_one: kN,
  beds_other: $N,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: wN,
  global_babies: xN,
  global_calendarUpdated_toast: CN,
  global_calendar_aMonth: SN,
  global_calendar_exactDates: zN,
  global_calendar_oneWeek: AN,
  global_calendar_oneWeekend: PN,
  global_calendar_plusMinusDay_zero: MN,
  global_calendar_plusMinusDay_one: DN,
  global_calendar_plusMinusDay_other: NN,
  global_calendar_twoWeeks: ON,
  global_cancel: IN,
  global_children: jN,
  global_dates: LN,
  global_delete: EN,
  global_description: BN,
  global_destination: TN,
  global_done: RN,
  global_edit: FN,
  "global_filter_a-c": "A/C",
  global_filter_available: VN,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: GN,
  global_filter_bbq: UN,
  global_filter_bicycle: ZN,
  global_filter_car: WN,
  global_filter_cat: KN,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: qN,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: HN,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: JN,
  global_filter_dog: YN,
  global_filter_dryer: QN,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: XN,
  global_filter_favorite: eO,
  global_filter_fireplace: tO,
  global_filter_flat: aO,
  global_filter_garden: oO,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: nO,
  global_filter_guestPointsMin: rO,
  global_filter_guestPointsMinMax: iO,
  global_filter_gym: lO,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: sO,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: cO,
  global_filter_isolated: uO,
  global_filter_jacuzzi: dO,
  "global_filter_kids-toys": "",
  global_filter_lakes: _O,
  global_filter_luxury: gO,
  global_filter_mountains: fO,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: bO,
  global_filter_other: hO,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: mO,
  global_filter_playground: pO,
  global_filter_primary: yO,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: vO,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: kO,
  global_filter_river: $O,
  global_filter_seaside: wO,
  global_filter_secondary: xO,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: CO,
  global_filter_villages: SO,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: zO,
  global_filters: AO,
  global_fixDates: PO,
  global_flexDates_aMonth: MO,
  global_flexDates_aWeekend: DO,
  global_flexDates_oneWeek: NO,
  global_flexDates_twoWeek: OO,
  global_flexibleDates: IO,
  global_guests: jO,
  global_homes: LO,
  global_lastMinute: EO,
  global_location: BO,
  global_modify: TO,
  global_name: RO,
  global_next: FO,
  global_numberOfAdults_zero: VO,
  global_numberOfAdults_one: GO,
  global_numberOfAdults_other: UO,
  global_numberOfBabies_zero: ZO,
  global_numberOfBabies_one: WO,
  global_numberOfBabies_other: KO,
  global_numberOfChildren_zero: qO,
  global_numberOfChildren_one: HO,
  global_numberOfChildren_other: JO,
  global_numberOfGuests_zero: YO,
  global_numberOfGuests_one: QO,
  global_numberOfGuests_other: XO,
  global_phoneNumber_notValid: eI,
  global_receiveEmailAlerts: tI,
  global_save: aI,
  global_searchBar_noLocationFound: oI,
  global_seeMore_link: nI,
  global_travelWishlist: rI,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: iI,
  optional: lI,
  "privacy-policy": "Privacidade"
}, cI = "", uI = "", dI = "", _I = "Após pré-aprovar esta troca, o seu parceiro de troca terá de a finalizar e terá {nbDays} dias para o fazer (até {date}). Caso contrário, a sua pré-aprovação irá expirar e terá de voltar a pré-aprovar a troca.", gI = "", fI = "Reserva dupla (outra plataforma)", bI = "Motivos familiares", hI = "Motivos de saúde", mI = "Danos na propriedade", pI = "Mudanças", yI = "Você precisa indicar os motivos do cancelamento.", vI = "Outro", kI = "Problemas de transporte", $I = "Problemas de confiança", wI = "Motivos laborais", xI = "É obrigatório introduzir um motivo", CI = {
  "cancellation-page.cancel-exchange": "Cancelar a troca",
  "cancellation-page.continue-cancellation": "Continuar com o cancelamento",
  "cancellation-page.keep-exchange": "Manter a minha troca",
  "cancellation-page.reason_step.checboxes_label": "Selecione o motivo principal para o cancelamento:",
  "cancellation-page.reason_step.comment_placeholder": "Escreva aqui o motivo do cancelamento",
  "cancellation-page.reason_step.error": "É obrigatório introduzir um motivo",
  "cancellation-page.reason_step.title": "Por que motivo precisa de cancelar?",
  "cancellation-page.warning-step.first-warning": "Lembre-se que cancelar a sua troca pode ter um impacto negativo para o seu parceiro de troca, que pode já ter feito planos de viagem!",
  "cancellation-page.warning-step.second-warning": "Importante: Caso tenha demasiados cancelamentos injustificados como anfitrião, a sua conta poderá ser colocada offline. Caso isto aconteça enquanto convidado, poderá não receber todos os seus GuestPoints de volta.",
  page_cancellation_guest_calloutBody: cI,
  page_cancellation_host_calloutBody: uI,
  page_cancellation_reciprocal_calloutBody: dI,
  pre_approval_modal_expiration_description: _I,
  reasons_for_cancellation_asked_by_exchange_partner: gI,
  reasons_for_cancellation_double_booking_rental: fI,
  reasons_for_cancellation_family_issues: bI,
  reasons_for_cancellation_health_issues: hI,
  reasons_for_cancellation_home_damage: mI,
  reasons_for_cancellation_moving: pI,
  reasons_for_cancellation_needed: yI,
  reasons_for_cancellation_other: vI,
  reasons_for_cancellation_transportation_issues: kI,
  reasons_for_cancellation_trust_issues: $I,
  reasons_for_cancellation_work_related: wI,
  reasons_other_comment_needed: xI
}, SI = "Studio", zI = "{{count}} sovrum", AI = "{{count}} sovrum", PI = "", MI = "{{count}} säng", DI = "{{count}} sängar", NI = "Vuxna", OI = "Småbarn", II = "Din kalender har uppdaterats.", jI = "En månad", LI = "Exakta datum", EI = "En vecka", BI = "En helg", TI = "", RI = "± {{count}} dag", FI = "± {{count}} dagar", VI = "Två veckor", GI = "Avbryt", UI = "Barn", ZI = "Datum", WI = "Ta bort", KI = "Beskrivning", qI = "Resmål", HI = "Klart!", JI = "Ändra", YI = "Alla typer av hembyten", QI = "Badkar", XI = "Grill", ej = "Cykel", tj = "Bil", aj = "Katt", oj = "Stad", nj = "Landsbygd", rj = "Diskmaskin", ij = "Hund", lj = "Torktumlare", sj = "Hiss", cj = "Favorithem", uj = "Eldstad", dj = "Lägenhet", _j = "Privat trädgård", gj = "Mindre än {{max}} GP", fj = "från {{min}} GP", bj = "Mellan {{min}} och {{max}} GuestPoints", hj = "Hemmagym", mj = "Hus", pj = "Ö", yj = "Isolerat", vj = "Jacuzzi", kj = "Sjö", $j = "Collection-hem", wj = "Berg", xj = "{{count}} badrum", Cj = "Andra djur", Sj = "Piano", zj = "Lekplats för barn", Aj = "Primärt", Pj = "Ömsesidigt hembyte", Mj = "Omvänd sökning", Dj = "Älv", Nj = "Kustnära", Oj = "Sekundärt", Ij = "TV", jj = "By", Lj = "WiFi", Ej = "Filter", Bj = "Fasta datum", Tj = "En månad i {{date}}", Rj = "En helg i {{date}}", Fj = "En vecka i {{date}}", Vj = "Två veckor i {{date}}", Gj = "Flexibla datum", Uj = "Gäster", Zj = "hem", Wj = "Sista minuten", Kj = "Plats", qj = "Ändra", Hj = "Namn", Jj = "Nästa", Yj = "", Qj = "{{count}} vuxen", Xj = "{{count}} vuxna", eL = "", tL = "{{count}} bebis", aL = "{{count}} bebisar", oL = "", nL = "{{count}} barn", rL = "{{count}} barn", iL = "", lL = "{{count}} gäst", sL = "{{count}} gäster", cL = "Telefonnumrets format är inte giltigt.", uL = "Få e-postaviseringar", dL = "Spara", _L = "Inga resmål hittades", gL = "Se mer", fL = "Reselista", bL = "", hL = "valfritt", mL = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: SI,
  bedroomsNumbers_one: zI,
  bedroomsNumbers_other: AI,
  beds_zero: PI,
  beds_one: MI,
  beds_other: DI,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: NI,
  global_babies: OI,
  global_calendarUpdated_toast: II,
  global_calendar_aMonth: jI,
  global_calendar_exactDates: LI,
  global_calendar_oneWeek: EI,
  global_calendar_oneWeekend: BI,
  global_calendar_plusMinusDay_zero: TI,
  global_calendar_plusMinusDay_one: RI,
  global_calendar_plusMinusDay_other: FI,
  global_calendar_twoWeeks: VI,
  global_cancel: GI,
  global_children: UI,
  global_dates: ZI,
  global_delete: WI,
  global_description: KI,
  global_destination: qI,
  global_done: HI,
  global_edit: JI,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: YI,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: QI,
  global_filter_bbq: XI,
  global_filter_bicycle: ej,
  global_filter_car: tj,
  global_filter_cat: aj,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: oj,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: nj,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: rj,
  global_filter_dog: ij,
  global_filter_dryer: lj,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: sj,
  global_filter_favorite: cj,
  global_filter_fireplace: uj,
  global_filter_flat: dj,
  global_filter_garden: _j,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: gj,
  global_filter_guestPointsMin: fj,
  global_filter_guestPointsMinMax: bj,
  global_filter_gym: hj,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: mj,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: pj,
  global_filter_isolated: yj,
  global_filter_jacuzzi: vj,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: kj,
  global_filter_luxury: $j,
  global_filter_mountains: wj,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: xj,
  global_filter_other: Cj,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: Sj,
  global_filter_playground: zj,
  global_filter_primary: Aj,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: Pj,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: Mj,
  global_filter_river: Dj,
  global_filter_seaside: Nj,
  global_filter_secondary: Oj,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Ij,
  global_filter_villages: jj,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: Lj,
  global_filters: Ej,
  global_fixDates: Bj,
  global_flexDates_aMonth: Tj,
  global_flexDates_aWeekend: Rj,
  global_flexDates_oneWeek: Fj,
  global_flexDates_twoWeek: Vj,
  global_flexibleDates: Gj,
  global_guests: Uj,
  global_homes: Zj,
  global_lastMinute: Wj,
  global_location: Kj,
  global_modify: qj,
  global_name: Hj,
  global_next: Jj,
  global_numberOfAdults_zero: Yj,
  global_numberOfAdults_one: Qj,
  global_numberOfAdults_other: Xj,
  global_numberOfBabies_zero: eL,
  global_numberOfBabies_one: tL,
  global_numberOfBabies_other: aL,
  global_numberOfChildren_zero: oL,
  global_numberOfChildren_one: nL,
  global_numberOfChildren_other: rL,
  global_numberOfGuests_zero: iL,
  global_numberOfGuests_one: lL,
  global_numberOfGuests_other: sL,
  global_phoneNumber_notValid: cL,
  global_receiveEmailAlerts: uL,
  global_save: dL,
  global_searchBar_noLocationFound: _L,
  global_seeMore_link: gL,
  global_travelWishlist: fL,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: bL,
  optional: hL,
  "privacy-policy": "Sekretesspolicy"
}, pL = "Din värd kan själv välja att behålla eller återlämna GuestPoints om hen vill.", yL = "Obefogade eller upprepade avbokningar kan leda till att ditt konto stängs av.", vL = "Obefogade eller upprepade avbokningar kan leda till att ditt konto stängs av. Om GuestPoints har använts kommer din hembytespartner att ha valet att behålla eller återlämna dem.", kL = "Efter att du har förgodkänt det här hembytet behöver din hembytespartner bekräfta det. Hen har {nbDays} dagar på sig att bekräfta det (till {date}). Annars kommer ditt förgodkännande att löpa ut och du behöver förgodkänna hembytet igen.", $L = "Min hembytespartner bad mig att avbryta hembytet", wL = "Dubbelbokning (via en annan plattform)", xL = "Familjeproblem", CL = "Hälsoproblem", SL = "Skada i hemmet", zL = "Flytt", AL = "Du måste ange orsaken till din avbokning.", PL = "Annat", ML = "Transportproblem", DL = "Bristande förtroende", NL = "Arbetsrelaterat", OL = "Du behöver ange en anledning", IL = {
  "cancellation-page.cancel-exchange": "Avboka hembytet",
  "cancellation-page.continue-cancellation": "Fortsätt avbokning",
  "cancellation-page.keep-exchange": "Behåll mitt hembyte",
  "cancellation-page.reason_step.checboxes_label": "Välj huvudorsaken till din avbokning:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv skälet till din avbokning här",
  "cancellation-page.reason_step.error": "Du behöver ange en orsak",
  "cancellation-page.reason_step.title": "Varför behöver du avboka?",
  "cancellation-page.warning-step.first-warning": "HomeExchange bygger på förtroende och pålitlighet. Tänk på att en avbokning kan påverka din hembytespartner.",
  "cancellation-page.warning-step.second-warning": "Viktigt: Vid överdrivna och omotiverade avbokningar som värd kan ditt konto tas offline. Och som gäst kanske inte alla dina GuestPoints återlämnas till dig.",
  page_cancellation_guest_calloutBody: pL,
  page_cancellation_host_calloutBody: yL,
  page_cancellation_reciprocal_calloutBody: vL,
  pre_approval_modal_expiration_description: kL,
  reasons_for_cancellation_asked_by_exchange_partner: $L,
  reasons_for_cancellation_double_booking_rental: wL,
  reasons_for_cancellation_family_issues: xL,
  reasons_for_cancellation_health_issues: CL,
  reasons_for_cancellation_home_damage: SL,
  reasons_for_cancellation_moving: zL,
  reasons_for_cancellation_needed: AL,
  reasons_for_cancellation_other: PL,
  reasons_for_cancellation_transportation_issues: ML,
  reasons_for_cancellation_trust_issues: DL,
  reasons_for_cancellation_work_related: NL,
  reasons_other_comment_needed: OL
}, jL = "en", Rr = Lf({
  fallbackLng: jL,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      common: Ah,
      conversations: Zh
    },
    de: {
      common: Ep,
      conversations: ey
    },
    en: {
      conversations: ck,
      common: Wv
    },
    es: {
      conversations: pw,
      common: tw
    },
    fr: {
      conversations: zC,
      common: uC
    },
    hr: {
      conversations: G1,
      common: S1
    },
    it: {
      conversations: QA,
      common: jA
    },
    nb: {
      conversations: lM,
      common: UP
    },
    nl: {
      conversations: hN,
      common: XD
    },
    pt: {
      conversations: CI,
      common: sI
    },
    sv: {
      conversations: IL,
      common: mL
    }
  }
});
Rr.init();
const bn = Rr, LL = (e, t) => {
  Lr("exchange_status", e, t);
}, WL = (e, t) => {
  const a = {
    weekday: "long",
    month: "long",
    day: "numeric"
  };
  return pn(new Date(e), t).toLocaleDateString(document.body.dataset.locale, a);
}, KL = (e, t, a) => {
  const o = pn(new Date(t), a);
  return new Date(e) > o;
}, Da = "warning_step", Fr = "reason_step", EL = {
  [Da]: df,
  [Fr]: cf
};
function BL({
  cancellationReasons: e,
  conversation: t,
  user: a
}) {
  const [o, n] = xe(Da), r = EL[o], { url: i } = Ua(`/conversations/${t.id}`);
  return Ie(() => {
    const l = bf({
      isHeCollection: a.is_he_collection,
      subscriptionEndOn: a?.subscription?.end_on
    });
    gf(a.id, l, a.is_he_collection);
  }, [a]), /* @__PURE__ */ p(Lc, { color: "primary", isFullHeight: !0, centerContent: !0, children: /* @__PURE__ */ p(Mc, { children: /* @__PURE__ */ p(
    r,
    {
      cancellationReasons: e,
      conversation: t,
      user: a,
      onClickContinue: () => {
        o === Da ? (ff("exchange_cancellation", "exchange_cancellation_reason_selection", {
          collection: a.is_he_collection
        }), window.scrollTo(0, 0), n(Fr)) : window.location.assign(i);
      }
    }
  ) }) });
}
function qL({ cancellationReasons: e, conversation: t, locale: a, user: o, config: n }) {
  return bn.changeLanguage(a), ei(n.apiUrl), /* @__PURE__ */ p(Wc, { locale: a, children: /* @__PURE__ */ p(Ii, { i18n: bn, children: /* @__PURE__ */ p(rf, { config: n, children: /* @__PURE__ */ p(
    BL,
    {
      cancellationReasons: e,
      conversation: t,
      user: o
    }
  ) }) }) });
}
const HL = "WITH-GP", JL = "RECIPROCAL", YL = "RECIPROCAL-WITH-GP", QL = "NEW", XL = "ACCEPTED", eE = "EXPIRED", tE = "MANUALLY_DECLINED", aE = "AUTOMATICALLY_DECLINED", oE = "PAST_DATES_DECLINE";
export {
  qL as CancellationPage,
  cf as ReasonStep,
  XL as STAY_REQUEST_STATUS_ACCEPTED,
  aE as STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED,
  eE as STAY_REQUEST_STATUS_EXPIRED,
  tE as STAY_REQUEST_STATUS_MANUALLY_DECLINED,
  QL as STAY_REQUEST_STATUS_NEW,
  oE as STAY_REQUEST_STATUS_PAST_DATES_DECLINE,
  JL as STAY_TYPE_RECIPROCAL,
  YL as STAY_TYPE_RECIPROCAL_WITH_GP,
  HL as STAY_TYPE_WITH_GP,
  ZL as TransportationBanner,
  df as WarningStep,
  Xr as cancel,
  iE as cancelPreApprobation,
  lE as changeStayRequestToNonReciprocal,
  sE as changeStayRequestToReciprocal,
  cE as createStayRequest,
  uE as createStayRequestV3,
  dE as getCancellationInformations,
  _E as getExchangeConfig,
  WL as getExpirationDate,
  gE as getLastSentStayRequestMessage,
  fE as getStayRequest,
  bE as getV1StayRequest,
  hE as heFetch,
  bn as i18nConfig,
  mE as isCancellationPossible,
  KL as isStartDateAfterExpirationDate,
  pE as manualDecline,
  yE as preapproveExchange,
  ei as setConversationsFetchConfig,
  LL as trackExchangeStatus,
  vE as updateStayRequestDates
};
